import _Object$entries from '@babel/runtime-corejs3/core-js-stable/object/entries';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _findInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/find';
import Vue from 'vue';
import { ValidationObserver, ValidationProvider, setInteractionMode, extend } from 'vee-validate';
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import _findIndexInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/find-index';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/map';
import _includesInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/includes';
import _sliceInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/slice';
import _repeatInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/repeat';
import _JSON$stringify from '@babel/runtime-corejs3/core-js-stable/json/stringify';
import _startsWithInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/starts-with';
import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$values from '@babel/runtime-corejs3/core-js-stable/object/values';
import _padEndInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/pad-end';
import _spliceInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/splice';
import draggable from 'vuedraggable';
import _orderBy from 'lodash/orderBy';
import { buildNumUri, resolvePath } from 'num-client';
import _endsWithInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/ends-with';
import _debounce from 'lodash/debounce';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import moment from 'moment';
import { confirmed, email, required } from 'vee-validate/dist/rules.umd.js';

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$U = {
  name: "Button",
  props: {
    disabled: Boolean,
    href: String,
    to: Object,
    type: {
      default: "button",
      type: String,

      validator(value) {
        // The value must match one of these strings
        return ["button", "submit"].indexOf(value) !== -1;
      }

    },
    value: {
      type: String,
      default: "submit"
    },
    variant: String
  },

  data() {
    return {
      defaultSlotProvided: false
    };
  },

  computed: {
    buttonClass() {
      return {
        "is-disabled": this.disabled,
        "is-small": this.variant === "small"
      };
    }

  },

  created() {
    this.handleSlots();
  },

  beforeUpdate() {
    this.handleSlots();
  },

  methods: {
    handleSlots() {
      var _this$$slots$default;

      // can't use a computed property here.
      // src: https://stackoverflow.com/a/61484374/827129
      this.defaultSlotProvided = !!((_this$$slots$default = this.$slots.default) !== null && _this$$slots$default !== void 0 && _this$$slots$default[0]);
    }

  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

/* script */
const __vue_script__$U = script$U;
/* template */

var __vue_render__$Z = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.type === 'submit' && !_vm.defaultSlotProvided ? _c('input', {
    staticClass: "button",
    class: _vm.buttonClass,
    attrs: {
      "type": "submit",
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.value
    }
  }) : _vm.to ? _c('router-link', {
    staticClass: "button",
    class: _vm.buttonClass,
    attrs: {
      "to": _vm.to,
      "tag": "button",
      "disabled": _vm.disabled
    }
  }, [_vm._t("default")], 2) : _vm.href ? _c('a', {
    staticClass: "button",
    class: _vm.buttonClass,
    attrs: {
      "href": _vm.href,
      "disabled": _vm.disabled
    }
  }, [_vm._t("default")], 2) : _c('button', {
    staticClass: "button",
    class: _vm.buttonClass,
    attrs: {
      "type": _vm.type
    }
  }, [_vm._t("default")], 2);
};

var __vue_staticRenderFns__$Z = [];
/* style */

const __vue_inject_styles__$_ = undefined;
/* scoped */

const __vue_scope_id__$_ = "data-v-2d00729d";
/* module identifier */

const __vue_module_identifier__$_ = undefined;
/* functional template */

const __vue_is_functional_template__$_ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$_ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$Z,
  staticRenderFns: __vue_staticRenderFns__$Z
}, __vue_inject_styles__$_, __vue_script__$U, __vue_scope_id__$_, __vue_is_functional_template__$_, __vue_module_identifier__$_, false, undefined, undefined, undefined);

var script$T = {
  name: "SeparatedList",
  props: {
    spacing: {
      type: String,

      validator(value) {
        return ["large"].indexOf(value) !== -1;
      }

    }
  },
  computed: {
    dynamicClass() {
      return this.spacing && `spacing-${this.spacing}`;
    }

  }
};

/* script */
const __vue_script__$T = script$T;
/* template */

var __vue_render__$Y = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "separated-list",
    class: _vm.dynamicClass
  }, [_vm._t("default")], 2);
};

var __vue_staticRenderFns__$Y = [];
/* style */

const __vue_inject_styles__$Z = undefined;
/* scoped */

const __vue_scope_id__$Z = "data-v-e7762924";
/* module identifier */

const __vue_module_identifier__$Z = undefined;
/* functional template */

const __vue_is_functional_template__$Z = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$Z = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$Y,
  staticRenderFns: __vue_staticRenderFns__$Y
}, __vue_inject_styles__$Z, __vue_script__$T, __vue_scope_id__$Z, __vue_is_functional_template__$Z, __vue_module_identifier__$Z, false, undefined, undefined, undefined);

//
var script$S = {
  name: "Card",
  components: {
    SeparatedList: __vue_component__$Z
  },
  props: {
    disabled: Boolean,
    event: String,
    href: String,
    innerClass: String,
    mainClass: String,
    outer: Boolean,
    size: {
      type: String,

      validator(value) {
        return ["spacious", "tight"].indexOf(value) !== -1;
      }

    },
    target: String,
    to: [Object, String],
    variant: {
      type: String,

      validator(value) {
        return ["dark", "warning"].indexOf(value) !== -1;
      }

    }
  },

  data() {
    return {
      showActions: false,
      showFooter: false
    };
  },

  computed: {
    dynamicClasses() {
      let classes = [];
      this.outer && classes.push("card--outer");
      this.size && classes.push(`card--${this.size}`);
      this.variant && classes.push(`card--${this.variant}`);
      return classes;
    },

    el() {
      if (this.to) return "router-link";else if (this.href) return "a";
      return "div";
    }

  },

  beforeUpdate() {
    this.setShowSlots();
  },

  created() {
    this.setShowSlots();
  },

  methods: {
    setShowSlots() {
      var _this$$slots$actions, _this$$slots$footer;

      // this.$slots isn't reactive, so we have to use `beforeUpdate` and
      // `created` to manually watch for changes to this.
      // more info: https://stackoverflow.com/a/61484374/827129
      this.showActions = (_this$$slots$actions = this.$slots.actions) === null || _this$$slots$actions === void 0 ? void 0 : _this$$slots$actions[0];
      this.showFooter = (_this$$slots$footer = this.$slots.footer) === null || _this$$slots$footer === void 0 ? void 0 : _this$$slots$footer[0];
    }

  }
};

/* script */
const __vue_script__$S = script$S;
/* template */

var __vue_render__$X = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c(_vm.el, {
    tag: "component",
    staticClass: "card no-underline last:mb-0",
    class: _vm.dynamicClasses,
    attrs: {
      "disabled": _vm.disabled,
      "event": _vm.event,
      "href": _vm.href,
      "target": _vm.target,
      "to": _vm.to
    }
  }, [_c('div', {
    staticClass: "card__inner",
    class: _vm.innerClass
  }, [_c('div', {
    staticClass: "card__main last:mb-0",
    class: _vm.mainClass
  }, [_vm._t("default")], 2), _vm._v(" "), _vm.showActions ? _c('SeparatedList', {
    staticClass: "card__actions"
  }, [_vm._t("actions")], 2) : _vm._e()], 1), _vm._v(" "), _vm.showFooter ? _c('div', {
    staticClass: "card__footer"
  }, [_vm._t("footer")], 2) : _vm._e()]);
};

var __vue_staticRenderFns__$X = [];
/* style */

const __vue_inject_styles__$Y = undefined;
/* scoped */

const __vue_scope_id__$Y = "data-v-6081e70c";
/* module identifier */

const __vue_module_identifier__$Y = undefined;
/* functional template */

const __vue_is_functional_template__$Y = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$Y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$X,
  staticRenderFns: __vue_staticRenderFns__$X
}, __vue_inject_styles__$Y, __vue_script__$S, __vue_scope_id__$Y, __vue_is_functional_template__$Y, __vue_module_identifier__$Y, false, undefined, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
var script$R = {
  name: "Error",
  props: {
    dark: Boolean,
    errors: Array
  }
};

/* script */
const __vue_script__$R = script$R;
/* template */

var __vue_render__$W = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return !_vm.errors || _vm.errors.length ? _c('div', {
    staticClass: "is-error sentence-case",
    class: {
      'text-red-400': _vm.dark
    }
  }, [_vm.errors ? [_vm._v(_vm._s(_vm.errors[0]))] : _vm._t("default")], 2) : _vm._e();
};

var __vue_staticRenderFns__$W = [];
/* style */

const __vue_inject_styles__$X = undefined;
/* scoped */

const __vue_scope_id__$X = undefined;
/* module identifier */

const __vue_module_identifier__$X = undefined;
/* functional template */

const __vue_is_functional_template__$X = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$X = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$W,
  staticRenderFns: __vue_staticRenderFns__$W
}, __vue_inject_styles__$X, __vue_script__$R, __vue_scope_id__$X, __vue_is_functional_template__$X, __vue_module_identifier__$X, false, undefined, undefined, undefined);

//
var script$Q = {
  name: "Checkbox",
  components: {
    FormError: __vue_component__$X
  },
  props: {
    id: {
      type: String,
      required: true
    },
    inputClass: String,
    label: String,
    rules: [Object, String],
    useLabelForError: {
      default: true,
      type: Boolean
    },
    value: Boolean,
    variant: String
  },
  computed: {
    dynamicClass() {
      return this.variant === "inline" && "is-inline";
    }

  },
  watch: {
    value(newVal) {
      this.validateCheckbox(newVal);
    }

  },
  methods: {
    handleInput(event) {
      this.$emit("input", event.target.checked);
    },

    validateCheckbox(checked) {
      // src: https://logaretm.github.io/vee-validate/advanced/model-less-validation.html#value-synchronization
      this.$refs.provider.syncValue(checked); // src: https://logaretm.github.io/vee-validate/advanced/model-less-validation.html#html-file-validation

      this.$refs.provider.validate();
    }

  }
};

/* script */
const __vue_script__$Q = script$Q;
/* template */

var __vue_render__$V = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('ValidationProvider', {
    ref: "provider",
    staticClass: "checkbox-wrapper",
    attrs: {
      "rules": _vm.rules,
      "name": _vm.useLabelForError ? _vm.label : 'This field',
      "tag": "div"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (ref) {
        var errors = ref.errors;
        return [_c('div', {
          staticClass: "checkbox",
          class: _vm.dynamicClass
        }, [_vm.label ? _c('label', {
          staticClass: "checkbox__label",
          attrs: {
            "for": _vm.id
          },
          domProps: {
            "innerHTML": _vm._s(_vm.label)
          }
        }) : _vm._e(), _vm._v(" "), _c('input', {
          class: _vm.inputClass,
          attrs: {
            "id": _vm.id,
            "type": "checkbox"
          },
          domProps: {
            "checked": _vm.value
          },
          on: {
            "input": _vm.handleInput
          }
        })]), _vm._v(" "), _c('FormError', {
          staticClass: "qa-checkbox-error",
          attrs: {
            "errors": errors
          }
        })];
      }
    }])
  });
};

var __vue_staticRenderFns__$V = [];
/* style */

const __vue_inject_styles__$W = undefined;
/* scoped */

const __vue_scope_id__$W = "data-v-02eb4692";
/* module identifier */

const __vue_module_identifier__$W = undefined;
/* functional template */

const __vue_is_functional_template__$W = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$W = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$V,
  staticRenderFns: __vue_staticRenderFns__$V
}, __vue_inject_styles__$W, __vue_script__$Q, __vue_scope_id__$W, __vue_is_functional_template__$W, __vue_module_identifier__$W, false, undefined, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
var script$P = {
  name: "ToggleArrow",
  props: {
    isOpen: Boolean
  },
  methods: {
    toggle() {
      this.$emit("toggled");
    }

  }
};

/* script */
const __vue_script__$P = script$P;
/* template */

var __vue_render__$U = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('a', {
    staticClass: "toggle-arrow",
    class: {
      'is-hidden': _vm.isOpen
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.toggle.apply(null, arguments);
      }
    }
  }, [_vm._t("default")], 2);
};

var __vue_staticRenderFns__$U = [];
/* style */

const __vue_inject_styles__$V = undefined;
/* scoped */

const __vue_scope_id__$V = "data-v-787baf49";
/* module identifier */

const __vue_module_identifier__$V = undefined;
/* functional template */

const __vue_is_functional_template__$V = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$V = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$U,
  staticRenderFns: __vue_staticRenderFns__$U
}, __vue_inject_styles__$V, __vue_script__$P, __vue_scope_id__$V, __vue_is_functional_template__$V, __vue_module_identifier__$V, false, undefined, undefined, undefined);

const errorCodePriority = ["NUM_RECORD_NOT_FOUND", "ERROR_CREATING_CONTEXT", "COMPACT_SCHEMA_ERROR", "LOCALE_FILE_NOT_FOUND", "UNPACKER_CONFIG_FILE_NOT_FOUND", "EXPANDED_SCHEMA_ERROR", "MODULE_CONFIG_FILE_NOT_FOUND", "TOO_MANY_REDIRECTS", "INTERNAL_ERROR", "SCHEMA_NOT_FOUND", "DOH_SERVICE_ERROR"];
const errorCodeMessages = {
  COMPACT_SCHEMA_ERROR: "One or more of the records are incorrectly formatted.",
  EXPANDED_SCHEMA_ERROR: "One or more of the records are incorrectly formatted.",
  DOH_SERVICE_ERROR: "There was a temporary problem with retrieving some records, please try again later.",
  ERROR_CREATING_CONTEXT: "There was an internal error when fetching some records.",
  INTERNAL_ERROR: "There was an internal error when fetching some records.",
  LOCALE_FILE_NOT_FOUND: "A problem with the module configuration prevented some records being returned.",
  MODULE_CONFIG_FILE_NOT_FOUND: "A problem with the module configuration prevented some records being returned.",
  UNPACKER_CONFIG_FILE_NOT_FOUND: "A problem with the module configuration prevented some records being returned.",
  SCHEMA_NOT_FOUND: "A problem with the module configuration prevented some records being returned.",
  TOO_MANY_REDIRECTS: "There's an issue with some records leading to too many redirects.",
  NUM_RECORD_NOT_FOUND: "One or more records could not be found."
};
var script$O = Vue.extend({
  components: {
    Card: __vue_component__$Y,
    ToggleArrow: __vue_component__$V
  },
  props: {
    errors: Array
  },

  data() {
    return {
      errorsToIgnore: [{
        moduleNumber: 3,
        error: "NUM_RECORD_NOT_FOUND"
      }],
      infoShown: false
    };
  },

  computed: {
    errorMessage() {
      return errorCodeMessages[this.mainErrorCode];
    },

    filteredErrors() {
      var _context;

      return _filterInstanceProperty(_context = this.errors).call(_context, error => !this.errorsToIgnore.some(errorIgnore => errorIgnore.moduleNumber === error.moduleNumber && errorIgnore.error === error.error));
    },

    mainErrorCode() {
      return _findInstanceProperty(errorCodePriority).call(errorCodePriority, errorCode => this.filteredErrors.some(e => e.error === errorCode));
    }

  }
});

/* script */
const __vue_script__$O = script$O;
/* template */

var __vue_render__$T = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.filteredErrors.length ? _c('Card', {
    staticClass: "mb-8 md:mb-12 bg-gray-200"
  }, [_c('p', {
    staticClass: "h4 text-gray-500"
  }, [_vm._v("\n    " + _vm._s(_vm.errorMessage) + "\n    "), _c('ToggleArrow', {
    attrs: {
      "is-open": _vm.infoShown
    },
    on: {
      "toggled": function ($event) {
        _vm.infoShown = !_vm.infoShown;
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.infoShown ? "Hide" : "More") + " info\n    ")])], 1), _vm._v(" "), _vm.infoShown ? _c('Card', {
    staticClass: "mb-8 md:mb-12 bg-gray-300 text-gray-600 last:mb-0"
  }, [_c('h4', {
    staticClass: "h5 text-gray-500"
  }, [_vm._v("\n      There\n      " + _vm._s(_vm.filteredErrors.length > 1 ? "were" : "was") + "\n      " + _vm._s(_vm.filteredErrors.length) + " issue"), _vm.filteredErrors.length !== 1 ? [_vm._v("s")] : _vm._e(), _vm._v(":\n    ")], 2), _vm._v(" "), _c('ul', {
    staticClass: "last:mb-0"
  }, _vm._l(_vm.filteredErrors, function (error, index) {
    return _c('li', {
      key: index,
      staticClass: "mb-2"
    }, [_c('code', [_vm._v(_vm._s(error.uri))]), _vm._v(" had error\n        "), _c('code', [_vm._v(_vm._s(error.error))])]);
  }), 0)]) : _vm._e()], 1) : _vm._e();
};

var __vue_staticRenderFns__$T = [];
/* style */

const __vue_inject_styles__$U = undefined;
/* scoped */

const __vue_scope_id__$U = undefined;
/* module identifier */

const __vue_module_identifier__$U = undefined;
/* functional template */

const __vue_is_functional_template__$U = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$U = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$T,
  staticRenderFns: __vue_staticRenderFns__$T
}, __vue_inject_styles__$U, __vue_script__$O, __vue_scope_id__$U, __vue_is_functional_template__$U, __vue_module_identifier__$U, false, undefined, undefined, undefined);

/* script */
/* template */

var __vue_render__$S = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "num-container"
  }, [_vm._t("default")], 2);
};

var __vue_staticRenderFns__$S = [];
/* style */

const __vue_inject_styles__$T = undefined;
/* scoped */

const __vue_scope_id__$T = undefined;
/* module identifier */

const __vue_module_identifier__$T = undefined;
/* functional template */

const __vue_is_functional_template__$T = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$T = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$S,
  staticRenderFns: __vue_staticRenderFns__$S
}, __vue_inject_styles__$T, {}, __vue_scope_id__$T, __vue_is_functional_template__$T, __vue_module_identifier__$T, false, undefined, undefined, undefined);

/* script */
/* template */

var __vue_render__$R = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('span', {
    staticClass: "clear-wrapper"
  }, [_c('ion-icon', {
    staticClass: "clear",
    attrs: {
      "name": "backspace-outline"
    }
  })], 1);
};

var __vue_staticRenderFns__$R = [];
/* style */

const __vue_inject_styles__$S = undefined;
/* scoped */

const __vue_scope_id__$S = "data-v-f082000a";
/* module identifier */

const __vue_module_identifier__$S = undefined;
/* functional template */

const __vue_is_functional_template__$S = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$S = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$R,
  staticRenderFns: __vue_staticRenderFns__$R
}, __vue_inject_styles__$S, {}, __vue_scope_id__$S, __vue_is_functional_template__$S, __vue_module_identifier__$S, false, undefined, undefined, undefined);

/* script */
/* template */

var __vue_render__$Q = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('span', {
    staticClass: "remove-wrapper"
  }, [_c('ion-icon', {
    staticClass: "icon--bold remove",
    attrs: {
      "name": "close-sharp",
      "title": "Remove Item",
      "aria-label": "Remove Item"
    }
  })], 1);
};

var __vue_staticRenderFns__$Q = [];
/* style */

const __vue_inject_styles__$R = undefined;
/* scoped */

const __vue_scope_id__$R = "data-v-0ee1be3c";
/* module identifier */

const __vue_module_identifier__$R = undefined;
/* functional template */

const __vue_is_functional_template__$R = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$R = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$Q,
  staticRenderFns: __vue_staticRenderFns__$Q
}, __vue_inject_styles__$R, {}, __vue_scope_id__$R, __vue_is_functional_template__$R, __vue_module_identifier__$R, false, undefined, undefined, undefined);

var script$N = {
  name: "SearchableSelect",
  components: {
    RemoveButton: __vue_component__$R
  },
  props: {
    customAllowed: {
      default: false,
      type: Boolean
    },
    // customPrefixOption: this can be provided to allow an option to be
    // inserted into the options list that when clicked inserts a prefix and
    // keeps focus on the input
    customPrefixOption: {
      type: Object,
      validator: obj => obj.description && typeof obj.description === "string" && obj.value && typeof obj.value === "string"
    },
    disabled: Boolean,
    filterOptions: {
      default: true,
      type: Boolean
    },
    id: {
      required: true,
      type: String
    },
    inputClass: String,
    label: String,
    noResultsMessage: {
      default: "No matching options found",
      type: String
    },
    // optionOutput: used as the output by default unless a slot is passed for
    // custom formatting, and is used to match the value typed against for
    // fuzzy searching
    optionOutput: Function,
    options: Array,
    placeholder: String,
    preserveInputOnBlur: Boolean,
    rules: [Object, String],
    showDropdownIcon: {
      default: true,
      type: Boolean
    },
    showLabel: {
      default: true,
      type: Boolean
    },
    value: String,
    valueKey: String,
    vid: String
  },

  data() {
    return {
      dropdownVisible: false,
      focussedOptionIndex: 0,
      input: null,
      showValueAsPlaceholder: false
    };
  },

  computed: {
    customInputOptionVisible() {
      var _this$options;

      const exactMatchOption = (_this$options = this.options) === null || _this$options === void 0 ? void 0 : _this$options.some(o => this.optionValue(o) === this.input);
      return this.customAllowed && !!this.input && !exactMatchOption;
    },

    customPrefixOptionVisible() {
      return this.customAllowed && !!this.customPrefixOption && !this.value;
    },

    dynamicPlaceholder() {
      return this.showValueAsPlaceholder && this.formattedValue ? this.formattedValue : this.placeholder;
    },

    filteredOptions() {
      var _this$options2;

      return this.filterOptions ? (_this$options2 = this.options) === null || _this$options2 === void 0 ? void 0 : _filterInstanceProperty(_this$options2).call(_this$options2, o => this.isVisible(o)) : this.options;
    },

    formattedValue() {
      return this.formatValue(this.value);
    },

    optionsIndexOffset() {
      return this.customInputOptionVisible || this.customPrefixOptionVisible ? 1 : 0;
    },

    selectedOption() {
      var _this$options3;

      return (_this$options3 = this.options) === null || _this$options3 === void 0 ? void 0 : _findInstanceProperty(_this$options3).call(_this$options3, o => this.optionValue(o) === this.value);
    }

  },
  watch: {
    input(newVal) {
      this.$emit("input-changed", newVal);
    },

    value: {
      handler(newVal) {
        if (newVal === this.input) return;
        this.parseValueToInput(newVal);
      },

      immediate: true
    }
  },
  methods: {
    blurInput() {
      this.$refs.input.blur();
    },

    emitClearValue() {
      this.$emit("input", "");
    },

    emitClearValueAndFocus() {
      this.emitClearValue();
      this.showValueAsPlaceholder = false;
      this.$refs.input.focus();
    },

    formatValue(value) {
      const formattedValue = this.customAllowed ? value : this.optionOutput(this.selectedOption);
      return formattedValue || value;
    },

    fuzzy(needle, hay) {
      if (!needle) return true; // based on: https://stackoverflow.com/a/15252131/827129

      let n = -1;
      hay = hay.toLowerCase();
      needle = needle.toLowerCase(); // split to require whole words to match together for more accuracy, not
      // letter by letter

      const needleWords = needle.split(" ");

      for (let l of [...needleWords]) {
        const wordExistsAfterPreviousMatch = ~(n = hay.indexOf(l, n + 1));
        if (!wordExistsAfterPreviousMatch) return false;
      }

      return true;
    },

    hideDropdown() {
      this.setDropdownVisible(false);
      this.blurInput();
    },

    isVisible(option) {
      return this.fuzzy(this.input, this.optionOutput(option));
    },

    onInputBlur() {
      // if custom allowed and we have user input, then emit this value
      //  changing now so it is saved on blur
      if (this.customAllowed && this.input) this.$emit("input", this.input); // else if custom isn't allowed, and the user hasn't selected a matching
      // option, then clear the input when they leave it's focus
      else if (!this.customAllowed && !this.selectedOption) {
          // but only if we haven't set to preserveInputOnBlur
          if (!this.preserveInputOnBlur) this.input = null;
        } else this.parseValueToInput(this.value);
      this.showValueAsPlaceholder = false;
      this.setDropdownVisible(false);
    },

    onInputEnterKeypress() {
      this.selectFocussedOption();
      this.$emit("enter-keypress");
    },

    onInputFocus() {
      this.setDropdownVisible(true);
      this.showValueAsPlaceholder = true; // if we want to preserveInputOnBlur, we also want to reshow that input on focus

      if (this.preserveInputOnBlur) return;
      this.input = null; // if there's a value, then when focussing on the input set the
      // `focussedOptionIndex` to match the `valueOptionIndex`, so that it
      // highlights the existing element. without this it had the
      // `focussedOptionIndex` as `0`, meaning it would set the value to the
      // first item when tabbing through this input

      if (this.value !== "") {
        var _this$filteredOptions;

        if ((_this$filteredOptions = this.filteredOptions) !== null && _this$filteredOptions !== void 0 && _this$filteredOptions.length) {
          var _context;

          const valueOptionIndex = _findIndexInstanceProperty(_context = this.filteredOptions).call(_context, o => o[this.valueKey] === this.value);

          this.focussedOptionIndex = valueOptionIndex;
        }
      } else {
        this.resetOptionFocus();
      }
    },

    optionClass(option, index) {
      return this.focussedOptionIndex === index + this.optionsIndexOffset ? "is-active" : null;
    },

    optionValue(option) {
      return this.valueKey ? option === null || option === void 0 ? void 0 : option[this.valueKey] : option;
    },

    parseUserInput(event) {
      event.target.value;
      const tabChar = 9;
      const keyDownChar = 38;
      const keyUpChar = 40;

      if (event.keyCode == tabChar) {
        // if the keyup event here is the tab character, then we want to do
        // nothing as this means the user has just tabbed into the input, they
        // haven't actually done any input we need to handle
        return;
      } else if (event.keyCode === keyDownChar) {
        this.shiftOptionFocus(-1);
      } else if (event.keyCode === keyUpChar) {
        this.shiftOptionFocus(1);
      } else {
        this.resetOptionFocus();
      }
    },

    parseValueToInput(value) {
      if (value === this.input) return;
      this.input = this.formatValue(value);
    },

    resetOptionFocus() {
      this.setOptionFocus(0);
    },

    selectCustomOption() {
      this.$emit("input", this.customPrefixOption.value);
    },

    selectFocussedOption() {
      var _this$filteredOptions2;

      if (((_this$filteredOptions2 = this.filteredOptions) === null || _this$filteredOptions2 === void 0 ? void 0 : _this$filteredOptions2.length) === 0) {
        // if there's no options, ignore the user input for now
        return;
      } else if (this.customInputOptionVisible && this.focussedOptionIndex === 0) {
        // do nothing, this custom value is already selected
        this.hideDropdown();
      } else if (this.customPrefixOptionVisible && this.focussedOptionIndex === 0) {
        this.$emit("input", this.customPrefixOption.value);
      } else {
        const optionIndex = this.focussedOptionIndex - this.optionsIndexOffset;
        const option = this.filteredOptions[optionIndex];
        this.$emit("input", this.optionValue(option));
        this.hideDropdown();
      }
    },

    selectOption(option) {
      this.$emit("input", this.optionValue(option));
      this.hideDropdown();
    },

    setDropdownVisible(visible) {
      this.dropdownVisible = visible;
    },

    setOptionFocus(index) {
      this.focussedOptionIndex = index;
    },

    shiftOptionFocus(shift) {
      var _this$filteredOptions3;

      const newIndex = this.focussedOptionIndex + shift;
      const optionsLength = ((_this$filteredOptions3 = this.filteredOptions) === null || _this$filteredOptions3 === void 0 ? void 0 : _this$filteredOptions3.length) + this.optionsIndexOffset - 1;
      if (newIndex === -1 || newIndex > optionsLength) return;
      this.setOptionFocus(newIndex);
    },

    toggleDropdown() {
      if (!this.dropdownVisible) this.$refs.input.focus();else this.blurInput();
    }

  }
};

/* script */
const __vue_script__$N = script$N;
/* template */

var __vue_render__$P = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "ss",
    class: {
      'is-disabled': _vm.disabled
    }
  }, [_vm.showLabel && _vm.label ? _c('label', {
    attrs: {
      "for": _vm.id
    }
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ss__input-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.input,
      expression: "input"
    }],
    ref: "input",
    staticClass: "ss__input",
    class: _vm.inputClass,
    attrs: {
      "id": _vm.id,
      "disabled": _vm.disabled,
      "placeholder": _vm.dynamicPlaceholder,
      "autocomplete": "off"
    },
    domProps: {
      "value": _vm.input
    },
    on: {
      "focus": _vm.onInputFocus,
      "blur": _vm.onInputBlur,
      "keypress": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }

        $event.preventDefault();
        return _vm.onInputEnterKeypress.apply(null, arguments);
      },
      "keydown": [function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")) {
          return null;
        }

        $event.stopPropagation();
        return _vm.selectFocussedOption.apply(null, arguments);
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) {
          return null;
        }

        return _vm.blurInput.apply(null, arguments);
      }],
      "keyup": _vm.parseUserInput,
      "paste": _vm.parseUserInput,
      "input": function ($event) {
        if ($event.target.composing) {
          return;
        }

        _vm.input = $event.target.value;
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ss__input-actions"
  }, [_vm.value ? _c('RemoveButton', {
    staticClass: "ss__input-clear",
    nativeOn: {
      "click": function ($event) {
        return function () {
          return !_vm.disabled && _vm.emitClearValueAndFocus();
        }.apply(null, arguments);
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm.showDropdownIcon ? _c('div', {
    staticClass: "ss__dropdown-icon",
    on: {
      "mousedown": function ($event) {
        $event.preventDefault();
      },
      "click": _vm.toggleDropdown
    }
  }, [_c('ion-icon', {
    staticClass: "icon--bold transition duration-300",
    class: {
      'transform rotate-180': _vm.dropdownVisible
    },
    attrs: {
      "name": "caret-down-sharp",
      "title": "Toggle dropdown",
      "aria-label": "Toggle dropdown"
    }
  })], 1) : _vm._e()], 1)]), _vm._v(" "), _vm.dropdownVisible ? _c('div', {
    staticClass: "ss__options"
  }, [_vm.customInputOptionVisible ? _c('div', {
    staticClass: "ss__option",
    class: {
      'is-active': _vm.focussedOptionIndex === 0
    },
    on: {
      "click": function ($event) {
        return _vm.hideDropdown();
      },
      "mousedown": function ($event) {
        $event.preventDefault();
      },
      "mouseover": function ($event) {
        return _vm.setOptionFocus(0);
      }
    }
  }, [_c('span', {
    staticClass: "opacity-50"
  }, [_vm._v("Custom input:")]), _vm._v(" " + _vm._s(_vm.input) + "\n    ")]) : !_vm.customInputOptionVisible && !(_vm.filteredOptions && _vm.filteredOptions.length) ? _c('div', {
    staticClass: "ss__option",
    class: {
      'is-active': _vm.focussedOptionIndex === 0
    },
    on: {
      "click": function ($event) {
        return _vm.hideDropdown();
      },
      "mousedown": function ($event) {
        $event.preventDefault();
      },
      "mouseover": function ($event) {
        return _vm.setOptionFocus(0);
      }
    }
  }, [_c('em', {
    staticClass: "opacity-50"
  }, [_vm._v(_vm._s(_vm.noResultsMessage))])]) : _vm.customPrefixOptionVisible ? _c('div', {
    staticClass: "ss__option",
    class: {
      'is-active': _vm.focussedOptionIndex === 0
    },
    on: {
      "click": _vm.selectCustomOption,
      "mousedown": function ($event) {
        $event.preventDefault();
      },
      "mouseover": function ($event) {
        return _vm.setOptionFocus(0);
      }
    }
  }, [_c('span', {
    staticClass: "opacity-50"
  }, [_vm._v(_vm._s(_vm.customPrefixOption.description))]), _vm._v(": " + _vm._s(_vm.customPrefixOption.value) + "\n    ")]) : _vm._e(), _vm._v(" "), _vm._l(_vm.filteredOptions, function (option, index) {
    return [_c('div', {
      key: _vm.optionValue(option),
      staticClass: "ss__option",
      class: _vm.optionClass(option, index),
      on: {
        "click": function ($event) {
          return _vm.selectOption(option);
        },
        "mouseover": function ($event) {
          return _vm.setOptionFocus(index + _vm.optionsIndexOffset);
        },
        "mousedown": function ($event) {
          $event.preventDefault();
        }
      }
    }, [_vm._t("default", function () {
      return [_c('span', {
        domProps: {
          "innerHTML": _vm._s(_vm.optionOutput(option))
        }
      })];
    }, {
      "option": option
    })], 2)];
  })], 2) : _vm._e()]);
};

var __vue_staticRenderFns__$P = [];
/* style */

const __vue_inject_styles__$Q = undefined;
/* scoped */

const __vue_scope_id__$Q = undefined;
/* module identifier */

const __vue_module_identifier__$Q = undefined;
/* functional template */

const __vue_is_functional_template__$Q = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$Q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$P,
  staticRenderFns: __vue_staticRenderFns__$P
}, __vue_inject_styles__$Q, __vue_script__$N, __vue_scope_id__$Q, __vue_is_functional_template__$Q, __vue_module_identifier__$Q, false, undefined, undefined, undefined);

//
const GET_DATA_COUNTRIES$1 = "GET_DATA_COUNTRIES";
var script$M = {
  name: "Country",
  components: {
    FormError: __vue_component__$X,
    SearchableSelect: __vue_component__$Q
  },
  props: {
    id: String,
    keyToUse: {
      default: "id",
      type: String
    },
    label: {
      default: "Country",
      type: String
    },
    rules: [Object, String],
    value: [Number, String]
  },

  data() {
    return {
      Deselect: __vue_component__$S,
      OpenIndicator: {
        render: createElement => createElement("span", "")
      }
    };
  },

  computed: { ...mapState({
      countries: state => state.base.data.countries
    })
  },

  created() {
    this.GET_DATA_COUNTRIES();
  },

  methods: { ...mapActions("base", [GET_DATA_COUNTRIES$1])
  }
};

/* script */
const __vue_script__$M = script$M;
/* template */

var __vue_render__$O = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('ValidationProvider', {
    staticClass: "mb-4",
    attrs: {
      "rules": _vm.rules,
      "name": "Country",
      "tag": "div",
      "mode": "eager"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (ref) {
        var errors = ref.errors;
        return [_c('label', {
          attrs: {
            "for": _vm.id
          }
        }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _vm.countries ? _c('SearchableSelect', {
          staticClass: "mb-0",
          attrs: {
            "id": _vm.id,
            "options": _vm.countries,
            "option-output": function (o) {
              return o && o.name;
            },
            "placeholder": "Select country",
            "value-key": _vm.keyToUse,
            "value": _vm.value
          },
          on: {
            "input": function (value) {
              return _vm.$emit('input', value);
            }
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (ref) {
              var option = ref.option;
              return [_c('div', {
                staticClass: "option"
              }, [_c('img', {
                staticClass: "option__icon",
                attrs: {
                  "src": "https://www.countryflags.io/" + option.code + "/flat/32.png",
                  "alt": "Country flag"
                }
              }), _vm._v("\n        " + _vm._s(option.name) + "\n      ")])];
            }
          }], null, true)
        }) : _vm._e(), _vm._v(" "), _c('FormError', {
          attrs: {
            "errors": errors
          }
        })];
      }
    }])
  });
};

var __vue_staticRenderFns__$O = [];
/* style */

const __vue_inject_styles__$P = undefined;
/* scoped */

const __vue_scope_id__$P = "data-v-2ad56b56";
/* module identifier */

const __vue_module_identifier__$P = undefined;
/* functional template */

const __vue_is_functional_template__$P = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$P = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$O,
  staticRenderFns: __vue_staticRenderFns__$O
}, __vue_inject_styles__$P, __vue_script__$M, __vue_scope_id__$P, __vue_is_functional_template__$P, __vue_module_identifier__$P, false, undefined, undefined, undefined);

const responseSuccessful = response => {
  if (response !== null && response !== void 0 && response.status) {
    return response.status >= 200 && response.status < 300;
  } else {
    return null;
  }
};

var response = /*#__PURE__*/Object.freeze({
  __proto__: null,
  responseSuccessful: responseSuccessful
});

//
var script$L = {
  name: "Form",
  components: {
    ValidationObserver
  },
  props: {
    onSubmit: Function,
    preventSubmit: {
      default: true,
      type: Boolean
    }
  },

  data() {
    return {
      formSubmitResponse: null,
      formSubmitting: false
    };
  },

  methods: {
    attemptSubmit(handleSubmit, validate) {
      if (this.preventSubmit) {
        handleSubmit(this.submitForm);
      } else {
        this.submitForm(); // wait 50ms as nextTick fires before data has fully passed down,
        // causing the errors to show before the inputs are updated. 50ms
        // is short enough that it looks to happen about the same time still.

        setTimeout(() => {
          validate();
        }, 50);
      }
    },

    async submitForm() {
      if (!this.formSubmitting) {
        this.formSubmitting = true;
        const response = await this.onSubmit();

        if (response !== null && response !== void 0 && response.status) {
          this.formSubmitResponse = responseSuccessful(response) ? "success" : "failure";
        }

        this.formSubmitting = false;
      }
    }

  }
};

/* script */
const __vue_script__$L = script$L;
/* template */

var __vue_render__$N = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('ValidationObserver', {
    attrs: {
      "slim": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (ref) {
        var errors = ref.errors;
        var handleSubmit = ref.handleSubmit;
        var reset = ref.reset;
        var validate = ref.validate;
        return [_c('form', {
          on: {
            "submit": function ($event) {
              $event.preventDefault();
              return _vm.attemptSubmit(handleSubmit, validate);
            }
          }
        }, [_vm._t("default", null, {
          "errors": errors,
          "formSubmitResponse": _vm.formSubmitResponse,
          "formSubmitting": _vm.formSubmitting,
          "reset": reset,
          "validate": validate
        })], 2)];
      }
    }], null, true)
  });
};

var __vue_staticRenderFns__$N = [];
/* style */

const __vue_inject_styles__$O = undefined;
/* scoped */

const __vue_scope_id__$O = undefined;
/* module identifier */

const __vue_module_identifier__$O = undefined;
/* functional template */

const __vue_is_functional_template__$O = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$O = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$N,
  staticRenderFns: __vue_staticRenderFns__$N
}, __vue_inject_styles__$O, __vue_script__$L, __vue_scope_id__$O, __vue_is_functional_template__$O, __vue_module_identifier__$O, false, undefined, undefined, undefined);

//
//
//
//
var script$K = {
  name: "Prefix",
  props: {
    prefix: String
  }
};

/* script */
const __vue_script__$K = script$K;
/* template */

var __vue_render__$M = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.prefix ? _c('span', {
    staticClass: "prefix",
    domProps: {
      "innerHTML": _vm._s(_vm.prefix)
    }
  }) : _vm._e();
};

var __vue_staticRenderFns__$M = [];
/* style */

const __vue_inject_styles__$N = undefined;
/* scoped */

const __vue_scope_id__$N = "data-v-8c6ff960";
/* module identifier */

const __vue_module_identifier__$N = undefined;
/* functional template */

const __vue_is_functional_template__$N = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$N = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$M,
  staticRenderFns: __vue_staticRenderFns__$M
}, __vue_inject_styles__$N, __vue_script__$K, __vue_scope_id__$N, __vue_is_functional_template__$N, __vue_module_identifier__$N, false, undefined, undefined, undefined);

//
var script$J = {
  name: "Input",
  components: {
    FormError: __vue_component__$X,
    Prefix: __vue_component__$N,
    ValidationProvider
  },
  props: {
    autocapitalize: String,
    autocomplete: String,
    autocorrect: String,
    autofocus: Boolean,
    disabled: Boolean,
    fakeInputClass: [Object, String],
    help: String,
    id: {
      type: String,
      required: true
    },
    inputClass: [Object, String],
    label: String,
    max: String,
    min: String,
    placeholder: String,
    prefix: String,
    rules: [Object, String],
    showErrors: {
      default: true,
      type: Boolean
    },
    showLabel: {
      default: true,
      type: Boolean
    },
    step: String,
    type: {
      default: "text",
      type: String
    },
    useLabelForErrors: {
      default: true,
      type: Boolean
    },
    value: [String, Number],
    vid: String
  },
  computed: {
    computedFakeInputClass() {
      let fakeInputClass = this.fakeInputClass;
      if (this.disabled) fakeInputClass += " is-disabled";
      return fakeInputClass;
    },

    formattedValue() {
      return this.type === "password" ? decodeURIComponent(this.value) : this.value;
    },

    providerName() {
      return this.useLabelForErrors && this.label ? this.label : "This field";
    },

    showDescription() {
      var _this$$slots$descript, _this$$slots$descript2, _this$$slots$descript3;

      return (_this$$slots$descript = this.$slots.description) === null || _this$$slots$descript === void 0 ? void 0 : (_this$$slots$descript2 = _this$$slots$descript[0]) === null || _this$$slots$descript2 === void 0 ? void 0 : (_this$$slots$descript3 = _this$$slots$descript2.text) === null || _this$$slots$descript3 === void 0 ? void 0 : _this$$slots$descript3.length;
    }

  },
  methods: {
    handleEmit(e) {
      const formattedValue = this.type === "password" ? encodeURIComponent(e.target.value) : e.target.value;
      this.$emit("input", formattedValue);
    },

    removeInput() {
      this.$emit("remove");
    }

  }
};

/* script */
const __vue_script__$J = script$J;
/* template */

var __vue_render__$L = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('ValidationProvider', {
    ref: "provider",
    staticClass: "flex flex-col fake-input__wrapper",
    attrs: {
      "rules": _vm.rules,
      "name": _vm.providerName,
      "tag": "div",
      "vid": _vm.vid
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (ref) {
        var errors = ref.errors;
        return [_vm.showLabel && _vm.label ? _c('label', {
          staticClass: "flex items-center justify-between",
          class: {
            'font-bold mb-0': _vm.showDescription
          },
          attrs: {
            "for": _vm.id
          }
        }, [_vm._v("\n    " + _vm._s(_vm.label) + "\n    "), _vm.help ? _c('span', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip",
            value: {
              content: _vm.help,
              hideOnTargetClick: false
            },
            expression: "{ content: help, hideOnTargetClick: false }"
          }]
        }, [_c('ion-icon', {
          attrs: {
            "name": "help-circle-outline"
          }
        })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm.showDescription ? _c('span', {
          staticClass: "text-sm opacity-75 italic mb-1"
        }, [_vm._t("description")], 2) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "fake-input",
          class: _vm.computedFakeInputClass
        }, [_c('Prefix', {
          attrs: {
            "prefix": _vm.prefix
          }
        }), _vm._v(" "), _c('input', {
          ref: "input",
          staticClass: "flex-1 fake-input__input",
          class: _vm.inputClass,
          attrs: {
            "disabled": _vm.disabled,
            "id": _vm.id,
            "placeholder": _vm.placeholder,
            "type": _vm.type,
            "autocorrect": _vm.autocorrect,
            "autocapitalize": _vm.autocapitalize,
            "autocomplete": _vm.autocomplete,
            "autofocus": _vm.autofocus,
            "min": _vm.min,
            "max": _vm.max,
            "step": _vm.step
          },
          domProps: {
            "value": _vm.formattedValue
          },
          on: {
            "input": _vm.handleEmit
          }
        })], 1), _vm._v(" "), _vm.showErrors && errors && errors.length ? _c('FormError', {
          staticClass: "qa-input-error",
          attrs: {
            "errors": errors
          }
        }) : _vm._e()];
      }
    }], null, true)
  });
};

var __vue_staticRenderFns__$L = [];
/* style */

const __vue_inject_styles__$M = undefined;
/* scoped */

const __vue_scope_id__$M = "data-v-36d8e281";
/* module identifier */

const __vue_module_identifier__$M = undefined;
/* functional template */

const __vue_is_functional_template__$M = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$M = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$L,
  staticRenderFns: __vue_staticRenderFns__$L
}, __vue_inject_styles__$M, __vue_script__$J, __vue_scope_id__$M, __vue_is_functional_template__$M, __vue_module_identifier__$M, false, undefined, undefined, undefined);

var script$I = Vue.extend({
  name: "DomainClaimForm",
  components: {
    Button: __vue_component__$_,
    Form: __vue_component__$O,
    FormError: __vue_component__$X,
    Input: __vue_component__$M,
    ValidationProvider
  },

  data() {
    return {
      input: ""
    };
  },

  methods: {
    submitForm() {
      window.open(`https://numserver.com/claim/${this.input}`, "_blank");
    }

  }
});

/* script */
const __vue_script__$I = script$I;
/* template */

var __vue_render__$K = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('Form', {
    staticClass: "mb-6 sm:mb-8",
    attrs: {
      "on-submit": _vm.submitForm
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (ref) {
        var errors = ref.errors;
        return [_c('ValidationProvider', {
          staticClass: "flex",
          attrs: {
            "name": "Company domain",
            "rules": "required",
            "vid": "claimDomainInput",
            "el": "div"
          }
        }, [_c('Input', {
          staticClass: "mb-0",
          attrs: {
            "input-class": "px-1",
            "id": "input",
            "label": "Company domain",
            "placeholder": "Company domain",
            "show-errors": false,
            "show-label": false,
            "rules": "required",
            "type": "input"
          },
          model: {
            value: _vm.input,
            callback: function ($$v) {
              _vm.input = $$v;
            },
            expression: "input"
          }
        }), _vm._v(" "), _c('Button', {
          staticClass: "mb-0",
          attrs: {
            "type": "submit",
            "variant": "small",
            "value": "Claim domain"
          }
        })], 1), _vm._v(" "), errors && errors['claimDomainInput'] && errors['claimDomainInput'].length ? _c('FormError', {
          staticClass: "mt-2",
          attrs: {
            "dark": true
          }
        }, [_vm._v("\n    " + _vm._s(errors["claimDomainInput"][0]) + "\n  ")]) : _vm._e()];
      }
    }])
  });
};

var __vue_staticRenderFns__$K = [];
/* style */

const __vue_inject_styles__$L = undefined;
/* scoped */

const __vue_scope_id__$L = undefined;
/* module identifier */

const __vue_module_identifier__$L = undefined;
/* functional template */

const __vue_is_functional_template__$L = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$L = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$K,
  staticRenderFns: __vue_staticRenderFns__$K
}, __vue_inject_styles__$L, __vue_script__$I, __vue_scope_id__$L, __vue_is_functional_template__$L, __vue_module_identifier__$L, false, undefined, undefined, undefined);

var script$H = {
  name: "DynamicString",
  props: {
    text: [Error, String]
  },
  computed: {
    transformed() {
      return {
        template: `<span>${this.text}</span>`
      };
    }

  },
  template: `<component v-bind:is="transformed" /></component>`
};

/* script */
const __vue_script__$H = script$H;
/* template */

/* style */

const __vue_inject_styles__$K = undefined;
/* scoped */

const __vue_scope_id__$K = undefined;
/* module identifier */

const __vue_module_identifier__$K = undefined;
/* functional template */

const __vue_is_functional_template__$K = undefined;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$K = /*#__PURE__*/normalizeComponent({}, __vue_inject_styles__$K, __vue_script__$H, __vue_scope_id__$K, __vue_is_functional_template__$K, __vue_module_identifier__$K, false, undefined, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$G = {
  name: "ProgressCircle",
  props: {
    radius: Number,
    stroke: Number
  },

  data() {
    const normalizedRadius = this.radius - this.stroke * 2;
    const circumference = normalizedRadius * 2 * Math.PI;
    return {
      circumference,
      normalizedRadius,
      showDefaultSlot: false
    };
  },

  computed: {
    strokeDashoffset() {
      return this.circumference;
    }

  },

  beforeUpdate() {
    this.setShowSlots();
  },

  created() {
    this.setShowSlots();
  },

  methods: {
    setShowSlots() {
      var _this$$slots$default;

      // this.$slots isn't reactive, so we have to use `beforeUpdate` and
      // `created` to manually watch for changes to this.
      // more info: https://stackoverflow.com/a/61484374/827129
      this.showDefaultSlot = (_this$$slots$default = this.$slots.default) === null || _this$$slots$default === void 0 ? void 0 : _this$$slots$default[0];
    }

  }
};

/* script */
const __vue_script__$G = script$G;
/* template */

var __vue_render__$J = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "progress-circle"
  }, [_c('svg', {
    attrs: {
      "height": _vm.radius * 2,
      "width": _vm.radius * 2
    }
  }, [_c('circle', {
    staticClass: "progress-circle__circle",
    style: {
      strokeDashoffset: _vm.strokeDashoffset
    },
    attrs: {
      "fill": "transparent",
      "stroke-dasharray": _vm.circumference + ' ' + _vm.circumference,
      "stroke-width": _vm.stroke,
      "r": _vm.normalizedRadius,
      "cx": _vm.radius,
      "cy": _vm.radius
    }
  })]), _vm._v(" "), _vm.showDefaultSlot ? _c('div', {
    staticClass: "progress-circle__slot-wrapper",
    style: {
      width: (_vm.radius - _vm.stroke) * 2 + "px",
      height: (_vm.radius - _vm.stroke) * 2 + "px"
    }
  }, [_c('div', {
    staticClass: "progress-circle__slot-wrapper-inner"
  }, [_vm._t("default")], 2)]) : _vm._e()]);
};

var __vue_staticRenderFns__$J = [];
/* style */

const __vue_inject_styles__$J = undefined;
/* scoped */

const __vue_scope_id__$J = undefined;
/* module identifier */

const __vue_module_identifier__$J = undefined;
/* functional template */

const __vue_is_functional_template__$J = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$J = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$J,
  staticRenderFns: __vue_staticRenderFns__$J
}, __vue_inject_styles__$J, __vue_script__$G, __vue_scope_id__$J, __vue_is_functional_template__$J, __vue_module_identifier__$J, false, undefined, undefined, undefined);

const HIDE_FLASH_MESSAGE = "HIDE_FLASH_MESSAGE";
const PUSH_FLASH_MESSAGE$4 = "PUSH_FLASH_MESSAGE";
var script$F = {
  name: "FlashMessage",
  components: {
    DynamicString: __vue_component__$K,
    ProgressCircle: __vue_component__$J
  },
  computed: { ...mapState("base", ["flashMessages"]),

    visibleFlashMessages() {
      var _context, _context2;

      return _filterInstanceProperty(_context = _mapInstanceProperty(_context2 = this.flashMessages).call(_context2, (flashMessage, unfilteredIndex) => ({
        flashMessage,
        unfilteredIndex
      }))).call(_context, message => !message.flashMessage.hidden);
    }

  },
  methods: { ...mapMutations("base", [HIDE_FLASH_MESSAGE, PUSH_FLASH_MESSAGE$4]),

    capturedClick(unfilteredIndex, event) {
      const childEventWasLinkClick = event.srcElement.nodeName === "A";
      if (childEventWasLinkClick) this.hideFlashMessage(unfilteredIndex);
    },

    hideFlashMessage(unfilteredIndex) {
      this.HIDE_FLASH_MESSAGE(unfilteredIndex);
    }

  }
};

/* script */
const __vue_script__$F = script$F;
/* template */

var __vue_render__$I = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.flashMessages ? _c('transition-group', {
    staticClass: "flash-messages",
    attrs: {
      "name": "transition-list",
      "tag": "ul"
    }
  }, _vm._l(_vm.visibleFlashMessages, function (ref) {
    var flashMessage = ref.flashMessage;
    var unfilteredIndex = ref.unfilteredIndex;
    return _c('li', {
      key: unfilteredIndex,
      staticClass: "flash-messages__message",
      class: flashMessage.type && "is-" + flashMessage.type,
      on: {
        "animationend": function ($event) {
          return _vm.hideFlashMessage(unfilteredIndex);
        }
      }
    }, [_c('DynamicString', {
      staticClass: "flash-messages__main",
      attrs: {
        "text": flashMessage.message
      },
      nativeOn: {
        "!click": function ($event) {
          return _vm.capturedClick(unfilteredIndex, $event);
        }
      }
    }), _vm._v(" "), _c('ProgressCircle', {
      staticClass: "mr-2",
      attrs: {
        "radius": 20,
        "stroke": 3
      },
      nativeOn: {
        "click": function ($event) {
          return _vm.hideFlashMessage(unfilteredIndex);
        }
      }
    }, [_vm._v("\n      ×\n    ")])], 1);
  }), 0) : _vm._e();
};

var __vue_staticRenderFns__$I = [];
/* style */

const __vue_inject_styles__$I = undefined;
/* scoped */

const __vue_scope_id__$I = "data-v-8d7f4c56";
/* module identifier */

const __vue_module_identifier__$I = undefined;
/* functional template */

const __vue_is_functional_template__$I = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$I = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$I,
  staticRenderFns: __vue_staticRenderFns__$I
}, __vue_inject_styles__$I, __vue_script__$F, __vue_scope_id__$I, __vue_is_functional_template__$I, __vue_module_identifier__$I, false, undefined, undefined, undefined);

var ModlLogo = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 400 364.315"}},[_c('path',{attrs:{"d":"M30.253 3.112c-37.781 90.111-40.394 244.193-5.931 349.846l3.569 10.942 30.453.218c16.749.12 30.453.018 30.453-.227 0-.244-1.293-4.823-2.872-10.176-30.114-102.047-30.906-236.524-1.979-336.288 2.316-7.987 4.398-15.176 4.628-15.975C88.965.089 87.228 0 60.274 0H31.558l-1.305 3.112M309.544.241c0 .145 1.315 4.164 2.923 8.932 31.829 94.393 33.242 238.369 3.364 342.902l-3.499 12.24h61.024l3.321-10.206c33.856-104.066 30.71-256.565-7.177-347.885L367.09.415 338.317.197c-15.826-.12-28.773-.1-28.773.044M82.28 65.768c-13.584 70.408-13.444 175.949.312 236.099l.427 1.867H145.408l-.482-1.921c-.265-1.057-1.426-7.671-2.579-14.699-10.678-65.066-10.397-150.642.708-215.53l1.883-11.003H83.281l-1.001 5.187m166.735 14.937a21378.369 21378.369 0 01-25.271 51.558l-15.458 31.433 14.322 27.678c7.877 15.223 14.532 27.686 14.79 27.696.379.014 76.356-153.883 77.732-157.452.315-.817-5.61-1.037-27.951-1.037h-28.351l-9.813 20.124m-97.387-9.284c-2.543 10.344-6.832 51.891-8.035 77.843l-.784 16.9 15.036 30.611 15.037 30.611h28.911c15.902 0 28.892-.28 28.867-.623-.219-2.982-78.609-157.062-79.032-155.342m140.281 56.954l-26.349 53.647-.008 9.196c-.025 29.804-4.467 78.863-9.535 105.328-.685 3.578-1.245 6.658-1.245 6.847 0 .188 13.973.341 31.051.341h31.052l.838-3.941c2.721-12.803 6.611-42.775 8.589-66.183 1.434-16.965 1.437-85.425.004-102.49-1.946-23.185-6.389-56.456-7.534-56.411-.283.011-12.372 24.161-26.863 53.666","fill":"currentColor","fill-rule":"evenodd"}})]) } };

var NumLogo = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"viewBox":"0 0 521 521","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M256.204 520.627c-84.882-3.353-169.922-43.705-217.489-115.597-49.602-76.675-48.745-179.222-10.877-260.543C60.607 76.795 124.033 24.107 198.325 9.115 262.892-3.917 332.91-4.115 394.42 21.82c66.35 30.694 120.148 95.155 125.023 169.85 5.585 59.002-7.41 123.648-51.887 165.798-35.334 33.82-81.045 61.52-130.99 63.693-29.043-1.333-26.59-39.369-27.75-60.565-1.88-52.12 6.898-103.921 6.615-155.92 3.647-25.359-26.4-47.897-41.8-19.124-39.41 48.573-56.854 110.942-68.474 171.382a433.182 433.182 0 00-5.896 53.584c-16.285-2.009-51.266 16.879-55.594-.364 4.702-78.426 8.734-156.99 8.545-235.568 3.227-23.517-23.031-21.571-34.396-18.197 1.26-7.616-3.776-19.733 7.677-20.063 24.485-4.924 57.047-24.805 78.832-5.77 9.55 25.146.758 53.195 1.522 79.406-.614 13.633-4.944 44.51 4.434 15.024 17.303-37.976 36.36-82.099 77.087-99.817 25.707-9.658 62.747-7.208 74.868 21.498 18.123 40.887 5.325 86.486 4.406 129.319-1.056 28.75-5.996 58.224-.26 86.625 22.016 5.7 43.734-14.07 59.33-28.343 56.526-59.718 59.588-162.069 7.229-225.294-43.208-52.557-115.508-69.09-180.697-62.448C164.976 52.043 80.8 113.08 59.582 199.83c-17.455 71.237-8.88 155.852 45.124 209.882 54.586 59.107 141.29 74.997 218.077 62.851 44.891-6.905 87.245-25.907 124.27-51.897 23.984-.09 47.976-.724 71.953-.17-64.978 72.933-167.288 103.76-262.802 100.13z","fill":"currentColor","fill-rule":"nonzero"}})]) } };

var NumServerLogo = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"viewBox":"0 0 659 659","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M574-1c46.944 0 85 38.056 85 85v490c0 46.944-38.056 85-85 85H84c-46.944 0-85-38.056-85-85V84C-1 37.056 37.056-1 84-1h490zM460.257 94.003c-60.295-25.515-128.927-25.32-192.217-12.5-72.821 14.75-134.993 66.582-167.113 133.176-37.119 80.003-37.959 180.887 10.662 256.318 46.626 70.726 129.983 110.423 213.186 113.722 93.623 3.57 193.91-26.757 257.601-98.508-23.503-.544-47.02.08-70.528.168-36.293 25.57-77.81 44.263-121.812 51.056-75.268 11.949-160.256-3.684-213.762-61.831-52.935-53.155-61.341-136.397-44.23-206.479 20.797-85.343 103.308-145.39 188.85-150.816 63.899-6.535 134.768 9.73 177.12 61.435 51.324 62.2 48.323 162.89-7.085 221.64-15.287 14.041-36.575 33.49-58.156 27.883-5.623-27.94-.78-56.936.255-85.22.901-42.139 13.446-86.998-4.32-127.222-11.88-28.24-48.187-30.65-73.385-21.149-39.922 17.43-58.602 60.838-75.562 98.198-9.192 29.007-4.948-1.368-4.347-14.78-.748-25.786 7.87-53.38-1.491-78.118-21.354-18.726-53.272.832-77.272 5.676-11.227.325-6.29 12.246-7.525 19.738 11.14-3.32 36.879-5.234 33.715 17.902.185 77.303-3.767 154.593-8.375 231.747 4.242 16.963 38.53-1.618 54.493.358a427.649 427.649 0 015.78-52.715c11.39-59.46 28.49-120.817 67.12-168.602 15.094-28.306 44.547-6.134 40.972 18.813.277 51.156-8.328 102.118-6.485 153.391 1.138 20.853-1.267 58.272 27.2 59.583 48.958-2.138 93.764-29.387 128.4-62.66 43.597-41.466 56.334-105.064 50.86-163.108-4.779-73.484-57.513-136.9-122.55-167.096z","fill":"currentColor","fill-rule":"evenodd"}})]) } };

var UnpackerLogo = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 400 533.919"}},[_c('path',{attrs:{"d":"M198.515 9.785c-1.583.319-2.636 1.069-5.928 4.218C120.652 82.809 77.939 124.789 76.162 128.43c-1.385 2.838-1.189 6.704.457 9.034 2.528 3.578.778 3.389 33.016 3.566 15.743.086 28.714.25 28.824.365.421.439.744 33.768 1.177 121.613.472 95.687.473 95.698 2.513 101.866 12.091 36.538 61.263 50.3 94.621 26.481 10.067-7.188 19.244-19.056 23.023-29.774l1.239-3.513.115-108.278.115-108.278 5.373-.258c2.956-.141 14.607-.273 25.893-.292 12.294-.02 20.974-.207 21.654-.465 4.74-1.802 7.055-6.909 5.073-11.189-1.281-2.766-18.688-20.92-86.304-90.011-10.872-11.108-21.548-22.037-23.725-24.286-5.206-5.379-6.598-6.058-10.711-5.226M27.493 176.319c-4.002 1.289-7.423 5.504-8.884 10.948-.579 2.153-.541 121.344.047 151.043 2 100.94 63.424 175.221 155.219 187.708 48.859 6.646 102.159-6.596 136.039-33.797 17.665-14.183 28.541-25.998 39.827-43.264 17.333-26.516 27.312-56.185 31.236-92.865 1.739-16.263 1.152-166.67-.67-171.307-1.472-3.748-3.597-6.248-6.535-7.691l-2.532-1.243-26.783.122c-32.777.149-32.81.156-36.796 7.479-2.463 4.525-2.383 1.476-1.975 76.043.524 95.54.461 97.093-4.747 115.478-13.121 46.317-48.65 71.56-100.719 71.56-59.283 0-96.837-32.719-104.815-91.319-.597-4.388-.708-15.398-.843-84.083-.105-53.912-.305-79.872-.628-81.669-1.099-6.117-5.137-11.401-9.694-12.686-3.69-1.04-53.686-1.443-56.747-.457","fill":"currentColor","fill-rule":"evenodd"}})]) } };

var script$E = Vue.extend({
  name: "GlobalFooter",
  components: {
    Container: __vue_component__$T,
    ModlLogo,
    NumLogo,
    NumServerLogo,
    UnpackerLogo
  },
  props: {
    site: String,
    stage: String
  },
  computed: {
    showCol2() {
      var _this$$slots$col;

      return (_this$$slots$col = this.$slots["col-2"]) === null || _this$$slots$col === void 0 ? void 0 : _this$$slots$col[0];
    },

    showCol3() {
      var _this$$slots$col2;

      return (_this$$slots$col2 = this.$slots["col-3"]) === null || _this$$slots$col2 === void 0 ? void 0 : _this$$slots$col2[0];
    },

    showTrademarksLink() {
      const showOnWebsites = ["num.uk", "numprotocol.com", "numserver.com"];
      return _includesInstanceProperty(showOnWebsites).call(showOnWebsites, this.site);
    },

    trademarksLink() {
      const path = "/ip/trademarks";
      if (this.stage === "local" || this.stage === "test") return `https://num.uk.test.numops.com${path}`;else if (this.stage === "staging") return `https://num.uk.staging.numops.com${path}`;else return `https://num.uk${path}`;
    }

  }
});

/* script */
const __vue_script__$E = script$E;
/* template */

var __vue_render__$H = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "global-footer"
  }, [_c('Container', [_c('div', {
    staticClass: "global-footer__inner"
  }, [_c('div', {
    staticClass: "global-footer__num-sites-col"
  }, [_c('h2', [_vm._v("NUM Technologies:")]), _vm._v(" "), _c('ul', {
    staticClass: "global-footer__num-sites"
  }, [_vm.site !== 'num.uk' ? _c('li', {
    staticClass: "global-footer__num-sites-item",
    class: {
      'is-site': _vm.site === 'num.uk'
    }
  }, [_c('a', {
    staticClass: "global-footer__num-sites-link",
    attrs: {
      "href": "https://num.uk"
    }
  }, [_c('NumLogo', {
    staticClass: "global-footer__num-sites-icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "global-footer__num-sites-text"
  }, [_vm._v("\n                NUM Technology\n              ")])], 1)]) : _vm._e(), _vm._v(" "), _vm.site !== 'numprotocol.com' ? _c('li', {
    staticClass: "global-footer__num-sites-item",
    class: {
      'is-site': _vm.site === 'numprotocol.com'
    }
  }, [_c('a', {
    staticClass: "global-footer__num-sites-link",
    attrs: {
      "href": "https://numprotocol.com"
    }
  }, [_c('NumLogo', {
    staticClass: "global-footer__num-sites-icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "global-footer__num-sites-text"
  }, [_vm._v("NUM Protocol")])], 1)]) : _vm._e(), _vm._v(" "), _vm.site !== 'numserver.com' ? _c('li', {
    staticClass: "global-footer__num-sites-item",
    class: {
      'is-site': _vm.site === 'numserver.com'
    }
  }, [_c('a', {
    staticClass: "global-footer__num-sites-link",
    attrs: {
      "href": "https://numserver.com"
    }
  }, [_c('NumServerLogo', {
    staticClass: "global-footer__num-sites-icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "global-footer__num-sites-text"
  }, [_vm._v("NUM Server")])], 1)]) : _vm._e(), _vm._v(" "), _vm.site !== 'modl.uk' ? _c('li', {
    staticClass: "global-footer__num-sites-item",
    class: {
      'is-site': _vm.site === 'modl.uk'
    }
  }, [_c('a', {
    staticClass: "global-footer__num-sites-link",
    attrs: {
      "href": "https://modl.uk"
    }
  }, [_c('ModlLogo', {
    staticClass: "global-footer__num-sites-icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "global-footer__num-sites-text"
  }, [_vm._v("MODL")])], 1)]) : _vm._e(), _vm._v(" "), _vm.site !== 'unpacker.uk' ? _c('li', {
    staticClass: "global-footer__num-sites-item",
    class: {
      'is-site': _vm.site === 'unpacker.uk'
    }
  }, [_c('a', {
    staticClass: "global-footer__num-sites-link",
    attrs: {
      "href": "https://unpacker.uk"
    }
  }, [_c('UnpackerLogo', {
    staticClass: "global-footer__num-sites-icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "global-footer__num-sites-text"
  }, [_vm._v("Unpacker")])], 1)]) : _vm._e()]), _vm._v(" "), _c('p', [_c('small', {
    staticClass: "global-footer__legal"
  }, [_vm._v("\n            © NUM Technology Ltd " + _vm._s(new Date().getFullYear()) + "\n          ")])]), _vm._v(" "), _vm.showTrademarksLink ? _c('p', [_c('small', {
    staticClass: "global-footer__legal"
  }, [_vm._v("\n            \"NUM\" and the n sign are\n            "), _c('a', {
    attrs: {
      "href": _vm.trademarksLink,
      "target": _vm.site === 'num.uk' ? '_self' : '_blank'
    }
  }, [_vm._v("registered trademarks")]), _vm._v("\n            of NUM Technology Ltd.\n          ")])]) : _vm._e()]), _vm._v(" "), _vm.showCol2 ? _c('div', {
    staticClass: "global-footer__slot"
  }, [_vm._t("col-2")], 2) : _vm._e(), _vm._v(" "), _vm.showCol3 ? _c('div', {
    staticClass: "global-footer__slot"
  }, [_vm._t("col-3")], 2) : _vm._e()])])], 1);
};

var __vue_staticRenderFns__$H = [];
/* style */

const __vue_inject_styles__$H = undefined;
/* scoped */

const __vue_scope_id__$H = undefined;
/* module identifier */

const __vue_module_identifier__$H = undefined;
/* functional template */

const __vue_is_functional_template__$H = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$H = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$H,
  staticRenderFns: __vue_staticRenderFns__$H
}, __vue_inject_styles__$H, __vue_script__$E, __vue_scope_id__$H, __vue_is_functional_template__$H, __vue_module_identifier__$H, false, undefined, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
var script$D = {
  name: "Hamburger",
  props: {
    isActive: Boolean
  }
};

/* script */
const __vue_script__$D = script$D;
/* template */

var __vue_render__$G = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('button', {
    staticClass: "hamburger",
    class: {
      'is-active': _vm.isActive
    }
  }, [_vm._m(0)]);
};

var __vue_staticRenderFns__$G = [function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "hamburger__inner"
  }, [_c('div', {
    staticClass: "hamburger__line"
  }), _vm._v(" "), _c('div', {
    staticClass: "hamburger__line"
  }), _vm._v(" "), _c('div', {
    staticClass: "hamburger__line"
  })]);
}];
/* style */

const __vue_inject_styles__$G = undefined;
/* scoped */

const __vue_scope_id__$G = "data-v-005a1d9e";
/* module identifier */

const __vue_module_identifier__$G = undefined;
/* functional template */

const __vue_is_functional_template__$G = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$G = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$G,
  staticRenderFns: __vue_staticRenderFns__$G
}, __vue_inject_styles__$G, __vue_script__$D, __vue_scope_id__$G, __vue_is_functional_template__$G, __vue_module_identifier__$G, false, undefined, undefined, undefined);

var script$C = Vue.extend({
  name: "GlobalNav",
  components: {
    Container: __vue_component__$T,
    Hamburger: __vue_component__$G,
    ModlLogo,
    NumLogo,
    NumServerLogo,
    UnpackerLogo
  },
  props: {
    site: String
  },

  data() {
    return {
      menuVisible: false
    };
  },

  computed: {
    hasMainLinks() {
      var _this$$slots, _this$$slots$mainLin;

      return !!((_this$$slots = this.$slots) !== null && _this$$slots !== void 0 && (_this$$slots$mainLin = _this$$slots["main-links"]) !== null && _this$$slots$mainLin !== void 0 && _this$$slots$mainLin[0]);
    }

  },
  methods: {
    clickedOutside() {
      this.menuVisible = false;
    },

    hideMenu() {
      this.menuVisible = false;
    },

    toggleMenu() {
      this.menuVisible = !this.menuVisible;
    }

  }
});

/* script */
const __vue_script__$C = script$C;
/* template */

var __vue_render__$F = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: _vm.clickedOutside,
      expression: "clickedOutside"
    }],
    staticClass: "global-nav",
    class: {
      'menu-visible': _vm.menuVisible
    }
  }, [_c('Container', {
    staticClass: "global-nav__container"
  }, [_c('div', {
    staticClass: "global-nav__header"
  }, [_c('a', {
    staticClass: "global-nav__logo",
    attrs: {
      "href": "/"
    }
  }, [_vm._t("logo")], 2), _vm._v(" "), _vm.hasMainLinks ? _c('Hamburger', {
    staticClass: "global-nav__hamburger",
    attrs: {
      "is-active": _vm.menuVisible
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.toggleMenu.apply(null, arguments);
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "global-nav__main"
  }, [_c('div', {
    staticClass: "global-nav__main-inner",
    on: {
      "click": _vm.hideMenu
    }
  }, [_vm._t("main-links")], 2)])])], 1);
};

var __vue_staticRenderFns__$F = [];
/* style */

const __vue_inject_styles__$F = undefined;
/* scoped */

const __vue_scope_id__$F = undefined;
/* module identifier */

const __vue_module_identifier__$F = undefined;
/* functional template */

const __vue_is_functional_template__$F = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$F = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$F,
  staticRenderFns: __vue_staticRenderFns__$F
}, __vue_inject_styles__$F, __vue_script__$C, __vue_scope_id__$F, __vue_is_functional_template__$F, __vue_module_identifier__$F, false, undefined, undefined, undefined);

/* script */

/* template */
var __vue_render__$E = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "global-nav-spacer"
  });
};

var __vue_staticRenderFns__$E = [];
/* style */

const __vue_inject_styles__$E = undefined;
/* scoped */

const __vue_scope_id__$E = undefined;
/* module identifier */

const __vue_module_identifier__$E = undefined;
/* functional template */

const __vue_is_functional_template__$E = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$E = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$E,
  staticRenderFns: __vue_staticRenderFns__$E
}, __vue_inject_styles__$E, {}, __vue_scope_id__$E, __vue_is_functional_template__$E, __vue_module_identifier__$E, false, undefined, undefined, undefined);

/* script */
/* template */

var __vue_render__$D = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "header-wrapper pb-2"
  }, [_vm._t("default")], 2);
};

var __vue_staticRenderFns__$D = [];
/* style */

const __vue_inject_styles__$D = undefined;
/* scoped */

const __vue_scope_id__$D = undefined;
/* module identifier */

const __vue_module_identifier__$D = undefined;
/* functional template */

const __vue_is_functional_template__$D = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$D = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$D,
  staticRenderFns: __vue_staticRenderFns__$D
}, __vue_inject_styles__$D, {}, __vue_scope_id__$D, __vue_is_functional_template__$D, __vue_module_identifier__$D, false, undefined, undefined, undefined);

var script$B = Vue.extend({
  components: {
    Container: __vue_component__$T,
    GlobalNavSpacer: __vue_component__$E
  }
});

/* script */
const __vue_script__$B = script$B;
/* template */

var __vue_render__$C = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "bg-blue-gradient-angle-bottom text-white"
  }, [_c('GlobalNavSpacer'), _vm._v(" "), _c('Container', [_c('div', {
    staticClass: "py-8 md:pt-12 md:pb-16 lg:pt-16 lg:pb-24 fs-4 last:mb-0"
  }, [_vm._t("default")], 2)])], 1);
};

var __vue_staticRenderFns__$C = [];
/* style */

const __vue_inject_styles__$C = undefined;
/* scoped */

const __vue_scope_id__$C = undefined;
/* module identifier */

const __vue_module_identifier__$C = undefined;
/* functional template */

const __vue_is_functional_template__$C = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$C = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$C,
  staticRenderFns: __vue_staticRenderFns__$C
}, __vue_inject_styles__$C, __vue_script__$B, __vue_scope_id__$C, __vue_is_functional_template__$C, __vue_module_identifier__$C, false, undefined, undefined, undefined);

//
var script$A = {
  name: "Textarea",
  components: {
    FormError: __vue_component__$X
  },
  props: {
    autofocus: Boolean,
    disabled: Boolean,
    id: {
      type: String,
      required: Boolean
    },
    label: String,
    placeholder: String,
    rows: {
      type: String,
      default: "12"
    },
    rules: [Object, String],
    showLabel: {
      default: true,
      type: Boolean
    },
    styleAsCard: Boolean,
    type: {
      type: String,
      default: "text"
    },
    useLabelForErrors: {
      default: true,
      type: Boolean
    },
    value: String,
    vid: String
  },
  computed: {
    providerName() {
      return this.useLabelForErrors && this.label ? this.label : "This field";
    }

  },
  methods: {
    removeInput() {
      this.$emit("remove");
    }

  }
};

/* script */
const __vue_script__$A = script$A;
/* template */

var __vue_render__$B = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('ValidationProvider', {
    staticClass: "textarea flex flex-col",
    attrs: {
      "rules": _vm.rules,
      "name": _vm.providerName,
      "vid": _vm.vid,
      "tag": "div"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (ref) {
        var errors = ref.errors;
        return [_vm.showLabel && _vm.label ? _c('label', {
          attrs: {
            "for": _vm.id
          }
        }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _c('textarea', {
          staticClass: "flex-1",
          class: {
            'textarea-as-card': _vm.styleAsCard
          },
          attrs: {
            "disabled": _vm.disabled,
            "id": _vm.id,
            "placeholder": _vm.placeholder,
            "rows": _vm.rows,
            "autofocus": _vm.autofocus
          },
          domProps: {
            "value": _vm.value
          },
          on: {
            "input": function ($event) {
              return _vm.$emit('input', $event.target.value);
            }
          }
        }), _vm._v(" "), _c('FormError', {
          attrs: {
            "errors": errors
          }
        })];
      }
    }])
  });
};

var __vue_staticRenderFns__$B = [];
/* style */

const __vue_inject_styles__$B = undefined;
/* scoped */

const __vue_scope_id__$B = "data-v-8cc71584";
/* module identifier */

const __vue_module_identifier__$B = undefined;
/* functional template */

const __vue_is_functional_template__$B = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$B = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$B,
  staticRenderFns: __vue_staticRenderFns__$B
}, __vue_inject_styles__$B, __vue_script__$A, __vue_scope_id__$B, __vue_is_functional_template__$B, __vue_module_identifier__$B, false, undefined, undefined, undefined);

const PUSH_FLASH_MESSAGE$3 = "PUSH_FLASH_MESSAGE";
var script$z = {
  name: "ModlInput",
  components: {
    Textarea: __vue_component__$B
  },
  props: {
    converting: Boolean,
    modlToJson: {
      required: true,
      type: Function
    },
    value: String
  },
  methods: { ...mapMutations("base", [PUSH_FLASH_MESSAGE$3]),

    async convertModlToJson(val, open, errorFunc = this.onError) {
      this.$emit("converting-changed", true);
      let response;

      if (val) {
        try {
          response = await this.modlToJson(val, open);

          if (responseSuccessful(response)) {
            // pretty print the JSON with 2 space indents
            const stringifiedJson = _JSON$stringify(response.data, null, 2);

            this.$emit("json-changed", stringifiedJson);
          } else {
            errorFunc({
              message: response.data.message,
              type: "error"
            });
          }
        } catch (e) {// console.log("stringifiedJson failed", e);
        }
      }

      this.$emit("converting-changed", false);
      return response;
    },

    onError(params) {
      this.PUSH_FLASH_MESSAGE(params);
    }

  }
};

/* script */
const __vue_script__$z = script$z;
/* template */

var __vue_render__$A = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('Textarea', {
    staticClass: "mb-0 font-mono",
    attrs: {
      "value": _vm.value,
      "id": "modl",
      "placeholder": "Write your custom record MODL here",
      "rows": "6",
      "label": "MODL",
      "show-label": false,
      "rules": "numVersionModl",
      "disabled": _vm.converting
    },
    on: {
      "input": function (newVal) {
        return _vm.$emit('input', newVal);
      }
    }
  });
};

var __vue_staticRenderFns__$A = [];
/* style */

const __vue_inject_styles__$A = undefined;
/* scoped */

const __vue_scope_id__$A = undefined;
/* module identifier */

const __vue_module_identifier__$A = undefined;
/* functional template */

const __vue_is_functional_template__$A = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$A = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$A,
  staticRenderFns: __vue_staticRenderFns__$A
}, __vue_inject_styles__$A, __vue_script__$z, __vue_scope_id__$A, __vue_is_functional_template__$A, __vue_module_identifier__$A, false, undefined, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$y = {
  name: "Tabs",
  props: {
    appearance: {
      type: String,

      validator(value) {
        // The value must match one of these strings
        return ["dark"].indexOf(value) !== -1;
      }

    },
    bodyClass: String,
    selectedTab: String,
    size: {
      type: String,

      validator(value) {
        // The value must match one of these strings
        return ["full"].indexOf(value) !== -1;
      }

    },
    tabs: Array,
    tabClass: String
  },
  computed: {
    dynamicClass() {
      const classes = [];
      if (this.appearance === "dark") classes.push("is-dark");
      if (this.size === "full") classes.push("is-full");
      return classes.join(" ");
    }

  },
  methods: {
    getTabClass(tab) {
      var _this$tabClass;

      let classes = (_this$tabClass = this.tabClass) !== null && _this$tabClass !== void 0 ? _this$tabClass : "";
      if (this.selectedTab === tab) classes += " is-selected";
      return classes;
    },

    selectTab(tab) {
      if (this.selectedTab !== tab) this.$emit("tab-changed", tab);
    }

  }
};

/* script */
const __vue_script__$y = script$y;
/* template */

var __vue_render__$z = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "tabs",
    class: _vm.dynamicClass
  }, [_c('div', {
    staticClass: "tabs__header"
  }, [_c('div', {
    staticClass: "tabs__tabs"
  }, [_vm._l(_vm.tabs, function (tab) {
    return [_c('span', {
      key: tab,
      staticClass: "tabs__tab",
      class: _vm.getTabClass(tab),
      on: {
        "click": function ($event) {
          $event.preventDefault();
          return _vm.selectTab(tab);
        }
      }
    }, [_vm._v("\n          " + _vm._s(tab) + "\n        ")])];
  })], 2), _vm._v(" "), _vm._t("header")], 2), _vm._v(" "), _c('div', {
    staticClass: "tabs__body",
    class: _vm.bodyClass
  }, [_vm._t("default")], 2)]);
};

var __vue_staticRenderFns__$z = [];
/* style */

const __vue_inject_styles__$z = undefined;
/* scoped */

const __vue_scope_id__$z = "data-v-0f4f95a9";
/* module identifier */

const __vue_module_identifier__$z = undefined;
/* functional template */

const __vue_is_functional_template__$z = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$z = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$z,
  staticRenderFns: __vue_staticRenderFns__$z
}, __vue_inject_styles__$z, __vue_script__$y, __vue_scope_id__$z, __vue_is_functional_template__$z, __vue_module_identifier__$z, false, undefined, undefined, undefined);

const setModlVersion = modlResponse => {
  if (!modlResponse) return;
  let modlToSet = modlResponse;

  if (!_startsWithInstanceProperty(modlResponse).call(modlResponse, "@n=1")) {
    modlToSet = `@n=1;${modlResponse}`;
  }

  return modlToSet;
};

const PUSH_FLASH_MESSAGE$2 = "PUSH_FLASH_MESSAGE";
var script$x = {
  name: "JsonModl",
  components: {
    Card: __vue_component__$Y,
    Checkbox: __vue_component__$W,
    ModlInput: __vue_component__$A,
    Tabs: __vue_component__$z,
    Textarea: __vue_component__$B
  },
  props: {
    jsonToModl: {
      required: true,
      type: Function
    },
    modlToJson: {
      required: true,
      type: Function
    },
    moduleId: Number,
    open: Boolean,
    validate: Function,
    value: String
  },

  data() {
    return {
      convertTabsToSpaces: true,
      converting: false,
      json: "",
      modl: "",
      selectedTab: "JSON",
      tabs: ["JSON", "MODL"]
    };
  },

  watch: {
    modl(newVal) {
      this.$emit("input", newVal);
    },

    value: {
      handler(newVal) {
        if (!newVal) return;
        this.modl = newVal;
      },

      immediate: true
    }
  },

  async mounted() {
    // if we have a value, handle edit mode, parsing existing MODL to JSON
    await this.$refs.modlInput.convertModlToJson(this.value, this.open);
  },

  methods: { ...mapMutations("base", [PUSH_FLASH_MESSAGE$2]),

    // called by the parent to make sure the latest JSON is converted to MODL, if the JSON tab is open
    async convertJsonModl() {
      let response;

      if (this.selectedTab === "JSON") {
        response = await this.convertJsonToModl(this.json);
      } else if (this.selectedTab === "MODL") {
        response = await this.$refs.modlInput.convertModlToJson(this.value, this.open);
      }

      return response;
    },

    async convertJsonToModl(val) {
      this.converting = true;
      let response;

      if (val) {
        try {
          const parsedJson = JSON.parse(val);
          response = await this.jsonToModl(parsedJson, this.open);

          if (responseSuccessful(response)) {
            const modlResponse = response.data.modl;
            this.modl = setModlVersion(modlResponse);
          } else {
            this.PUSH_FLASH_MESSAGE({
              message: response.data.message,
              type: "error"
            });
          }
        } catch (e) {
          response = e;
          this.PUSH_FLASH_MESSAGE({
            message: e,
            type: "error"
          });
        }
      }

      this.converting = false;
      return response;
    },

    async tabChanged(newTab) {
      const valid = await this.validate();
      if (!valid) return;
      let response;

      if (newTab === "JSON") {
        response = await this.$refs.modlInput.convertModlToJson(this.value, this.open);
      } else if (newTab === "MODL") {
        response = await this.convertJsonToModl(this.json);
      }

      if (responseSuccessful(response)) this.selectedTab = newTab;
    },

    tabKeyToSpaces(event) {
      if (this.convertTabsToSpaces) {
        event.preventDefault(); // based on: https://forum.vuejs.org/t/how-to-add-indents-when-using-tab-key-in-textarea/33430/6

        const text = this.json;
        const originalSelectionStart = event.target.selectionStart;

        const textStart = _sliceInstanceProperty(text).call(text, 0, originalSelectionStart);

        const textEnd = _sliceInstanceProperty(text).call(text, originalSelectionStart);

        const spaceChar = " ";
        const numberOfSpacesToInsert = 2;

        const spacesToInsert = _repeatInstanceProperty(spaceChar).call(spaceChar, numberOfSpacesToInsert);

        this.json = `${textStart}${spacesToInsert}${textEnd}`;
        event.target.value = this.json; // required to make the cursor stay in place.

        event.target.selectionEnd = event.target.selectionStart = originalSelectionStart + numberOfSpacesToInsert;
      }
    }

  }
};

/* script */
const __vue_script__$x = script$x;
/* template */

var __vue_render__$y = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_vm.moduleId !== 0 ? _c('Card', {
    attrs: {
      "variant": "dark"
    }
  }, [_c('p', [_vm._v("\n      We don't have a user-friendly record editor available for this module\n      yet, instead you can edit the data in the JSON object shown. We'll have\n      a record editor available soon.\n    ")])]) : _vm._e(), _vm._v(" "), _c('Tabs', {
    attrs: {
      "selected-tab": _vm.selectedTab,
      "tabs": _vm.tabs
    },
    on: {
      "tab-changed": _vm.tabChanged
    }
  }, [_c('template', {
    slot: "header"
  }, [_vm.selectedTab === 'JSON' ? _c('Checkbox', {
    staticClass: "mb-0",
    attrs: {
      "id": "tabs-to-spaces",
      "label": "Enable tabs",
      "variant": "inline"
    },
    model: {
      value: _vm.convertTabsToSpaces,
      callback: function ($$v) {
        _vm.convertTabsToSpaces = $$v;
      },
      expression: "convertTabsToSpaces"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('Textarea', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.selectedTab === 'JSON',
      expression: "selectedTab === 'JSON'"
    }],
    staticClass: "mb-0 font-mono",
    attrs: {
      "id": "json",
      "placeholder": "Write your custom record JSON here",
      "rows": "6",
      "label": "JSON",
      "show-label": false,
      "disabled": _vm.converting
    },
    nativeOn: {
      "keydown": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")) {
          return null;
        }

        if ($event.ctrlKey || $event.shiftKey || $event.altKey || $event.metaKey) {
          return null;
        }

        return _vm.tabKeyToSpaces($event);
      }
    },
    model: {
      value: _vm.json,
      callback: function ($$v) {
        _vm.json = $$v;
      },
      expression: "json"
    }
  }), _vm._v(" "), _c('ModlInput', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.selectedTab === 'MODL',
      expression: "selectedTab === 'MODL'"
    }],
    ref: "modlInput",
    attrs: {
      "converting": _vm.converting,
      "disabled": _vm.converting,
      "modl-to-json": _vm.modlToJson
    },
    on: {
      "json-changed": function (newVal) {
        return _vm.json = newVal;
      },
      "converting-changed": function (newVal) {
        return _vm.converting = newVal;
      }
    },
    model: {
      value: _vm.modl,
      callback: function ($$v) {
        _vm.modl = $$v;
      },
      expression: "modl"
    }
  })], 2)], 1);
};

var __vue_staticRenderFns__$y = [];
/* style */

const __vue_inject_styles__$y = undefined;
/* scoped */

const __vue_scope_id__$y = undefined;
/* module identifier */

const __vue_module_identifier__$y = undefined;
/* functional template */

const __vue_is_functional_template__$y = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$y,
  staticRenderFns: __vue_staticRenderFns__$y
}, __vue_inject_styles__$y, __vue_script__$x, __vue_scope_id__$y, __vue_is_functional_template__$y, __vue_module_identifier__$y, false, undefined, undefined, undefined);

//
var script$w = {
  name: "ViewModeItem",
  components: {
    Prefix: __vue_component__$N
  },
  props: {
    name: String,
    ownLine: Boolean,
    prefix: String,
    value: [Number, String]
  }
};

/* script */
const __vue_script__$w = script$w;
/* template */

var __vue_render__$x = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "mb-2"
  }, [_vm.name ? [_vm._v(" " + _vm._s(_vm.name) + ": ")] : _vm._e(), _vm._v(" "), _c('Prefix', {
    attrs: {
      "prefix": _vm.prefix
    }
  }), _vm._v(" "), _vm.value ? _c('strong', {
    class: {
      'inline-flex': _vm.ownLine
    },
    domProps: {
      "innerHTML": _vm._s(_vm.value)
    }
  }) : _c('em', {
    staticClass: "opacity-50"
  }, [_vm._v("blank")])], 2);
};

var __vue_staticRenderFns__$x = [];
/* style */

const __vue_inject_styles__$x = undefined;
/* scoped */

const __vue_scope_id__$x = undefined;
/* module identifier */

const __vue_module_identifier__$x = undefined;
/* functional template */

const __vue_is_functional_template__$x = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$x = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$x,
  staticRenderFns: __vue_staticRenderFns__$x
}, __vue_inject_styles__$x, __vue_script__$w, __vue_scope_id__$x, __vue_is_functional_template__$x, __vue_module_identifier__$x, false, undefined, undefined, undefined);

var script$v = {
  name: "JsonPreview",
  components: {
    ViewModeItem: __vue_component__$x
  },
  props: {
    converting: Boolean,
    isRoot: Boolean,
    json: [Array, Object, Number, String],
    showNull: Boolean
  },
  computed: {
    filteredItems() {
      if (!this.json) return;

      const jsonKeys = _Object$keys(this.json);

      const filteredJsonKeys = this.isRoot ? _filterInstanceProperty(jsonKeys).call(jsonKeys, k => !_startsWithInstanceProperty(k).call(k, "@")) : jsonKeys;

      const jsonItems = _mapInstanceProperty(filteredJsonKeys).call(filteredJsonKeys, k => ({
        key: k,
        value: this.json[k]
      }));

      return jsonItems;
    }

  },
  methods: {
    classes(item) {
      const valueIsString = typeof item.value === "string";
      if (!valueIsString) return "module-editor-group";
    },

    isArrayOrObject(item) {
      return item && typeof item === "object";
    }

  }
};

/* script */
const __vue_script__$v = script$v;
/* template */

var __vue_render__$w = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "last:mb-0"
  }, _vm._l(_vm.filteredItems, function (item) {
    return !_vm.showNull && item.value ? _c('div', {
      key: item.key,
      staticClass: "mb-2 last:mb-0",
      class: _vm.classes(item)
    }, [_vm.isArrayOrObject(item.value) ? [!Array.isArray(_vm.json) ? _c('h4', [_vm._v(_vm._s(item.key))]) : _vm._e(), _vm._v(" "), _c('JsonPreview', {
      attrs: {
        "json": item.value,
        "converting": _vm.converting,
        "is-root": false,
        "show-null": _vm.showNull
      }
    })] : _c('ViewModeItem', {
      attrs: {
        "name": item.key,
        "value": item.value
      }
    })], 2) : _vm._e();
  }), 0);
};

var __vue_staticRenderFns__$w = [];
/* style */

const __vue_inject_styles__$w = undefined;
/* scoped */

const __vue_scope_id__$w = undefined;
/* module identifier */

const __vue_module_identifier__$w = undefined;
/* functional template */

const __vue_is_functional_template__$w = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$w = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$w,
  staticRenderFns: __vue_staticRenderFns__$w
}, __vue_inject_styles__$w, __vue_script__$v, __vue_scope_id__$w, __vue_is_functional_template__$w, __vue_module_identifier__$w, false, undefined, undefined, undefined);

//
//
//
//
//
//
//
//
var script$u = {
  name: "SkeletonLine",
  props: {
    pulse: {
      default: true,
      type: Boolean
    },
    width: String
  },
  computed: {
    skeletonStyle() {
      return this.width && `width: ${this.width}`;
    }

  }
};

/* script */
const __vue_script__$u = script$u;
/* template */

var __vue_render__$v = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('span', {
    staticClass: "skeleton skeleton--line",
    class: {
      pulse: _vm.pulse
    },
    style: _vm.skeletonStyle
  });
};

var __vue_staticRenderFns__$v = [];
/* style */

const __vue_inject_styles__$v = undefined;
/* scoped */

const __vue_scope_id__$v = undefined;
/* module identifier */

const __vue_module_identifier__$v = undefined;
/* functional template */

const __vue_is_functional_template__$v = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$v = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$v,
  staticRenderFns: __vue_staticRenderFns__$v
}, __vue_inject_styles__$v, __vue_script__$u, __vue_scope_id__$v, __vue_is_functional_template__$v, __vue_module_identifier__$v, false, undefined, undefined, undefined);

var script$t = {
  name: "JsonModlViewer",
  components: {
    JsonPreview: __vue_component__$w,
    SkeletonLine: __vue_component__$v,
    Tabs: __vue_component__$z
  },
  props: {
    modl: String,
    modlToJson: {
      required: true,
      type: Function
    }
  },

  data() {
    return {
      converting: true,
      json: null,
      selectedTab: "Preview",
      tabs: ["Preview", "JSON", "MODL"]
    };
  },

  computed: {
    jsonString() {
      // pretty print the JSON with 2 space indents
      return _JSON$stringify(this.json, null, 2);
    }

  },
  watch: {
    modl: {
      handler(newVal) {
        if (!newVal) return;
        this.convertModlToJson(newVal);
      },

      immediate: true
    }
  },
  methods: {
    async convertModlToJson(val) {
      this.converting = true;
      let response;

      if (val) {
        try {
          response = await this.modlToJson(val, this.open);

          if (responseSuccessful(response)) {
            this.json = response.data;
          }
        } catch (e) {// console.log("stringifiedJson failed", e);
        }
      }

      this.converting = false;
      return response;
    },

    async tabChanged(newTab) {
      this.selectedTab = newTab;
    }

  }
};

/* script */
const __vue_script__$t = script$t;
/* template */

var __vue_render__$u = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('Tabs', {
    attrs: {
      "selected-tab": _vm.selectedTab,
      "tabs": _vm.tabs
    },
    on: {
      "tab-changed": _vm.tabChanged
    }
  }, [_vm.selectedTab === 'Preview' ? _c('JsonPreview', {
    attrs: {
      "is-root": true,
      "json": _vm.json,
      "converting": _vm.converting
    }
  }) : _vm.selectedTab === 'JSON' ? _c('div', [_vm.converting ? _c('SkeletonLine') : _vm._e(), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.jsonString))])], 1) : _vm.selectedTab === 'MODL' ? _c('div', [_c('code', [_vm._v(_vm._s(_vm.modl))])]) : _vm._e()], 1);
};

var __vue_staticRenderFns__$u = [];
/* style */

const __vue_inject_styles__$u = undefined;
/* scoped */

const __vue_scope_id__$u = undefined;
/* module identifier */

const __vue_module_identifier__$u = undefined;
/* functional template */

const __vue_is_functional_template__$u = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$u = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$u,
  staticRenderFns: __vue_staticRenderFns__$u
}, __vue_inject_styles__$u, __vue_script__$t, __vue_scope_id__$u, __vue_is_functional_template__$u, __vue_module_identifier__$u, false, undefined, undefined, undefined);

// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
    // find the complete implementation of crypto (msCrypto) on IE11.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}

var REGEX = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

function validate(uuid) {
  return typeof uuid === 'string' && REGEX.test(uuid);
}

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

var byteToHex = [];

for (var i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).substr(1));
}

function stringify(arr) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!validate(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

function v4(options, buf, offset) {
  options = options || {};
  var rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (var i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return stringify(rnds);
}

//
var script$s = {
  name: "Modal",
  components: {
    Button: __vue_component__$_
  },
  props: {
    modalBodyClass: String,
    modalClass: String,
    modalWrapperClass: String,
    showCancel: {
      default: true,
      type: Boolean
    },
    showFooter: {
      default: true,
      type: Boolean
    },
    showCloseIcon: {
      default: false,
      type: Boolean
    }
  },

  data() {
    return {
      modalId: v4()
    };
  },

  computed: {
    showConfirmButton() {
      var _this$$slots$confirm, _this$$slots$confirm$, _this$$slots$confirm$2;

      return (_this$$slots$confirm = this.$slots["confirm-button"]) === null || _this$$slots$confirm === void 0 ? void 0 : (_this$$slots$confirm$ = _this$$slots$confirm[0]) === null || _this$$slots$confirm$ === void 0 ? void 0 : (_this$$slots$confirm$2 = _this$$slots$confirm$.text) === null || _this$$slots$confirm$2 === void 0 ? void 0 : _this$$slots$confirm$2.length;
    },

    showAfterHeader() {
      var _this$$slots, _this$$slots$afterHe;

      return !!((_this$$slots = this.$slots) !== null && _this$$slots !== void 0 && (_this$$slots$afterHe = _this$$slots["after-header"]) !== null && _this$$slots$afterHe !== void 0 && _this$$slots$afterHe[0]);
    },

    showHeader() {
      var _this$$slots$header, _this$$slots$header$, _this$$slots$header$$;

      return (_this$$slots$header = this.$slots.header) === null || _this$$slots$header === void 0 ? void 0 : (_this$$slots$header$ = _this$$slots$header[0]) === null || _this$$slots$header$ === void 0 ? void 0 : (_this$$slots$header$$ = _this$$slots$header$.text) === null || _this$$slots$header$$ === void 0 ? void 0 : _this$$slots$header$$.length;
    }

  },

  created() {
    this.handleModalShownFixPosition();
  },

  mounted() {
    this.toggleHtmlClass(true);
  },

  beforeDestroy() {
    this.handleModalClosingUnfixPosition();
    this.toggleHtmlClass(false);
  },

  methods: {
    closeModal() {
      this.$emit("close");
    },

    handleModalClosingUnfixPosition() {
      // let the window be scrollable again now the modal has been closed
      // src: https://css-tricks.com/prevent-page-scrolling-when-a-modal-is-open/
      const scrollY = document.body.style.top;
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.width = "";
      window.scrollTo(0, parseInt(scrollY || "0") * -1);
    },

    handleModalShownFixPosition() {
      // stop the body from being scrollable whilst the modal is open
      // src: https://css-tricks.com/prevent-page-scrolling-when-a-modal-is-open/
      document.body.style.top = `-${window.scrollY}px`;
      document.body.style.position = "fixed";
      document.body.style.width = "100%";
    },

    toggleHtmlClass(show) {
      const el = document.documentElement;
      const className = `modal-open-${this.modalId}`;

      if (show) {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    }

  }
};

/* script */
const __vue_script__$s = script$s;
/* template */

var __vue_render__$t = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask",
    on: {
      "click": function ($event) {
        if ($event.target !== $event.currentTarget) {
          return null;
        }

        return _vm.closeModal.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "modal-container-wrapper",
    class: _vm.modalWrapperClass
  }, [_c('div', {
    staticClass: "modal-container",
    class: _vm.modalClass
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "modal-header-inner -my-2"
  }, [_vm.showHeader ? _c('h2', {
    staticClass: "h3 my-2 mr-2"
  }, [_vm._t("header")], 2) : _vm._e(), _vm._v(" "), _vm.showAfterHeader ? _c('div', {
    staticClass: "my-2"
  }, [_vm._t("after-header")], 2) : _vm._e(), _vm._v(" "), _c('div')]), _vm._v(" "), _vm.showCloseIcon ? _c('ion-icon', {
    staticClass: "flex-shrink-0 icon--bold fs-2 ml-2 -mt-1 cursor-pointer",
    attrs: {
      "name": "close-sharp",
      "title": "Close modal",
      "aria-label": "Close modal"
    },
    on: {
      "click": _vm.closeModal
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-body last:mb-0",
    class: _vm.modalBodyClass
  }, [_vm._t("body")], 2), _vm._v(" "), _vm.showFooter ? _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", function () {
    return [_vm.showConfirmButton ? [_vm.showCancel ? _c('Button', {
      staticClass: "mb-0 is-plain qa-close-button",
      attrs: {
        "variant": "small"
      },
      nativeOn: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.closeModal.apply(null, arguments);
        }
      }
    }, [_vm._t("cancel-button", function () {
      return [_vm._v("Cancel")];
    })], 2) : _vm._e(), _vm._v(" "), _c('Button', {
      staticClass: "mb-0 qa-confirm-button",
      attrs: {
        "variant": "small"
      },
      nativeOn: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.$emit('confirm');
        }
      }
    }, [_vm._t("confirm-button", function () {
      return [_vm._v("Ok")];
    })], 2)] : _c('Button', {
      staticClass: "mb-0 qa-close-button",
      attrs: {
        "variant": "small"
      },
      nativeOn: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.closeModal.apply(null, arguments);
        }
      }
    }, [_vm._t("close-button", function () {
      return [_vm._v("Ok")];
    })], 2)];
  })], 2) : _vm._e()])])])]);
};

var __vue_staticRenderFns__$t = [];
/* style */

const __vue_inject_styles__$t = undefined;
/* scoped */

const __vue_scope_id__$t = "data-v-2f351d52";
/* module identifier */

const __vue_module_identifier__$t = undefined;
/* functional template */

const __vue_is_functional_template__$t = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$t = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$t,
  staticRenderFns: __vue_staticRenderFns__$t
}, __vue_inject_styles__$t, __vue_script__$s, __vue_scope_id__$t, __vue_is_functional_template__$t, __vue_module_identifier__$t, false, undefined, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$r = {
  name: "Pagination",
  props: {
    page: Number,
    pageCount: Number,
    router: Object
  },
  computed: {
    prevPages() {
      if (this.page === 1) return [];else if (this.page === 2) return [this.page - 1];else return [this.page - 2, this.page - 1];
    },

    nextPages() {
      if (this.page === this.pageCount) return [];else if (this.page === this.pageCount - 1) return [this.page + 1];else return [this.page + 1, this.page + 2];
    }

  },
  methods: {
    setPage(page) {
      this.router.push({
        query: { ...this.$route.query,
          page
        }
      });
    }

  }
};

/* script */
const __vue_script__$r = script$r;
/* template */

var __vue_render__$s = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "inline-flex items-center"
  }, [_vm.page > 1 ? _c('div', {
    staticClass: "cursor-pointer select-none mr-3",
    on: {
      "click": function ($event) {
        return _vm.setPage(_vm.page - 1);
      }
    }
  }, [_vm._v("\n    ← Prev\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, [_vm.prevPages && _vm.prevPages[0] > 1 ? _c('div', {
    staticClass: "pagination__item",
    on: {
      "click": function ($event) {
        return _vm.setPage(1);
      }
    }
  }, [_vm._v("\n      1\n    ")]) : _vm._e(), _vm._v(" "), _vm.prevPages && _vm.prevPages[0] > 2 ? _c('div', {
    staticClass: "pagination__item is-inactive"
  }, [_vm._v("\n      …\n    ")]) : _vm._e(), _vm._v(" "), _vm._l(_vm.prevPages, function (p) {
    return _c('div', {
      key: p,
      staticClass: "pagination__item",
      on: {
        "click": function ($event) {
          return _vm.setPage(p);
        }
      }
    }, [_vm._v("\n      " + _vm._s(p) + "\n    ")]);
  }), _vm._v(" "), _c('div', {
    staticClass: "pagination__item is-current is-inactive"
  }, [_vm._v(_vm._s(_vm.page))]), _vm._v(" "), _vm._l(_vm.nextPages, function (p) {
    return _c('div', {
      key: p,
      staticClass: "pagination__item",
      on: {
        "click": function ($event) {
          return _vm.setPage(p);
        }
      }
    }, [_vm._v("\n      " + _vm._s(p) + "\n    ")]);
  }), _vm._v(" "), _vm.nextPages && _vm.nextPages[_vm.nextPages.length - 1] < _vm.pageCount - 1 ? _c('div', {
    staticClass: "pagination__item is-inactive"
  }, [_vm._v("\n      …\n    ")]) : _vm._e(), _vm._v(" "), _vm.page < _vm.pageCount - 2 ? _c('div', {
    staticClass: "pagination__item",
    on: {
      "click": function ($event) {
        return _vm.setPage(_vm.pageCount);
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.pageCount) + "\n    ")]) : _vm._e()], 2), _vm._v(" "), _vm.page < _vm.pageCount ? _c('div', {
    staticClass: "cursor-pointer select-none ml-3",
    on: {
      "click": function ($event) {
        return _vm.setPage(_vm.page + 1);
      }
    }
  }, [_vm._v("\n    Next →\n  ")]) : _vm._e()]);
};

var __vue_staticRenderFns__$s = [];
/* style */

const __vue_inject_styles__$s = undefined;
/* scoped */

const __vue_scope_id__$s = "data-v-3ddaf9e8";
/* module identifier */

const __vue_module_identifier__$s = undefined;
/* functional template */

const __vue_is_functional_template__$s = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$s = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$s,
  staticRenderFns: __vue_staticRenderFns__$s
}, __vue_inject_styles__$s, __vue_script__$r, __vue_scope_id__$s, __vue_is_functional_template__$s, __vue_module_identifier__$s, false, undefined, undefined, undefined);

//
//
//
//
//
//
//
//
var script$q = {
  name: "Spacer",
  props: {
    innerClass: String,
    size: {
      type: String,

      validator(value) {
        return ["medium"].indexOf(value) !== -1;
      }

    }
  },
  computed: {
    spacerClass() {
      return this.size && `spacer--${this.size}`;
    }

  }
};

/* script */
const __vue_script__$q = script$q;
/* template */

var __vue_render__$r = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "spacer",
    class: _vm.spacerClass
  }, [_c('div', {
    staticClass: "spacer__inner",
    class: _vm.innerClass
  }, [_vm._t("default")], 2)]);
};

var __vue_staticRenderFns__$r = [];
/* style */

const __vue_inject_styles__$r = undefined;
/* scoped */

const __vue_scope_id__$r = undefined;
/* module identifier */

const __vue_module_identifier__$r = undefined;
/* functional template */

const __vue_is_functional_template__$r = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$r = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$r,
  staticRenderFns: __vue_staticRenderFns__$r
}, __vue_inject_styles__$r, __vue_script__$q, __vue_scope_id__$r, __vue_is_functional_template__$r, __vue_module_identifier__$r, false, undefined, undefined, undefined);

//
var script$p = {
  name: "RadioBlockItem",
  components: {
    Spacer: __vue_component__$r
  },
  props: {
    id: [String, Number],
    selectedId: [String, Number]
  },
  methods: {
    optionSelected(itemId) {
      // go up two levels to the RadioBlocks component and emit the change
      this.$parent.$parent.$emit("input", itemId);
    }

  }
};

/* script */
const __vue_script__$p = script$p;
/* template */

var __vue_render__$q = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    key: _vm.id,
    staticClass: "radio-block",
    class: [{
      'is-selected': _vm.selectedId === _vm.id
    }],
    on: {
      "click": function () {
        return _vm.optionSelected(_vm.id);
      }
    }
  }, [_c('div', {
    staticClass: "radio-block__radio"
  }, [_vm.selectedId === _vm.id ? _c('ion-icon', {
    staticClass: "radio-block__icon",
    attrs: {
      "name": "checkmark-circle-sharp"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('Spacer', {
    attrs: {
      "inner-class": "radio-block__body"
    }
  }, [_c('h2', {
    staticClass: "h5 radio-block__header"
  }, [_vm._t("header", function () {
    return [_vm._v("Default header")];
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "last:mb-0"
  }, [_vm._t("default")], 2)])], 1);
};

var __vue_staticRenderFns__$q = [];
/* style */

const __vue_inject_styles__$q = undefined;
/* scoped */

const __vue_scope_id__$q = undefined;
/* module identifier */

const __vue_module_identifier__$q = undefined;
/* functional template */

const __vue_is_functional_template__$q = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$q,
  staticRenderFns: __vue_staticRenderFns__$q
}, __vue_inject_styles__$q, __vue_script__$p, __vue_scope_id__$q, __vue_is_functional_template__$q, __vue_module_identifier__$q, false, undefined, undefined, undefined);

//
var script$o = {
  name: "RadioBlocks",
  components: {
    FormError: __vue_component__$X,
    RadioBlockItem: __vue_component__$q,
    ValidationProvider
  },
  props: {
    label: String,
    layout: {
      default: "full",
      type: String
    },
    options: Array,
    rules: String,
    value: [String, Number]
  },
  computed: {
    blockClass() {
      return `is-${this.layout}`;
    }

  }
};

/* script */
const __vue_script__$o = script$o;
/* template */

var __vue_render__$p = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('ValidationProvider', {
    staticClass: "radio-blocks mb-4",
    class: _vm.blockClass,
    attrs: {
      "rules": _vm.rules,
      "name": _vm.label || 'This field',
      "tag": "div"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (ref) {
        var errors = ref.errors;
        return [_c('input', {
          attrs: {
            "type": "hidden"
          },
          domProps: {
            "value": _vm.value
          }
        }), _vm._v(" "), _vm._t("default", function () {
          return _vm._l(_vm.options, function (option) {
            return _c('RadioBlockItem', {
              key: option.id,
              attrs: {
                "id": option.id,
                "selected-id": _vm.value
              },
              scopedSlots: _vm._u([{
                key: "header",
                fn: function () {
                  return [_c('span', {
                    domProps: {
                      "innerHTML": _vm._s(option.header)
                    }
                  })];
                },
                proxy: true
              }], null, true)
            }, [_vm._v(" "), _vm._l(option.body, function (paragraph) {
              return _c('p', {
                key: paragraph,
                staticClass: "mb-2",
                domProps: {
                  "innerHTML": _vm._s(paragraph)
                }
              });
            })], 2);
          });
        }), _vm._v(" "), _c('FormError', {
          attrs: {
            "errors": errors
          }
        })];
      }
    }], null, true)
  });
};

var __vue_staticRenderFns__$p = [];
/* style */

const __vue_inject_styles__$p = undefined;
/* scoped */

const __vue_scope_id__$p = undefined;
/* module identifier */

const __vue_module_identifier__$p = undefined;
/* functional template */

const __vue_is_functional_template__$p = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$p = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$p,
  staticRenderFns: __vue_staticRenderFns__$p
}, __vue_inject_styles__$p, __vue_script__$o, __vue_scope_id__$p, __vue_is_functional_template__$p, __vue_module_identifier__$p, false, undefined, undefined, undefined);

//
var script$n = {
  name: "RecordPath",
  components: {
    // have to rename it, it doesn't like the `</Input>` ending tag
    FormInput: __vue_component__$M
  },
  props: {
    disabled: Boolean,
    label: {
      default: "Record Path",
      type: String
    },
    mode: String,
    showDescription: Boolean,
    value: String
  },
  computed: { ...mapState("session", ["numId"]),

    domainToUse() {
      var _this$numId;

      return ((_this$numId = this.numId) === null || _this$numId === void 0 ? void 0 : _this$numId.name) || "example.com";
    }

  },

  created() {
    // if the initial value is set to `/` we don't want to emit a change
    if (this.value !== "/") this.setFormattedValue(this.value);
  },

  methods: {
    handlePathUpdate(newVal) {
      this.setFormattedValue(newVal);
      this.$emit("path-changed", newVal);
    },

    setFormattedValue(newVal) {
      if (!newVal) return;
      let formattedNewVal = newVal.replace(/(\s|\.)+/g, "-").toLowerCase();
      if (formattedNewVal.charAt(0) !== "/") formattedNewVal = `/${formattedNewVal}`;
      this.$emit("input", formattedNewVal);
    }

  }
};

/* script */
const __vue_script__$n = script$n;
/* template */

var __vue_render__$o = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('FormInput', {
    attrs: {
      "value": _vm.value,
      "disabled": _vm.disabled || _vm.mode === 'edit',
      "id": "path",
      "label": _vm.label,
      "rules": "recordPath"
    },
    on: {
      "input": _vm.handlePathUpdate
    }
  }, [_vm.showDescription ? _c('template', {
    slot: "description"
  }, [_vm._v("\n      Paths make it possible for you to split data across multiple records and\n      link records together. The path "), _c('code', [_vm._v("/")]), _vm._v(" represents the root\n      record – similar to a homepage on the web. In the NUM URI\n      "), _c('code', [_vm._v("num://" + _vm._s(_vm.domainToUse) + "/path/to/record")]), _vm._v(" the path is\n      "), _c('code', [_vm._v("/path/to/record")])]) : _vm._e()], 2)], 1);
};

var __vue_staticRenderFns__$o = [];
/* style */

const __vue_inject_styles__$o = undefined;
/* scoped */

const __vue_scope_id__$o = undefined;
/* module identifier */

const __vue_module_identifier__$o = undefined;
/* functional template */

const __vue_is_functional_template__$o = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$o = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$o,
  staticRenderFns: __vue_staticRenderFns__$o
}, __vue_inject_styles__$o, __vue_script__$n, __vue_scope_id__$o, __vue_is_functional_template__$o, __vue_module_identifier__$o, false, undefined, undefined, undefined);

//
const PUSH_FLASH_MESSAGE$1 = "PUSH_FLASH_MESSAGE";
var script$m = {
  name: "RecordModl",
  components: {
    Button: __vue_component__$_,
    Card: __vue_component__$Y,
    Form: __vue_component__$O,
    Textarea: __vue_component__$B,
    ToggleArrow: __vue_component__$V
  },
  props: {
    context: String,
    editing: Boolean,
    modlLoading: {
      default: false,
      type: Boolean
    },
    modlShown: Boolean,
    value: String
  },

  data() {
    return {
      input: ""
    };
  },

  methods: { ...mapMutations("base", [PUSH_FLASH_MESSAGE$1]),

    submitForm() {
      this.$emit("input", this.input);
      this.toggleEditing();
      this.PUSH_FLASH_MESSAGE({
        message: 'Record form updated, please click "publish" to save your changes',
        type: "notice"
      });
    },

    toggleEditing() {
      if (!this.editing) {
        this.input = this.value;
      }

      this.$emit("editing-changed", !this.editing);
    },

    toggleModlShown() {
      this.$emit("modl-shown-toggled");
    }

  }
};

/* script */
const __vue_script__$m = script$m;
/* template */

var __vue_render__$n = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('div', {
    staticClass: "flex items-start justify-between"
  }, [_c('p', [_c('ToggleArrow', {
    class: {
      'is-subtle': _vm.context === 'editor'
    },
    attrs: {
      "is-open": _vm.modlShown
    },
    on: {
      "toggled": _vm.toggleModlShown
    }
  }, [_vm._v("\n        " + _vm._s(_vm.modlShown ? "Hide" : "View") + " raw NUM record\n      ")])], 1), _vm._v(" "), _vm.modlShown && _vm.context === 'editor' ? _c('a', {
    staticClass: "flex items-center",
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.toggleEditing.apply(null, arguments);
      }
    }
  }, [_vm.editing ? [_c('ion-icon', {
    staticClass: "mr-1",
    attrs: {
      "name": "close-outline"
    }
  }), _vm._v("\n        cancel edit\n      ")] : [_c('ion-icon', {
    staticClass: "mr-1",
    attrs: {
      "name": "create-outline"
    }
  }), _vm._v("\n        edit\n      ")]], 2) : _vm._e()]), _vm._v(" "), _vm.modlShown ? [_vm.editing ? _c('Form', {
    attrs: {
      "on-submit": _vm.submitForm
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (ref) {
        var formSubmitting = ref.formSubmitting;
        return [_c('Textarea', {
          attrs: {
            "id": "record-textarea",
            "label": "NUM record",
            "show-label": false,
            "placeholder": "Paste your NUM record here",
            "rules": "numVersionModl",
            "rows": "4",
            "autofocus": "",
            "style-as-card": true
          },
          model: {
            value: _vm.input,
            callback: function ($$v) {
              _vm.input = $$v;
            },
            expression: "input"
          }
        }), _vm._v(" "), _c('Button', {
          attrs: {
            "type": "submit",
            "value": "validate",
            "variant": "small",
            "disabled": formSubmitting
          }
        })];
      }
    }], null, false, 406257694)
  }) : _c('Card', {
    staticClass: "modl-content",
    class: {
      'is-loading': _vm.modlLoading
    },
    attrs: {
      "variant": "dark"
    }
  }, [_c('code', [_vm.value || _vm.modlLoading ? _c('span', [_vm._v(_vm._s(_vm.value))]) : _c('em', {
    staticClass: "placeholder"
  }, [_vm._v("Edit the record to generate MODL")])])])] : _vm._e()], 2);
};

var __vue_staticRenderFns__$n = [];
/* style */

const __vue_inject_styles__$n = undefined;
/* scoped */

const __vue_scope_id__$n = "data-v-7d437e08";
/* module identifier */

const __vue_module_identifier__$n = undefined;
/* functional template */

const __vue_is_functional_template__$n = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$n = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$n,
  staticRenderFns: __vue_staticRenderFns__$n
}, __vue_inject_styles__$n, __vue_script__$m, __vue_scope_id__$n, __vue_is_functional_template__$n, __vue_module_identifier__$n, false, undefined, undefined, undefined);

//
var script$l = {
  name: "Select",
  components: {
    FormError: __vue_component__$X
  },
  props: {
    disableDefault: Boolean,
    id: {
      type: String,
      required: true
    },
    label: String,
    loadingText: String,
    optionKey: String,
    optionText: String,
    options: Array,
    rules: [Object, String],
    selectText: {
      default: "Select below",
      type: String
    },
    showErrors: {
      default: true,
      type: Boolean
    },
    showLabel: {
      default: true,
      type: Boolean
    },
    type: {
      type: String,
      default: "text"
    },
    value: [String, Number],
    variant: String,
    vid: String
  },
  computed: {
    loading() {
      return this.loadingText ? this.loadingText : "loading&hellip;";
    },

    selectClass() {
      return this.variant ? `select--${this.variant}` : null;
    }

  }
};

/* script */
const __vue_script__$l = script$l;
/* template */

var __vue_render__$m = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('ValidationProvider', {
    staticClass: "flex flex-col select",
    attrs: {
      "rules": _vm.rules,
      "name": _vm.label,
      "tag": "div",
      "vid": _vm.vid
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (ref) {
        var errors = ref.errors;
        return [_vm.showLabel && _vm.label ? _c('label', {
          attrs: {
            "for": _vm.id
          }
        }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _vm.options ? _c('select', {
          class: _vm.selectClass,
          attrs: {
            "id": _vm.id
          },
          domProps: {
            "value": _vm.value
          },
          on: {
            "input": function ($event) {
              return _vm.$emit('input', $event.target.value);
            }
          }
        }, [_c('option', {
          attrs: {
            "value": "",
            "selected": "",
            "disabled": _vm.disableDefault
          },
          domProps: {
            "innerHTML": _vm._s(_vm.selectText)
          }
        }), _vm._v(" "), _vm._l(_vm.options, function (o) {
          return _c('option', {
            key: _vm.optionKey ? o[_vm.optionKey] : o,
            domProps: {
              "value": _vm.optionKey ? o[_vm.optionKey] : o
            }
          }, [_vm._v("\n      " + _vm._s(_vm.optionText ? o[_vm.optionText] : o) + "\n    ")]);
        })], 2) : _c('div', {
          staticClass: "flex-1 flex flex-col"
        }, [_c('select', {
          class: _vm.selectClass,
          attrs: {
            "disabled": true
          },
          domProps: {
            "value": _vm.value
          }
        }, [_c('option', {
          key: _vm.value,
          domProps: {
            "value": _vm.value,
            "innerHTML": _vm._s(_vm.loading)
          }
        })])]), _vm._v(" "), _vm.showErrors ? _c('FormError', {
          attrs: {
            "errors": errors
          }
        }) : _vm._e()];
      }
    }])
  });
};

var __vue_staticRenderFns__$m = [];
/* style */

const __vue_inject_styles__$m = undefined;
/* scoped */

const __vue_scope_id__$m = "data-v-45b1bf3e";
/* module identifier */

const __vue_module_identifier__$m = undefined;
/* functional template */

const __vue_is_functional_template__$m = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$m = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$m,
  staticRenderFns: __vue_staticRenderFns__$m
}, __vue_inject_styles__$m, __vue_script__$l, __vue_scope_id__$m, __vue_is_functional_template__$m, __vue_module_identifier__$m, false, undefined, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$k = {
  name: "SideNav",
  props: {
    header: {
      type: String,
      required: true
    },
    links: {
      type: Array,
      required: true
    }
  }
};

/* script */
const __vue_script__$k = script$k;
/* template */

var __vue_render__$l = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('nav', {
    staticClass: "sidenav"
  }, [_c('h1', {
    staticClass: "sidenav__header"
  }, [_vm._v(_vm._s(_vm.header))]), _vm._v(" "), _vm._l(_vm.links, function (link, index) {
    return _c('router-link', {
      key: index,
      staticClass: "sidenav__link",
      attrs: {
        "to": link.to
      }
    }, [_vm._v("\n    " + _vm._s(link.value) + "\n  ")]);
  })], 2);
};

var __vue_staticRenderFns__$l = [];
/* style */

const __vue_inject_styles__$l = undefined;
/* scoped */

const __vue_scope_id__$l = undefined;
/* module identifier */

const __vue_module_identifier__$l = undefined;
/* functional template */

const __vue_is_functional_template__$l = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$l = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$l,
  staticRenderFns: __vue_staticRenderFns__$l
}, __vue_inject_styles__$l, __vue_script__$k, __vue_scope_id__$l, __vue_is_functional_template__$l, __vue_module_identifier__$l, false, undefined, undefined, undefined);

//
var script$j = {
  name: "Table",
  components: {
    SkeletonLine: __vue_component__$v
  },
  props: {
    align: String,
    columns: {
      required: true,
      type: Number
    }
  },
  computed: {
    alignClass() {
      return this.align && `align-${this.align}`;
    }

  }
};

/* script */
const __vue_script__$j = script$j;
/* template */

var __vue_render__$k = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "table-wrapper"
  }, [_c('table', {
    staticClass: "table table-auto",
    class: _vm.alignClass
  }, [_c('thead', [_c('tr', {
    staticClass: "bg-gray-100"
  }, [_vm._t("header")], 2)]), _vm._v(" "), _c('tbody', [_vm._t("body", function () {
    return [_c('tr', _vm._l(_vm.columns, function (index) {
      return _c('td', {
        key: index
      }, [_c('SkeletonLine')], 1);
    }), 0)];
  })], 2)])]);
};

var __vue_staticRenderFns__$k = [];
/* style */

const __vue_inject_styles__$k = undefined;
/* scoped */

const __vue_scope_id__$k = "data-v-7cb9bab7";
/* module identifier */

const __vue_module_identifier__$k = undefined;
/* functional template */

const __vue_is_functional_template__$k = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$k = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$k,
  staticRenderFns: __vue_staticRenderFns__$k
}, __vue_inject_styles__$k, __vue_script__$j, __vue_scope_id__$k, __vue_is_functional_template__$k, __vue_module_identifier__$k, false, undefined, undefined, undefined);

function isObject(obj) {
  return typeof obj === "object" && obj !== null;
}

function classKey(c) {
  var _Object$keys$1;

  if (!c) return;
  return isObject(c) ? (_Object$keys$1 = _Object$keys(c)) === null || _Object$keys$1 === void 0 ? void 0 : _Object$keys$1[0] : c;
}
function classKeysFromArray(keysAndObjects) {
  if (!keysAndObjects) return;

  const keys = _mapInstanceProperty(keysAndObjects).call(keysAndObjects, k => classKey(k));

  return keys;
} // if the item is a field at a lower level (e.g. a class has asked for it as
// one of it's fields), then the lower level should take precedence (meaning it
// inherits the superclasses values, but can override them), this is how
// inheritance works. `superclassFields` here will have already gone through
// this process, so may contain fields from any number of superclasses up the
// chain, that have already been merged in. this is because
// `getModuleClassValues` in our base module getters calls itself, which causes
// us to step through merging in superclasses infinitely (though it should
// never be infinite obviously if the ECF is setup correctly).

function mergeClassFields(fields, superclassFields) {
  const superclassMergedFields = {};

  if (superclassFields) {
    _Object$keys(superclassFields).forEach(k => {
      superclassMergedFields[k] = { ...superclassFields[k],
        ...(fields === null || fields === void 0 ? void 0 : fields[k])
      };
    });
  }

  return { ...fields,
    ...superclassMergedFields
  };
}
function classValues(c) {
  var _Object$values$1;

  return c && ((_Object$values$1 = _Object$values(c)) === null || _Object$values$1 === void 0 ? void 0 : _Object$values$1[0]);
}

var config = /*#__PURE__*/Object.freeze({
  __proto__: null,
  classKey: classKey,
  classKeysFromArray: classKeysFromArray,
  mergeClassFields: mergeClassFields,
  classValues: classValues
});

// src: https://stackoverflow.com/a/2175538/827129
function uniqueNumberString(length) {
  var _context;

  const multiplier = parseInt(_padEndInstanceProperty(_context = "1").call(_context, length, "0"));
  return Math.floor(Math.random() * 9 * multiplier) + 1 * multiplier;
}

function uniqueId(string) {
  const length = 12;
  return string ? `${string}-${uniqueNumberString(length)}` : uniqueNumberString(length).toString();
}

var jsonMixin = {
  computed: { ...mapGetters("base", ["getModuleClassByKey", "isSuperclass"]),

    _jsonPropStr() {
      return _JSON$stringify(this.jsonProp);
    },

    jsonPropKeys() {
      if (Array.isArray(this.jsonProp.body)) {
        var _context;

        return _mapInstanceProperty(_context = this.jsonProp.body).call(_context, (jsonItem, index) => {
          if (typeof jsonItem === "string") {
            return index;
          } else {
            return _Object$keys(jsonItem)[0];
          }
        });
      } else if (typeof this.jsonProp.body === "string") {
        return null;
      } else if (this.jsonProp.body) {
        return _Object$keys(this.jsonProp.body);
      }
    }

  },

  created() {
    typeof this.setJsonToPass === "function" && this.setJsonToPass();
  },

  data() {
    return {
      jsonToPass: {
        body: null,
        parentKey: null
      }
    };
  },

  methods: {
    getFieldProps(fieldKey) {
      var _this$itemValues, _this$itemValues$fiel;

      // if this item has fieldProps for this fieldKey, pass it
      // else if its been passed from the parent, pass it on
      // else just return an empty object, to stop destructuring later on from
      // blowing up
      return ((_this$itemValues = this.itemValues) === null || _this$itemValues === void 0 ? void 0 : (_this$itemValues$fiel = _this$itemValues.fields) === null || _this$itemValues$fiel === void 0 ? void 0 : _this$itemValues$fiel[fieldKey]) || this.fieldProps || {};
    },

    getJsonByKey(key) {
      var _this$jsonProp$body;

      return (_this$jsonProp$body = this.jsonProp.body) === null || _this$jsonProp$body === void 0 ? void 0 : _this$jsonProp$body[key];
    },

    globalUniqueId(name) {
      return uniqueId(name);
    }

  },
  props: {
    jsonProp: {
      required: true
    },
    viewMode: Boolean
  },
  watch: {
    // this hacky fix is needed to track changes between newVal and oldVal when
    // updating. this is needed for clearing a child Options dropdown when the
    // parent Options dropdown changes (e.g. change from `entity` to `media` in
    // Contacts module, should clear the child value (e.g. `Organisation` —>
    // `null`)`, see:
    // https://github.com/vuejs/vue/issues/2164#issuecomment-542766308
    _jsonPropStr(newValStr, oldValStr) {
      const newVal = JSON.parse(newValStr);
      const oldVal = JSON.parse(oldValStr); // if the parentKey has changed, reset the itemKey here (we don't want it
      // keeping the old value now it's parent has changed)

      if (this.hasOwnProperty("itemKey") && newVal.parentKey !== oldVal.parentKey) {
        this.itemKey = null;
      }
    },

    jsonProp: {
      deep: true,

      handler() {
        typeof this.setJsonToPass === "function" && this.setJsonToPass();
      }

    }
  }
};

var script$i = {
  name: "ConfigClass",
  mixins: [jsonMixin],
  props: {
    default_: String,
    fieldProps: Object,
    flattenItem: Boolean,
    isInArray: Boolean,
    item: Object,
    itemParent: Object
  },

  data() {
    return {
      baseClassTypes: ["arr", "num", "str"]
    };
  },

  computed: { ...mapGetters("base", ["getModuleClassByKey", "getModuleClassValues", "getModuleClassesBySuperclass", "isChildClassOfSuperclass", "isSuperclass"]),

    childClasses() {
      return this.getModuleClassesBySuperclass(this.itemKey);
    },

    classKeyToUse() {
      // if we're inside an array loop, don't pass the array again, instead add
      // an array item (currently we only support arrays of one type, which is
      // inferred from the `fields` option on that class)
      if (this.isInArray) {
        const itemFields = this.itemValues.fields;
        if (!itemFields) return;

        const firstItemField = _Object$keys(itemFields)[0];

        return firstItemField;
      } else {
        return this.itemValues.superclass;
      }
    },

    computedFieldProps() {
      return this.getFieldProps(this.itemKey);
    },

    isBaseType() {
      var _context;

      return _includesInstanceProperty(_context = this.baseClassTypes).call(_context, this.classKeyToUse);
    },

    isCustomComponentType() {
      var _context2;

      // if has component field we want to handle it as a component
      // or if the itemKey starts with `@`, then its a special NUM thing like a
      // Link that needs handling
      return !!this.itemValues.component || _startsWithInstanceProperty(_context2 = this.itemKey).call(_context2, "@");
    },

    isMapType() {
      return this.classKeyToUse === "map";
    },

    isModuleType() {
      return this.getModuleClassByKey(this.classKeyToUse);
    },

    itemKey() {
      return classKey(this.item);
    },

    itemValues() {
      return this.getModuleClassValues(this.item);
    }

  },
  methods: {
    // oldKeyVal is only emitted from an Options child, which is needed to
    // clear old values from the JSON structure
    jsonChanged(jsonBody, oldKeyVal) {
      this.$emit("json-changed", jsonBody, oldKeyVal);
    },

    setDefault(itemToPass) {
      const itemName = classValues(itemToPass).name;
      let default_ = classValues(this.item)[`${itemName}default_`];

      if (default_ === undefined) {
        var _classValues;

        const superclassDefault = (_classValues = classValues(this.getModuleClassByKey(classValues(this.item).superclass))) === null || _classValues === void 0 ? void 0 : _classValues[`${itemName}default_`];
        default_ = superclassDefault;
      }

      return default_;
    },

    setJsonToPass() {
      let jsonBodyToPass = null;

      if (this.jsonProp.body) {
        // if we're dealing with `root`, then the key won't exist as we don't
        // store this in the record MODL, so just pass down what we have
        if (this.itemKey === "root") {
          jsonBodyToPass = this.jsonProp.body;
        } else {
          var _context3, _context4;

          // otherwise, find the right part of our MODL to pass on down
          const hasMatchingKey = _includesInstanceProperty(_context3 = this.jsonPropKeys).call(_context3, this.itemKey);

          const propKeyWithItemKeyAsSuperclass = _findInstanceProperty(_context4 = this.jsonPropKeys).call(_context4, key => this.isChildClassOfSuperclass(key, this.itemKey));

          if (hasMatchingKey) {
            // if we have a jsonProp key that matches this itemKey, use that
            jsonBodyToPass = {
              [this.itemKey]: this.jsonProp.body[this.itemKey]
            };
          } else if (propKeyWithItemKeyAsSuperclass) {
            // else if we're dealing with a superclass, and pass that value
            // note we don't want to pass the contents of it, but it with its key
            // too, as if we're dealing with a superclass, then we still need the
            // class name itself to be passed down, not just the contents
            jsonBodyToPass = {
              [propKeyWithItemKeyAsSuperclass]: this.jsonProp.body[propKeyWithItemKeyAsSuperclass]
            };
          }
        }
      }

      this.$set(this.jsonToPass, "body", jsonBodyToPass);
      this.$set(this.jsonToPass, "parentKey", this.itemKey);
    }

  }
};

/* script */
const __vue_script__$i = script$i;
/* template */

var __vue_render__$j = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.isBaseType || _vm.isCustomComponentType ? _c('GlobalRecordEditorItemType', {
    attrs: {
      "field-props": _vm.computedFieldProps,
      "flatten-item": _vm.flattenItem,
      "item": _vm.item,
      "item-parent": _vm.itemParent,
      "json-prop": _vm.jsonToPass,
      "default_": _vm.default_,
      "view-mode": _vm.viewMode
    },
    on: {
      "json-changed": _vm.jsonChanged
    }
  }) : _vm.isModuleType || _vm.isMapType ? _c('div', [_vm.isSuperclass(_vm.itemKey) ? _c('GlobalRecordEditorOptions', {
    attrs: {
      "field-props": _vm.computedFieldProps,
      "item": _vm.item,
      "options": _vm.childClasses,
      "option-type-key": _vm.itemKey,
      "name": Math.random().toString(),
      "json-prop": _vm.jsonToPass,
      "parent-is-root": _vm.jsonProp.parentKey === 'root',
      "view-mode": _vm.viewMode
    },
    on: {
      "json-changed": _vm.jsonChanged
    }
  }) : _vm.itemValues && _vm.itemValues.fields ? _c('GlobalRecordEditorItemType', {
    attrs: {
      "field-props": _vm.computedFieldProps,
      "flatten-item": _vm.flattenItem,
      "item": _vm.item,
      "item-parent": _vm.itemParent,
      "json-prop": _vm.jsonToPass,
      "default_": _vm.default_,
      "view-mode": _vm.viewMode
    },
    on: {
      "json-changed": _vm.jsonChanged
    }
  }) : _vm._e()], 1) : _vm._e();
};

var __vue_staticRenderFns__$j = [];
/* style */

const __vue_inject_styles__$j = undefined;
/* scoped */

const __vue_scope_id__$j = undefined;
/* module identifier */

const __vue_module_identifier__$j = undefined;
/* functional template */

const __vue_is_functional_template__$j = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$j = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$j,
  staticRenderFns: __vue_staticRenderFns__$j
}, __vue_inject_styles__$j, __vue_script__$i, __vue_scope_id__$j, __vue_is_functional_template__$j, __vue_module_identifier__$j, false, undefined, undefined, undefined);

/* script */
/* template */

var __vue_render__$i = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "drag-handle__outer-wrapper"
  }, [_c('div', {
    staticClass: "drag-handle__inner-wrapper"
  }, [_c('div', {
    staticClass: "drag-handle"
  }, [_c('ion-icon', {
    staticClass: "drag-handle__icon",
    attrs: {
      "name": "ellipsis-vertical-outline"
    }
  }), _vm._v(" "), _c('ion-icon', {
    staticClass: "drag-handle__icon",
    attrs: {
      "name": "ellipsis-vertical-outline"
    }
  })], 1)])]);
};

var __vue_staticRenderFns__$i = [];
/* style */

const __vue_inject_styles__$i = undefined;
/* scoped */

const __vue_scope_id__$i = "data-v-5d52aa80";
/* module identifier */

const __vue_module_identifier__$i = undefined;
/* functional template */

const __vue_is_functional_template__$i = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$i = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$i,
  staticRenderFns: __vue_staticRenderFns__$i
}, __vue_inject_styles__$i, {}, __vue_scope_id__$i, __vue_is_functional_template__$i, __vue_module_identifier__$i, false, undefined, undefined, undefined);

var itemTypesMixin = {
  computed: { ...mapGetters("base", ["getModuleClassValues"]),

    itemValues() {
      return this.getModuleClassValues(this.item);
    },

    label() {
      return this.useParentOrValue("label");
    },

    name() {
      return this.itemValues.name;
    }

  },
  methods: {
    formatValueReadyToEmitIfInArray(value) {
      if (this.itemValues.superclass === "arr") {
        // if this string's parent is an Array, then just set the text
        // directly, we don't need to key it as the Array handles the keying
        return value;
      } else {
        return this.wrapInKey(value);
      }
    },

    useParentOrValue(value) {
      var _this$fieldProps, _classValues;

      const classValue = this.itemValues[value];
      const fieldPropsValue = (_this$fieldProps = this.fieldProps) === null || _this$fieldProps === void 0 ? void 0 : _this$fieldProps[value];
      if (!fieldPropsValue) return classValue;

      const useParentValue = _startsWithInstanceProperty(fieldPropsValue).call(fieldPropsValue, "<parent>");

      if (!useParentValue) return fieldPropsValue;
      const keyToUse = fieldPropsValue.split(">.")[1];
      const parentValue = (_classValues = classValues(this.itemParent)) === null || _classValues === void 0 ? void 0 : _classValues[keyToUse];
      return parentValue;
    },

    wrapInKey(value) {
      return {
        [classKey(this.item)]: value
      };
    }

  },
  props: {
    default_: String,
    fieldProps: Object,
    isInArray: Boolean,
    item: Object,
    itemParent: Object
  }
};

//
var script$h = {
  name: "ArrayItem",
  components: {
    DragHandle: __vue_component__$i,
    RemoveButton: __vue_component__$R
  },
  mixins: [itemTypesMixin, jsonMixin],
  props: {
    loopKey: Number
  },
  computed: {
    classes() {
      return !this.viewMode && "module-editor-group mb-4";
    }

  },
  methods: {
    jsonChanged(jsonBody) {
      this.$emit("json-changed", jsonBody, this.loopKey);
    },

    removeItem() {
      this.$emit("json-changed", null, this.loopKey);
    },

    setJsonToPass() {
      this.$set(this.jsonToPass, "body", this.getJsonByKey(this.loopKey));
      this.$set(this.jsonToPass, "parentKey", this.itemKey);
    }

  }
};

/* script */
const __vue_script__$h = script$h;
/* template */

var __vue_render__$h = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "drag-item flex items-start",
    class: _vm.classes
  }, [!_vm.viewMode ? _c('DragHandle') : _vm._e(), _vm._v(" "), _c('GlobalRecordEditorItemType', {
    staticClass: "flex-1 last:mb-0",
    attrs: {
      "is-in-array": true,
      "item": _vm.item,
      "item-parent": _vm.itemParent,
      "default_": _vm.default_,
      "view-mode": _vm.viewMode,
      "loop-key": _vm.loopKey,
      "json-prop": _vm.jsonToPass
    },
    on: {
      "json-changed": _vm.jsonChanged
    }
  }), _vm._v(" "), !_vm.viewMode ? _c('RemoveButton', {
    nativeOn: {
      "click": function ($event) {
        return _vm.removeItem.apply(null, arguments);
      }
    }
  }) : _vm._e()], 1);
};

var __vue_staticRenderFns__$h = [];
/* style */

const __vue_inject_styles__$h = undefined;
/* scoped */

const __vue_scope_id__$h = undefined;
/* module identifier */

const __vue_module_identifier__$h = undefined;
/* functional template */

const __vue_is_functional_template__$h = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$h = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$h,
  staticRenderFns: __vue_staticRenderFns__$h
}, __vue_inject_styles__$h, __vue_script__$h, __vue_scope_id__$h, __vue_is_functional_template__$h, __vue_module_identifier__$h, false, undefined, undefined, undefined);

var script$g = {
  name: "Array",
  components: {
    ArrayItem: __vue_component__$h,
    Button: __vue_component__$_,
    FormError: __vue_component__$X,
    ViewModeItem: __vue_component__$x,
    draggable
  },
  mixins: [itemTypesMixin, jsonMixin],

  data() {
    return {
      dragging: false,
      refreshKey: 0
    };
  },

  computed: { ...mapGetters("base", ["getModuleClassByKey", "getModuleClassesBySuperclass"]),
    array: {
      get() {
        return this.jsonProp.body;
      },

      set(newValue) {
        const updatedJson = {
          [this.itemKey]: newValue
        };
        this.$emit("json-changed", updatedJson);
        this.refreshKey = this.refreshKey + 1;
      }

    },

    dragOptions() {
      return {
        animation: 200,
        disabled: false,
        ghostClass: "ghost",
        group: "Array"
      };
    },

    itemKey() {
      return classKey(this.item);
    },

    rules() {
      var _this$fieldProps;

      return (_this$fieldProps = this.fieldProps) !== null && _this$fieldProps !== void 0 && _this$fieldProps.required ? "array" : "";
    }

  },
  methods: {
    addItem() {
      const updatedJson = {
        [this.itemKey]: [...(this.jsonProp.body || []), {} // add new empty object to end of json body
        ]
      };
      this.$emit("json-changed", updatedJson);
    },

    dynamicKey(index) {
      // this is used to tell Vue when it needs to refresh based on new data.
      // we want to handle more than just the index here, as when we delete an
      // item from the top, the index won't change for the first item (0), so
      // it won't update to reflect the new data from the item in that
      // position. we only want to update when an item is removed or added, so
      // we can use a combination of the length of the array and the index to
      // get a unique key that will only update when an item is removed or
      // added from the array
      // ^refactor: this currently reloads all items when a new item is added
      // to an array, which isn't necessary, so could be refactored to handle
      // this use case more elegantly
      return `${this.jsonProp.body.length}-${index}-${this.refreshKey}`;
    },

    jsonChanged(jsonBody, loopKey) {
      const updatedJson = {
        [this.itemKey]: this.jsonProp.body || []
      };

      if (jsonBody === null) {
        var _context;

        // when jsonBody === null, we have specifically set this with the
        // intention of removing this item from the array, so we do that here
        // (if we wanted to keep it, we'd have set jsonBody = {})
        _spliceInstanceProperty(_context = updatedJson[this.itemKey]).call(_context, loopKey, 1);
      } else {
        updatedJson[this.itemKey][loopKey] = jsonBody;
      }

      this.$emit("json-changed", updatedJson);
    },

    setJsonToPass() {
      this.$set(this.jsonToPass, "body", this.jsonProp.body);
      this.$set(this.jsonToPass, "parentKey", this.itemKey);
    }

  }
};

/* script */
const __vue_script__$g = script$g;
/* template */

var __vue_render__$g = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('ValidationProvider', {
    attrs: {
      "rules": _vm.rules,
      "name": _vm.name,
      "vid": _vm.globalUniqueId(_vm.name)
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (ref) {
        var errors = ref.errors;
        return [_vm.viewMode && _vm.jsonProp.body === null ? _c('ViewModeItem', {
          attrs: {
            "name": _vm.name
          }
        }) : _c('div', {
          staticClass: "module-editor-group"
        }, [_c('h2', {
          staticClass: "h4 mb-2 sentence-case"
        }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _vm.label && !_vm.viewMode ? _c('label', {
          staticClass: "mb-4"
        }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: _vm.jsonProp.body,
            expression: "jsonProp.body"
          }],
          attrs: {
            "type": "hidden"
          },
          domProps: {
            "value": _vm.jsonProp.body
          },
          on: {
            "input": function ($event) {
              if ($event.target.composing) {
                return;
              }

              _vm.$set(_vm.jsonProp, "body", $event.target.value);
            }
          }
        }), _vm._v(" "), _vm.jsonProp.body && Array.isArray(_vm.jsonProp.body) ? _c('draggable', _vm._b({
          staticClass: "last:mb-0 mb-4",
          attrs: {
            "handle": ".drag-handle__inner-wrapper"
          },
          on: {
            "start": function ($event) {
              _vm.dragging = true;
            },
            "end": function ($event) {
              _vm.dragging = false;
            }
          },
          model: {
            value: _vm.array,
            callback: function ($$v) {
              _vm.array = $$v;
            },
            expression: "array"
          }
        }, 'draggable', _vm.dragOptions, false), [_vm._l(_vm.jsonProp.body, function (jsonItem, index) {
          return [_c('ArrayItem', {
            key: _vm.dynamicKey(index),
            attrs: {
              "view-mode": _vm.viewMode,
              "item": _vm.item,
              "item-parent": _vm.itemParent,
              "loop-key": index,
              "json-prop": _vm.jsonToPass
            },
            on: {
              "json-changed": _vm.jsonChanged
            }
          })];
        })], 2) : _vm._e(), _vm._v(" "), !_vm.viewMode ? _c('Button', {
          staticClass: "mb-4",
          attrs: {
            "variant": "small"
          },
          nativeOn: {
            "click": function ($event) {
              $event.preventDefault();
              return _vm.addItem.apply(null, arguments);
            }
          }
        }, [_vm._v("\n      + add another\n    ")]) : _vm._e(), _vm._v(" "), _c('FormError', {
          attrs: {
            "errors": errors
          }
        })], 1)];
      }
    }])
  });
};

var __vue_staticRenderFns__$g = [];
/* style */

const __vue_inject_styles__$g = undefined;
/* scoped */

const __vue_scope_id__$g = undefined;
/* module identifier */

const __vue_module_identifier__$g = undefined;
/* functional template */

const __vue_is_functional_template__$g = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$g = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$g,
  staticRenderFns: __vue_staticRenderFns__$g
}, __vue_inject_styles__$g, __vue_script__$g, __vue_scope_id__$g, __vue_is_functional_template__$g, __vue_module_identifier__$g, false, undefined, undefined, undefined);

const GET_DATA_COUNTRIES = "GET_DATA_COUNTRIES";
var script$f = {
  name: "Country",
  components: {
    FormCountry: __vue_component__$P,
    ViewModeItem: __vue_component__$x
  },
  mixins: [itemTypesMixin, jsonMixin],
  props: {
    rules: String
  },

  data() {
    return {
      value: null
    };
  },

  computed: { ...mapState({
      countries: state => state.base.data.countries
    }),

    viewModeValue() {
      var _this$countries, _this$countries$find;

      return ((_this$countries = this.countries) === null || _this$countries === void 0 ? void 0 : (_this$countries$find = _findInstanceProperty(_this$countries).call(_this$countries, c => c.code === this.value)) === null || _this$countries$find === void 0 ? void 0 : _this$countries$find.name) || this.value;
    }

  },

  created() {
    !this.countries && this.GET_DATA_COUNTRIES();
  },

  watch: {
    jsonProp: {
      deep: true,

      handler(newVal) {
        if (typeof newVal.body !== "string" || newVal.body === "") return;
        this.value = newVal.body;
      },

      immediate: true
    },

    value(newVal) {
      const formattedVal = this.formatValueReadyToEmitIfInArray(newVal);
      this.$emit("json-changed", formattedVal);
    }

  },
  methods: { ...mapActions("base", [GET_DATA_COUNTRIES])
  }
};

/* script */
const __vue_script__$f = script$f;
/* template */

var __vue_render__$f = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.viewMode ? _c('ViewModeItem', {
    attrs: {
      "name": _vm.name,
      "value": _vm.viewModeValue
    }
  }) : _c('FormCountry', {
    attrs: {
      "id": "country",
      "key-to-use": "code",
      "label": _vm.itemValues && _vm.itemValues.label,
      "rules": _vm.rules
    },
    model: {
      value: _vm.value,
      callback: function ($$v) {
        _vm.value = $$v;
      },
      expression: "value"
    }
  });
};

var __vue_staticRenderFns__$f = [];
/* style */

const __vue_inject_styles__$f = undefined;
/* scoped */

const __vue_scope_id__$f = undefined;
/* module identifier */

const __vue_module_identifier__$f = undefined;
/* functional template */

const __vue_is_functional_template__$f = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$f = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$f,
  staticRenderFns: __vue_staticRenderFns__$f
}, __vue_inject_styles__$f, __vue_script__$f, __vue_scope_id__$f, __vue_is_functional_template__$f, __vue_module_identifier__$f, false, undefined, undefined, undefined);

//
var script$e = {
  name: "Dropdown",
  components: {
    FormError: __vue_component__$X,
    SearchableSelect: __vue_component__$Q,
    ViewModeItem: __vue_component__$x
  },
  mixins: [itemTypesMixin, jsonMixin],
  props: {
    showErrors: {
      default: true,
      type: Boolean
    },
    type: String,
    useLabelForErrors: {
      default: true,
      type: Boolean
    },
    vid: String
  },

  data() {
    return {
      json: {},
      value: ""
    };
  },

  computed: {
    id() {
      return `${classValues(this.item).name}-${Math.random()}`;
    },

    placeholder() {
      return this.useParentOrValue("placeholder") || "Please select an option";
    },

    providerName() {
      return this.useLabelForErrors && this.label ? this.label : "This field";
    },

    rules() {
      var _this$fieldProps;

      return (_this$fieldProps = this.fieldProps) !== null && _this$fieldProps !== void 0 && _this$fieldProps.required ? "required" : "";
    }

  },
  watch: {
    jsonProp: {
      deep: true,

      handler(newVal) {
        // update the input whenever the jsonProp changes
        this.value = newVal.body;
      },

      immediate: true
    },

    value(newVal) {
      const formattedVal = this.formatValueReadyToEmitIfInArray(newVal);
      this.$emit("json-changed", formattedVal);
    }

  },
  methods: {
    inputRemoved() {
      this.$emit("json-changed", null);
    },

    setJsonToPass() {
      if (this.jsonProp.body === null) {
        this.input = "";
      }
    }

  }
};

/* script */
const __vue_script__$e = script$e;
/* template */

var __vue_render__$e = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.viewMode ? _c('ViewModeItem', {
    attrs: {
      "name": _vm.name,
      "value": _vm.value
    }
  }) : _c('ValidationProvider', {
    staticClass: "mb-4",
    attrs: {
      "rules": _vm.rules,
      "name": _vm.providerName,
      "tag": "div",
      "vid": _vm.vid
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (ref) {
        var errors = ref.errors;
        return [_vm.label && !_vm.viewMode ? _c('label', [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _c('SearchableSelect', {
          staticClass: "mb-0",
          attrs: {
            "id": _vm.id,
            "options": _vm.itemValues.options,
            "option-output": function (o) {
              return o;
            },
            "rules": _vm.rules,
            "placeholder": _vm.placeholder
          },
          model: {
            value: _vm.value,
            callback: function ($$v) {
              _vm.value = $$v;
            },
            expression: "value"
          }
        }), _vm._v(" "), _vm.showErrors && errors && errors.length ? _c('FormError', {
          attrs: {
            "errors": errors
          }
        }) : _vm._e()];
      }
    }])
  });
};

var __vue_staticRenderFns__$e = [];
/* style */

const __vue_inject_styles__$e = undefined;
/* scoped */

const __vue_scope_id__$e = undefined;
/* module identifier */

const __vue_module_identifier__$e = undefined;
/* functional template */

const __vue_is_functional_template__$e = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$e = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$e,
  staticRenderFns: __vue_staticRenderFns__$e
}, __vue_inject_styles__$e, __vue_script__$e, __vue_scope_id__$e, __vue_is_functional_template__$e, __vue_module_identifier__$e, false, undefined, undefined, undefined);

//
var script$d = {
  name: "Descriptor",
  components: {
    Select: __vue_component__$m
  },
  props: {
    descriptors: Array,
    value: String
  },

  data() {
    return {
      uniqueId
    };
  }

};

/* script */
const __vue_script__$d = script$d;
/* template */

var __vue_render__$d = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('Select', {
    staticClass: "inline-flex",
    attrs: {
      "value": _vm.value,
      "options": _vm.descriptors,
      "option-key": "key",
      "option-text": "name",
      "disable-default": true,
      "label": "Day",
      "show-label": false,
      "select-text": "Select day",
      "id": _vm.uniqueId('hour-descriptor'),
      "rules": "required"
    },
    on: {
      "input": function (val) {
        return _vm.$emit('input', val);
      }
    }
  });
};

var __vue_staticRenderFns__$d = [];
/* style */

const __vue_inject_styles__$d = undefined;
/* scoped */

const __vue_scope_id__$d = undefined;
/* module identifier */

const __vue_module_identifier__$d = undefined;
/* functional template */

const __vue_is_functional_template__$d = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$d = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$d,
  staticRenderFns: __vue_staticRenderFns__$d
}, __vue_inject_styles__$d, __vue_script__$d, __vue_scope_id__$d, __vue_is_functional_template__$d, __vue_module_identifier__$d, false, undefined, undefined, undefined);

//
var script$c = {
  name: "OptionType",
  components: {
    Select: __vue_component__$m
  },
  props: {
    optionTypes: Array,
    value: String
  },

  data() {
    return {
      uniqueId
    };
  }

};

/* script */
const __vue_script__$c = script$c;
/* template */

var __vue_render__$c = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('Select', {
    staticClass: "inline-flex",
    attrs: {
      "value": _vm.value,
      "options": _vm.optionTypes,
      "option-key": "key",
      "option-text": "name",
      "disable-default": true,
      "label": "Opening options",
      "show-label": false,
      "select-text": "When are you open?",
      "id": _vm.uniqueId('hours-options'),
      "rules": "required"
    },
    on: {
      "input": function (val) {
        return _vm.$emit('input', val);
      }
    }
  });
};

var __vue_staticRenderFns__$c = [];
/* style */

const __vue_inject_styles__$c = undefined;
/* scoped */

const __vue_scope_id__$c = undefined;
/* module identifier */

const __vue_module_identifier__$c = undefined;
/* functional template */

const __vue_is_functional_template__$c = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$c = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$c,
  staticRenderFns: __vue_staticRenderFns__$c
}, __vue_inject_styles__$c, __vue_script__$c, __vue_scope_id__$c, __vue_is_functional_template__$c, __vue_module_identifier__$c, false, undefined, undefined, undefined);

// the string `0-0`, which would pass up to the top of our JSON, and then pass
// back down, setting the value to `Closed` (as `0-0` means closed), so
// selecting the `Set times` option would never work

const HOUR_END_DEFAULT = null;
const HOUR_START_DEFAULT = null;
var script$b = {
  name: "TimeRange",
  components: {
    Input: __vue_component__$M,
    RemoveButton: __vue_component__$R
  },
  props: {
    isOnlyRange: Boolean,
    value: String
  },

  data() {
    return {
      endId: uniqueId("hourEnd"),
      hourEnd: HOUR_END_DEFAULT,
      hourStart: HOUR_START_DEFAULT,
      startId: uniqueId("hourStart")
    };
  },

  computed: {
    formattedRange() {
      if (!this.hourStart || !this.hourEnd) return null;
      return `${this.formatTime(this.hourStart)}-${this.formatTime(this.hourEnd)}`;
    }

  },
  watch: {
    formattedRange: {
      handler(newVal) {
        this.$emit("input", newVal);
      },

      immediate: true
    },
    value: {
      handler(newVal) {
        this.parseRange(newVal);
      },

      immediate: true
    }
  },
  methods: {
    formatTime(time) {
      let formattedTime = time;
      const onTheHour = _sliceInstanceProperty(time).call(time, -2) === "00";

      if (onTheHour) {
        const hourPart = time.split(":")[0];
        formattedTime = hourPart;
      } else {
        formattedTime = formattedTime.replace(":", ".");
      }

      const firstChar = formattedTime.charAt(0);

      if (firstChar === "0") {
        formattedTime = formattedTime.substr(1);
      }

      return formattedTime;
    },

    parseRange(range) {
      // this function parses a shorthand string (e.g. `9-17.30`) and
      // sets the values of `hourStart` to `09:00` and `hourEnd` to
      // `17:30`. this is needed so that when an item is deleted from
      // the array, and the value then gets updated here, to update the
      // start and end times for the new value. it's also needed to handle
      // editing an existing hours string
      if (range === null || range === "") {
        this.hourStart = HOUR_START_DEFAULT;
        this.hourEnd = HOUR_END_DEFAULT;
      } else {
        const rangeParts = range.split("-");
        rangeParts.forEach((part, index) => {
          const containsMinutes = _includesInstanceProperty(part).call(part, ".");

          if (!containsMinutes) {
            part += ":00";
          } else {
            part = part.replace(".", ":");
          }

          if (part.length === 4) part = `0${part}`;
          rangeParts[index] = part;
        });
        this.hourStart = rangeParts[0];
        this.hourEnd = rangeParts[1];
      }
    },

    removeItem() {
      this.$emit("removed");
    }

  }
};

/* script */
const __vue_script__$b = script$b;
/* template */

var __vue_render__$b = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "flex items-center"
  }, [_c('Input', {
    staticClass: "mb-0",
    attrs: {
      "type": "time",
      "id": _vm.startId,
      "vid": _vm.startId,
      "rules": "required",
      "label": "Start time",
      "show-label": false
    },
    model: {
      value: _vm.hourStart,
      callback: function ($$v) {
        _vm.hourStart = $$v;
      },
      expression: "hourStart"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "px-2"
  }, [_vm._v("\n    –\n  ")]), _vm._v(" "), _c('Input', {
    staticClass: "mb-0",
    attrs: {
      "type": "time",
      "id": _vm.endId,
      "vid": _vm.endId,
      "rules": "required",
      "label": "End time",
      "show-label": false
    },
    model: {
      value: _vm.hourEnd,
      callback: function ($$v) {
        _vm.hourEnd = $$v;
      },
      expression: "hourEnd"
    }
  }), _vm._v(" "), !_vm.isOnlyRange ? _c('RemoveButton', {
    nativeOn: {
      "click": function ($event) {
        return _vm.removeItem.apply(null, arguments);
      }
    }
  }) : _vm._e()], 1);
};

var __vue_staticRenderFns__$b = [];
/* style */

const __vue_inject_styles__$b = undefined;
/* scoped */

const __vue_scope_id__$b = undefined;
/* module identifier */

const __vue_module_identifier__$b = undefined;
/* functional template */

const __vue_is_functional_template__$b = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$b = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$b,
  staticRenderFns: __vue_staticRenderFns__$b
}, __vue_inject_styles__$b, __vue_script__$b, __vue_scope_id__$b, __vue_is_functional_template__$b, __vue_module_identifier__$b, false, undefined, undefined, undefined);

//
var script$a = {
  name: "TimeRanges",
  components: {
    Spacer: __vue_component__$r,
    TimeRange: __vue_component__$b
  },
  props: {
    value: Array
  },

  data() {
    return {
      updatedRanges: this.value
    };
  },

  computed: {
    allRangesValid() {
      return this.value.every(val => val !== "");
    }

  },
  watch: {
    updatedRanges(newVal) {
      this.$emit("input", newVal);
    },

    value(newVal) {
      this.updatedRanges = newVal;
    }

  },
  methods: {
    addRange() {
      this.$emit("input", [...this.updatedRanges, ""]);
    },

    itemRemoved(index) {
      this.$delete(this.value, index);
      this.$emit("input", this.value);
    }

  }
};

/* script */
const __vue_script__$a = script$a;
/* template */

var __vue_render__$a = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('Spacer', {
    staticClass: "flex flex-wrap items-center"
  }, _vm._l(_vm.value, function (range, index) {
    return _c('TimeRange', {
      key: index,
      attrs: {
        "is-only-range": _vm.value.length === 1
      },
      on: {
        "removed": function () {
          return _vm.itemRemoved(index);
        }
      },
      model: {
        value: _vm.updatedRanges[index],
        callback: function ($$v) {
          _vm.$set(_vm.updatedRanges, index, $$v);
        },
        expression: "updatedRanges[index]"
      }
    });
  }), 1), _vm._v(" "), _vm.allRangesValid ? _c('div', {
    staticClass: "mt-2"
  }, [_c('a', {
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.addRange.apply(null, arguments);
      }
    }
  }, [_vm._v("\n      Add another session\n    ")])]) : _vm._e()], 1);
};

var __vue_staticRenderFns__$a = [];
/* style */

const __vue_inject_styles__$a = undefined;
/* scoped */

const __vue_scope_id__$a = undefined;
/* module identifier */

const __vue_module_identifier__$a = undefined;
/* functional template */

const __vue_is_functional_template__$a = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$a = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$a,
  staticRenderFns: __vue_staticRenderFns__$a
}, __vue_inject_styles__$a, __vue_script__$a, __vue_scope_id__$a, __vue_is_functional_template__$a, __vue_module_identifier__$a, false, undefined, undefined, undefined);

const {
  VUE_APP_NAME: VUE_APP_NAME$1
} = process.env;
const defaultTimeRanges = [""];
var script$9 = {
  name: "Hours",
  components: {
    Descriptor: __vue_component__$d,
    OptionType: __vue_component__$c,
    Spacer: __vue_component__$r,
    TimeRanges: __vue_component__$a,
    ViewModeItem: __vue_component__$x
  },
  mixins: [itemTypesMixin, jsonMixin],

  data() {
    return {
      descriptorKey: VUE_APP_NAME$1 === "empire" ? "wd" : null,
      descriptors: [{
        key: "d",
        name: "Every day"
      }, {
        key: "wd",
        name: "Weekdays"
      }, {
        key: "we",
        name: "Weekend"
      }, {
        key: "1",
        name: "Monday"
      }, {
        key: "2",
        name: "Tuesday"
      }, {
        key: "3",
        name: "Wednesday"
      }, {
        key: "4",
        name: "Thursday"
      }, {
        key: "5",
        name: "Friday"
      }, {
        key: "6",
        name: "Saturday"
      }, {
        key: "7",
        name: "Sunday"
      }],
      input: "",
      json: {},
      optionType: VUE_APP_NAME$1 === "empire" ? "set" : null,
      optionTypes: [{
        key: "set",
        name: "Set times"
      }, {
        key: "open24",
        name: "Open 24 hours"
      }, {
        key: "closed",
        name: "Closed"
      }],
      timeRanges: VUE_APP_NAME$1 === "empire" ? ["9-17"] : defaultTimeRanges
    };
  },

  computed: {
    output() {
      const allRangesValid = this.timeRanges.every(val => val !== "");

      if (!this.descriptorKey || this.optionType === "set" && !allRangesValid) {
        // return an empty string if the item isn't valid. normally we would
        // return null here, but this causes an issue as it makes the parent
        // hours array remove the item, which is not what we want to do here
        return "";
      }

      let times;
      if (this.optionType === "set") times = this.timeRanges;else if (this.optionType === "open24") times = "0-24";else if (this.optionType === "closed") times = "0-0";
      const newOutput = `${this.descriptorKey}@${times}`;
      return this.formatValueReadyToEmitIfInArray(newOutput);
    },

    viewModeOutput() {
      var _context, _context2, _context3;

      const descriptorName = _findInstanceProperty(_context = this.descriptors).call(_context, d => d.key === this.descriptorKey).name;

      let times;
      if (this.timeRanges.length === 1 && this.timeRanges[0] === "0-24") times = _findInstanceProperty(_context2 = this.optionTypes).call(_context2, o => o.key === "open24").name;else if (this.timeRanges.length === 1 && this.timeRanges[0] === "0-0") times = _findInstanceProperty(_context3 = this.optionTypes).call(_context3, o => o.key === "closed").name;else times = this.timeRanges;
      const newOutput = `${descriptorName} @ ${times}`;
      return this.formatValueReadyToEmitIfInArray(newOutput);
    }

  },
  watch: {
    jsonProp: {
      deep: true,

      handler(newVal) {
        // newVal.body might be an empty object (default) or an empty string
        // (user has cleared the input in this hours instance), if either are
        // true, don't do anything
        if (typeof newVal.body !== "string" || newVal.body === "") return;
        const hoursItemSplit = newVal.body.split("@");
        const [descriptorPart, timeRangesPart] = hoursItemSplit;
        const times = timeRangesPart.split(",");
        this.descriptorKey = descriptorPart;

        if (times.length === 1 && times[0] === "0-24") {
          this.optionType = "open24";
        } else if (times.length === 1 && times[0] === "0-0") {
          this.optionType = "closed";
        } else if (times.length) {
          this.optionType = "set";
        }

        this.timeRanges = times;
      },

      immediate: true
    },

    optionType(newVal) {
      if (newVal === "set") {
        // if the new value is set, then we need to reset timeRanges, as
        // otherwise it'll keep it as the old value (e.g. open = `0-24`) and
        // this will then set the dropdown to be "Open 24 hours" again)
        this.timeRanges = defaultTimeRanges;
      }
    },

    output(newVal) {
      this.$emit("json-changed", newVal);
    }

  }
};

/* script */
const __vue_script__$9 = script$9;
/* template */

var __vue_render__$9 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.viewMode ? _c('ViewModeItem', {
    attrs: {
      "name": _vm.isInArray ? null : _vm.name,
      "value": _vm.viewModeOutput
    }
  }) : _c('div', [_c('Spacer', [_c('Descriptor', {
    attrs: {
      "descriptors": _vm.descriptors
    },
    model: {
      value: _vm.descriptorKey,
      callback: function ($$v) {
        _vm.descriptorKey = $$v;
      },
      expression: "descriptorKey"
    }
  }), _vm._v(" "), _c('OptionType', {
    attrs: {
      "option-types": _vm.optionTypes
    },
    model: {
      value: _vm.optionType,
      callback: function ($$v) {
        _vm.optionType = $$v;
      },
      expression: "optionType"
    }
  }), _vm._v(" "), _vm.optionType === 'set' ? _c('TimeRanges', {
    model: {
      value: _vm.timeRanges,
      callback: function ($$v) {
        _vm.timeRanges = $$v;
      },
      expression: "timeRanges"
    }
  }) : _vm._e()], 1)], 1);
};

var __vue_staticRenderFns__$9 = [];
/* style */

const __vue_inject_styles__$9 = undefined;
/* scoped */

const __vue_scope_id__$9 = undefined;
/* module identifier */

const __vue_module_identifier__$9 = undefined;
/* functional template */

const __vue_is_functional_template__$9 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9,
  staticRenderFns: __vue_staticRenderFns__$9
}, __vue_inject_styles__$9, __vue_script__$9, __vue_scope_id__$9, __vue_is_functional_template__$9, __vue_module_identifier__$9, false, undefined, undefined, undefined);

const getModuleName = (modules, module) => {
  return modules !== null && modules !== void 0 && modules[module] ? modules[module].name : "0";
};

const convertBreakdownToNumUri = ({
  numId,
  module,
  path
}) => {
  const numIdPart = numId || "";
  const modulePart = module ? `:${module}` : "";
  const pathPart = path ? path : "";
  return `num://${numIdPart}${modulePart}${pathPart}`;
};
const getNumUri = numRecord => {
  var _numRecord$numId;

  let host, userinfo;

  if (((_numRecord$numId = numRecord.numId) === null || _numRecord$numId === void 0 ? void 0 : _includesInstanceProperty(_numRecord$numId)) === "@") {
    const numIdNameParts = numRecord.numId.split("@");
    userinfo = numIdNameParts[0];
    host = numIdNameParts[1];
  } else {
    host = numRecord.numId;
  }

  return buildNumUri(host, numRecord.module, userinfo ? userinfo : "", numRecord.path);
};

const getRelativeNumUriString = (baseUri, targetUri) => {
  const isSameBase = baseUri.port.n === targetUri.port.n && baseUri.host.s === targetUri.host.s && baseUri.userinfo.s === targetUri.userinfo.s && baseUri.protocol === targetUri.protocol;

  if (isSameBase) {
    return resolvePath(baseUri.path.s, targetUri.path.s);
  } else {
    return targetUri.toString();
  }
};

const getRelativeNumUriStringFromRecords = (linkNumRecord, currentRecord) => {
  const linkNumUri = getNumUri(linkNumRecord);
  if (!currentRecord) return `num://${linkNumUri.toString()}`;
  const currentNumUri = getNumUri(currentRecord);
  const relativeNumUriString = getRelativeNumUriString(currentNumUri, linkNumUri);
  return relativeNumUriString;
};

var num = /*#__PURE__*/Object.freeze({
  __proto__: null,
  convertBreakdownToNumUri: convertBreakdownToNumUri,
  getNumUri: getNumUri,
  getRelativeNumUriStringFromRecords: getRelativeNumUriStringFromRecords
});

/** FOR THIS COMPONENT TO ENABLE LINKING TO OTHER RECORDS, WE NEED:
 * 1. the current record (if editing/viewing) to be in the vuex store at
 `session/records`
 * 2. the records to show as options for linking to be in the vuex store at
 `session/records`
 * 3. if editing/viewing, to have a query string of `recordId` or
 `recordShortId` in the url
 */

var script$8 = {
  name: "Link",
  components: {
    SearchableSelect: __vue_component__$Q,
    SkeletonLine: __vue_component__$v
  },
  mixins: [itemTypesMixin, jsonMixin],
  props: {
    isInArray: Boolean
  },

  data() {
    return {
      Deselect: __vue_component__$S,
      OpenIndicator: {
        render: createElement => createElement("span", "")
      },
      id: this.globalUniqueId(),
      json: {},
      value: null
    };
  },

  computed: { ...mapState("session", ["numIdName", "record", "records"]),

    isReady() {
      const {
        recordId,
        recordShortId
      } = this.$route.params; // don't attempt to get all the records if we aren't in a view that has
      // access to them (e.g. we're at `/tools/editor` or `/record-editor`

      return recordShortId || recordId ? this.records : true;
    },

    orderedFilteredAndFormattedNumRecords() {
      var _this$records;

      if (!((_this$records = this.records) !== null && _this$records !== void 0 && _this$records.data)) return;
      const moduleParam = this.$route.params.moduleId;
      let thisNumRecordModule = moduleParam;
      let numRecordsWithoutThisRecord = this.records.data;

      if (this.record) {
        var _context;

        thisNumRecordModule = this.record.module;
        numRecordsWithoutThisRecord = _filterInstanceProperty(_context = this.records.data).call(_context, record => record.id !== this.record.id);
      }

      const enrichedNumRecords = _mapInstanceProperty(numRecordsWithoutThisRecord).call(numRecordsWithoutThisRecord, record => this.enrichNumRecord(record));

      const thisModulesNumRecords = _filterInstanceProperty(enrichedNumRecords).call(enrichedNumRecords, record => record.module === thisNumRecordModule);

      const otherModulesNumRecords = _filterInstanceProperty(enrichedNumRecords).call(enrichedNumRecords, record => record.module !== thisNumRecordModule);

      const orderedOtherModulesNumRecord = _orderBy(otherModulesNumRecords, ["module", "path"], ["asc", "asc"]);

      return [...(thisModulesNumRecords || []), ...(orderedOtherModulesNumRecord || [])];
    }

  },
  watch: {
    jsonProp: {
      deep: true,

      handler(newVal) {
        // don't run immediately, as the `records` watcher handles setting
        // up the correct value from the NUM records, just run this if jsonProp
        // changes again after load
        this.handleJsonProp(newVal);
      }

    },
    records: {
      handler() {
        // when the NUM records have loaded, parse the jsonProp body again to set
        // the correct value. run immediately, in case the value has already
        // returned from cache
        this.handleJsonProp();
      },

      immediate: true
    },

    value(newVal) {
      const formattedVal = this.formatValueReadyToEmitIfInArray(newVal);
      this.$emit("json-changed", formattedVal);
    }

  },
  methods: {
    enrichNumRecord(record) {
      return { ...record,
        numUrl: getRelativeNumUriStringFromRecords(record, this.record)
      };
    },

    handleJsonProp(newVal) {
      // if called from the watcher, use value passed to make sure it's the
      // latest, else reference the prop directly
      let value = newVal || this.jsonProp;
      if (typeof value.body !== "string" || value.body === "") return;
      this.value = value.body;
    },

    optionModuleName(option) {
      return getModuleName(this.numModules, option.module);
    }

  }
};

/* script */
const __vue_script__$8 = script$8;
/* template */

var __vue_render__$8 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.viewMode ? _c('div', {
    staticClass: "mb-2"
  }, [_vm._v("\n  value:\n  "), _vm.value ? _c('strong', {
    domProps: {
      "innerHTML": _vm._s(_vm.value)
    }
  }) : _c('em', {
    staticClass: "opacity-50"
  }, [_vm._v("blank")])]) : _c('div', [!_vm.isInArray && _vm.label ? _c('label', {
    attrs: {
      "for": _vm.id
    }
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _vm.isReady ? [_c('SearchableSelect', {
    attrs: {
      "id": _vm.id,
      "options": _vm.orderedFilteredAndFormattedNumRecords,
      "option-output": function (o) {
        return _vm.optionModuleName(o) + ": " + o.friendlyName + " - " + o.numUrl;
      },
      "custom-allowed": true,
      "custom-prefix-option": {
        description: 'Enter NUM URI',
        value: 'num://'
      },
      "value-key": "numUrl"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (ref) {
        var option = ref.option;
        return [_c('div', {
          staticClass: "option"
        }, [option.friendlyName ? _c('h4', {
          staticClass: "mb-0"
        }, [_c('span', {
          staticClass: "opacity-50"
        }, [_vm._v(" " + _vm._s(_vm.optionModuleName(option)) + ": ")]), _vm._v("\n            " + _vm._s(option.friendlyName) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('span', {
          staticClass: "opacity-75"
        }, [_vm._v(_vm._s(option.numUrl))])])];
      }
    }], null, false, 1680541230),
    model: {
      value: _vm.value,
      callback: function ($$v) {
        _vm.value = $$v;
      },
      expression: "value"
    }
  })] : _c('SkeletonLine')], 2);
};

var __vue_staticRenderFns__$8 = [];
/* style */

const __vue_inject_styles__$8 = undefined;
/* scoped */

const __vue_scope_id__$8 = undefined;
/* module identifier */

const __vue_module_identifier__$8 = undefined;
/* functional template */

const __vue_is_functional_template__$8 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8,
  staticRenderFns: __vue_staticRenderFns__$8
}, __vue_inject_styles__$8, __vue_script__$8, __vue_scope_id__$8, __vue_is_functional_template__$8, __vue_module_identifier__$8, false, undefined, undefined, undefined);

const isEmptyObject = obj => {
  return obj && _Object$entries(obj).length === 0 && obj.constructor === Object || false;
};
const isJsonString = str => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }

  return true;
};

var typeOf = /*#__PURE__*/Object.freeze({
  __proto__: null,
  isEmptyObject: isEmptyObject,
  isJsonString: isJsonString
});

var script$7 = {
  name: "Map",
  components: {
    ViewModeItem: __vue_component__$x
  },
  mixins: [itemTypesMixin, jsonMixin],
  props: {
    flattenItem: Boolean
  },
  computed: { ...mapGetters("base", ["getModuleClassByKey", "getModuleClassesBySuperclass"]),

    classes() {
      return !this.displayMinimal && "module-editor-group";
    },

    displayMinimal() {
      return this.itemKey === "root" || this.isInArray || this.flattenItem;
    },

    firstAssign() {
      var _assign$;

      const assign = this.itemValues.assign;
      const firstAssign = assign === null || assign === void 0 ? void 0 : (_assign$ = assign[0]) === null || _assign$ === void 0 ? void 0 : _assign$[0];
      return firstAssign;
    },

    firstAssignWithoutWildcard() {
      var _this$firstAssign;

      return (_this$firstAssign = this.firstAssign) === null || _this$firstAssign === void 0 ? void 0 : _sliceInstanceProperty(_this$firstAssign).call(_this$firstAssign, 0, -1);
    },

    itemKey() {
      return classKey(this.item);
    },

    orderedFieldKeys() {
      let fields; // if using assign (`*assign=[[class*]]`) then use the assign value, not
      // the value from the ECF's fields file, to specify what child to show
      // here

      if (this.useAssign) {
        var _classValues;

        const fieldModuleClass = this.getModuleClassByKey(this.firstAssignWithoutWildcard);
        fields = (_classValues = classValues(fieldModuleClass)) === null || _classValues === void 0 ? void 0 : _classValues.fields;
      } else {
        fields = this.itemValues.fields;
      }

      const fieldKeys = _Object$keys(fields);

      const orderedKeys = fieldKeys.sort((a, b) => this.getPriority(b) - this.getPriority(a));
      return orderedKeys;
    },

    useAssign() {
      var _this$firstAssign2;

      const firstAssignIsWildcard = (_this$firstAssign2 = this.firstAssign) === null || _this$firstAssign2 === void 0 ? void 0 : _endsWithInstanceProperty(_this$firstAssign2).call(_this$firstAssign2, "*");
      return firstAssignIsWildcard;
    }

  },
  methods: {
    // this method handles getting the right key to remove, as the key passed
    // up may not match any of our jsonPropKeys. in this case we're dealing
    // with a superclass being removed, so we need to go find the class to
    // remove by looking at which of our values has that item as its
    // superclass, and removing that. we also go up ~infinitely as we may have
    // multiple nested superclasses to loop through
    getClassKeyToRemove(ck) {
      var _context;

      if (_includesInstanceProperty(_context = this.jsonPropKeys).call(_context, ck)) {
        return ck;
      } else {
        var _context2;

        const keyToRemove = _findInstanceProperty(_context2 = this.jsonPropKeys).call(_context2, key => {
          const itemClass = this.getModuleClassByKey(key);
          const itemClassValues = classValues(itemClass);
          const itemSuperclass = itemClassValues === null || itemClassValues === void 0 ? void 0 : itemClassValues.superclass;

          if (itemSuperclass === ck) {
            return key;
          } else {
            // call this method itself recurringly, to loop through
            // superclasses until we find the key we need to remove
            return this.getClassKeyToRemove(key);
          }
        });

        return keyToRemove;
      }
    },

    getKey(index) {
      return `${classKey(this.orderedFieldKeys[index])}-${index}`;
    },

    getPriority(key) {
      var _this$itemValues, _this$itemValues$fiel;

      return ((_this$itemValues = this.itemValues) === null || _this$itemValues === void 0 ? void 0 : (_this$itemValues$fiel = _this$itemValues.fields[key]) === null || _this$itemValues$fiel === void 0 ? void 0 : _this$itemValues$fiel.priority) || 0;
    },

    // oldKeyVal is only emitted from an Options grandchild (ConfigClass
    // child), which is needed to clear old values from the JSON structure
    jsonChanged(jsonBody, oldKeyVal) {
      let jsonToEmit;

      if (isEmptyObject(jsonBody)) {
        jsonToEmit = this.removeDeletedItemFromJson(this.jsonProp.body, oldKeyVal);
      } else {
        jsonToEmit = { ...this.jsonProp.body,
          ...jsonBody
        };
      } // if we're dealing with root, we don't want to wrap it in `root: {...}`
      // but instead just pass it up as is
      // also, if we're dealing with an item that has had `flattenItem` passed
      // as a prop (e.g. one of the recent parent's is using `assign=val*` to
      // say they want `val` to be directly embedded inside the MODL, without
      // the key) then don't wrap in the key


      if (this.itemKey !== "root" && !this.flattenItem) {
        jsonToEmit = this.formatValueReadyToEmitIfInArray(jsonToEmit);
      }

      this.$emit("json-changed", jsonToEmit);
    },

    removeDeletedItemFromJson(json, oldKeyVal) {
      const keyToRemove = this.getClassKeyToRemove(oldKeyVal);
      this.$delete(json, keyToRemove);
      return json;
    },

    setJsonToPass() {
      this.$set(this.jsonToPass, "body", this.jsonProp.body);
      this.$set(this.jsonToPass, "parentKey", this.itemKey);
    }

  }
};

/* script */
const __vue_script__$7 = script$7;
/* template */

var __vue_render__$7 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.viewMode && _vm.jsonProp.body === null ? _c('ViewModeItem', {
    attrs: {
      "name": _vm.name,
      "value": null
    }
  }) : _c('div', {
    class: _vm.classes
  }, [!_vm.displayMinimal ? [_c('h2', {
    staticClass: "h4 mb-2 sentence-case"
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _vm.label && !_vm.viewMode ? _c('label', {
    staticClass: "mb-4"
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e()] : _vm._e(), _vm._v(" "), _vm._l(_vm.orderedFieldKeys, function (key, index) {
    return [_vm.getModuleClassByKey(key) ? _c('GlobalRecordEditorConfigClass', {
      key: _vm.getKey(index),
      attrs: {
        "field-props": _vm.getFieldProps(key),
        "flatten-item": _vm.useAssign,
        "item": _vm.getModuleClassByKey(key),
        "item-parent": _vm.item,
        "view-mode": _vm.viewMode,
        "json-prop": _vm.jsonToPass
      },
      on: {
        "json-changed": _vm.jsonChanged
      }
    }) : _c('GlobalRecordEditorItemType', {
      key: _vm.getKey(index),
      attrs: {
        "field-props": _vm.getFieldProps(key),
        "item": _vm.item,
        "item-parent": _vm.itemParent,
        "view-mode": _vm.viewMode,
        "flatten-item": _vm.useAssign,
        "json-prop": _vm.jsonToPass
      },
      on: {
        "json-changed": _vm.jsonChanged
      }
    })];
  })], 2);
};

var __vue_staticRenderFns__$7 = [];
/* style */

const __vue_inject_styles__$7 = undefined;
/* scoped */

const __vue_scope_id__$7 = undefined;
/* module identifier */

const __vue_module_identifier__$7 = undefined;
/* functional template */

const __vue_is_functional_template__$7 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7,
  staticRenderFns: __vue_staticRenderFns__$7
}, __vue_inject_styles__$7, __vue_script__$7, __vue_scope_id__$7, __vue_is_functional_template__$7, __vue_module_identifier__$7, false, undefined, undefined, undefined);

//
var script$6 = {
  name: "String",
  components: {
    Input: __vue_component__$M,
    ViewModeItem: __vue_component__$x
  },
  mixins: [itemTypesMixin, jsonMixin],
  props: {
    type: String
  },

  data() {
    return {
      input: "",
      json: {}
    };
  },

  computed: {
    id() {
      return `${classValues(this.item).name}-${Math.random()}`;
    },

    placeholder() {
      return this.useParentOrValue("placeholder");
    },

    prefix() {
      return this.useParentOrValue("prefix");
    },

    rules() {
      var _this$fieldProps;

      return (_this$fieldProps = this.fieldProps) !== null && _this$fieldProps !== void 0 && _this$fieldProps.required ? "required" : "";
    }

  },
  watch: {
    input(newVal) {
      const parsedVal = newVal !== "" && this.type === "number" ? parseInt(newVal, 10) : newVal;
      const formattedVal = this.formatValueReadyToEmitIfInArray(parsedVal);
      this.$emit("json-changed", formattedVal);
    },

    jsonProp: {
      deep: true,

      handler(newVal) {
        // update the input whenever the jsonProp changes
        this.setInput(newVal);
      },

      immediate: true
    }
  },
  methods: {
    inputRemoved() {
      this.$emit("json-changed", null);
    },

    isClassType(type) {
      return classValues(this.item).type === type;
    },

    setInput(newVal) {
      this.input = typeof newVal.body === "string" || typeof newVal.body === "number" ? newVal.body : "";
    },

    setJsonToPass() {
      if (this.jsonProp.body === null) {
        this.input = "";
      }
    }

  }
};

/* script */
const __vue_script__$6 = script$6;
/* template */

var __vue_render__$6 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.viewMode ? _c('ViewModeItem', {
    attrs: {
      "name": _vm.name,
      "value": _vm.input,
      "prefix": _vm.prefix
    }
  }) : _c('Input', {
    attrs: {
      "show-remove-button": _vm.isInArray,
      "type": _vm.type,
      "id": _vm.id,
      "label": _vm.label,
      "show-label": !_vm.isInArray,
      "use-label-for-errors": false,
      "placeholder": _vm.placeholder,
      "prefix": _vm.prefix,
      "rules": _vm.rules,
      "vid": _vm.globalUniqueId(_vm.name)
    },
    on: {
      "remove": _vm.inputRemoved
    },
    nativeOn: {
      "keydown": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }

        $event.preventDefault();
      }
    },
    model: {
      value: _vm.input,
      callback: function ($$v) {
        _vm.input = $$v;
      },
      expression: "input"
    }
  });
};

var __vue_staticRenderFns__$6 = [];
/* style */

const __vue_inject_styles__$6 = undefined;
/* scoped */

const __vue_scope_id__$6 = undefined;
/* module identifier */

const __vue_module_identifier__$6 = undefined;
/* functional template */

const __vue_is_functional_template__$6 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6,
  staticRenderFns: __vue_staticRenderFns__$6
}, __vue_inject_styles__$6, __vue_script__$6, __vue_scope_id__$6, __vue_is_functional_template__$6, __vue_module_identifier__$6, false, undefined, undefined, undefined);

//
var script$5 = {
  name: "Number",
  components: {
    TypeString: __vue_component__$6
  },
  mixins: [itemTypesMixin, jsonMixin],
  props: {
    jsonProp: Object
  },
  methods: {
    jsonChanged(jsonBody) {
      this.$emit("json-changed", jsonBody);
    },

    setJsonToPass() {
      this.$set(this.jsonToPass, "body", this.jsonProp.body);
      this.$set(this.jsonToPass, "parentKey", this.itemKey);
    }

  }
};

/* script */
const __vue_script__$5 = script$5;
/* template */

var __vue_render__$5 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('TypeString', {
    attrs: {
      "is-in-array": _vm.isInArray,
      "default_": _vm.default_,
      "item": _vm.item,
      "field-props": _vm.fieldProps,
      "view-mode": _vm.viewMode,
      "json-prop": _vm.jsonToPass,
      "type": "number"
    },
    on: {
      "json-changed": _vm.jsonChanged
    }
  });
};

var __vue_staticRenderFns__$5 = [];
/* style */

const __vue_inject_styles__$5 = undefined;
/* scoped */

const __vue_scope_id__$5 = undefined;
/* module identifier */

const __vue_module_identifier__$5 = undefined;
/* functional template */

const __vue_is_functional_template__$5 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5,
  staticRenderFns: __vue_staticRenderFns__$5
}, __vue_inject_styles__$5, __vue_script__$5, __vue_scope_id__$5, __vue_is_functional_template__$5, __vue_module_identifier__$5, false, undefined, undefined, undefined);

//
var script$4 = {
  name: "Textarea",
  components: {
    FormTextarea: __vue_component__$B,
    ViewModeItem: __vue_component__$x
  },
  mixins: [itemTypesMixin, jsonMixin],
  props: {
    type: String
  },

  data() {
    return {
      input: "",
      json: {}
    };
  },

  computed: {
    id() {
      return `${classValues(this.item).name}-${Math.random()}`;
    },

    placeholder() {
      return this.useParentOrValue("placeholder");
    },

    prefix() {
      return this.useParentOrValue("prefix");
    },

    rules() {
      var _this$fieldProps;

      return (_this$fieldProps = this.fieldProps) !== null && _this$fieldProps !== void 0 && _this$fieldProps.required ? "required" : "";
    }

  },
  watch: {
    input(newVal) {
      const convertedVal = this.convertValueReadyToEmit(newVal);
      const formattedVal = this.wrapInKey(convertedVal);
      this.$emit("json-changed", formattedVal);
    },

    jsonProp: {
      deep: true,

      handler(newVal) {
        // update the input whenever the jsonProp changes
        this.setInput(newVal);
      },

      immediate: true
    }
  },
  methods: {
    convertValueFromProp(value) {
      // convert array of new lines into a textarea version with new line chars
      return Array.isArray(value) ? value.join("\n") : value;
    },

    convertValueReadyToEmit(value) {
      // create an array, split on new line chars as we want to store this in
      // the DNS like so: `key[line1;line2]`
      return value === null || value === void 0 ? void 0 : value.split(/(?:\r\n|\r|\n)/g);
    },

    isClassType(type) {
      return classValues(this.item).type === type;
    },

    parseInput(input) {
      return input.replace(/\n/g, "<br />");
    },

    setInput(newVal) {
      const convertedVal = this.convertValueFromProp(newVal.body);
      this.input = typeof convertedVal === "string" || typeof convertedVal === "number" ? convertedVal : "";
    },

    setJsonToPass() {
      if (this.jsonProp.body === null) {
        this.input = "";
      }
    }

  }
};

/* script */
const __vue_script__$4 = script$4;
/* template */

var __vue_render__$4 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.viewMode ? _c('ViewModeItem', {
    attrs: {
      "own-line": true,
      "name": _vm.name,
      "value": _vm.parseInput(_vm.input),
      "prefix": _vm.prefix
    }
  }) : _c('FormTextarea', {
    attrs: {
      "id": _vm.id,
      "label": _vm.label,
      "use-label-for-errors": false,
      "placeholder": _vm.placeholder,
      "rules": _vm.rules,
      "vid": _vm.globalUniqueId(_vm.name),
      "rows": "4"
    },
    model: {
      value: _vm.input,
      callback: function ($$v) {
        _vm.input = $$v;
      },
      expression: "input"
    }
  });
};

var __vue_staticRenderFns__$4 = [];
/* style */

const __vue_inject_styles__$4 = undefined;
/* scoped */

const __vue_scope_id__$4 = undefined;
/* module identifier */

const __vue_module_identifier__$4 = undefined;
/* functional template */

const __vue_is_functional_template__$4 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4,
  staticRenderFns: __vue_staticRenderFns__$4
}, __vue_inject_styles__$4, __vue_script__$4, __vue_scope_id__$4, __vue_is_functional_template__$4, __vue_module_identifier__$4, false, undefined, undefined, undefined);

/* eslint vue/sort-keys: 0 */
var timezoneLocations = [{
  id: "1",
  name: "Europe/Andorra",
  iso_country: "AD",
  location_code: "AD",
  description: "Andorra",
  country_name: "Andorra"
}, {
  id: "2",
  name: "Asia/Dubai",
  iso_country: "AE",
  location_code: "DXB",
  description: "Dubai",
  country_name: "United Arab Emirates"
}, {
  id: "3",
  name: "Asia/Kabul",
  iso_country: "AF",
  location_code: "KBL",
  description: "Kabul",
  country_name: "Afghanistan"
}, {
  id: "4",
  name: "America/Antigua",
  iso_country: "AG",
  location_code: "ANU",
  description: "Antigua",
  country_name: "Antigua and Barbuda"
}, {
  id: "5",
  name: "America/Anguilla",
  iso_country: "AI",
  location_code: "AXA",
  description: "Anguilla",
  country_name: "Anguilla"
}, {
  id: "6",
  name: "Europe/Tirane",
  iso_country: "AL",
  location_code: "TIA",
  description: "Tirane",
  country_name: "Albania"
}, {
  id: "7",
  name: "Asia/Yerevan",
  iso_country: "AM",
  location_code: "EVN",
  description: "Yerevan",
  country_name: "Armenia"
}, {
  id: "8",
  name: "Africa/Luanda",
  iso_country: "AO",
  location_code: "LAD",
  description: "Luanda",
  country_name: "Angola"
}, {
  id: "9",
  name: "Antarctica/Casey",
  iso_country: "AQ",
  location_code: "CSY",
  description: "Casey",
  country_name: "Antarctica"
}, {
  id: "10",
  name: "Antarctica/Davis",
  iso_country: "AQ",
  location_code: "DAV",
  description: "Davis",
  country_name: "Antarctica"
}, {
  id: "11",
  name: "Antarctica/DumontDUrville",
  iso_country: "AQ",
  location_code: "DDU",
  description: "DumontDUrville",
  country_name: "Antarctica"
}, {
  id: "12",
  name: "Antarctica/Mawson",
  iso_country: "AQ",
  location_code: "MWN",
  description: "Mawson",
  country_name: "Antarctica"
}, {
  id: "13",
  name: "Antarctica/McMurdo",
  iso_country: "AQ",
  location_code: "MCM",
  description: "McMurdo",
  country_name: "Antarctica"
}, {
  id: "14",
  name: "Antarctica/Palmer",
  iso_country: "AQ",
  location_code: "PLM",
  description: "Palmer",
  country_name: "Antarctica"
}, {
  id: "15",
  name: "Antarctica/Rothera",
  iso_country: "AQ",
  location_code: "ROT",
  description: "Rothera",
  country_name: "Antarctica"
}, {
  id: "16",
  name: "Antarctica/Syowa",
  iso_country: "AQ",
  location_code: "SYW",
  description: "Syowa",
  country_name: "Antarctica"
}, {
  id: "17",
  name: "Antarctica/Troll",
  iso_country: "AQ",
  location_code: "TRL",
  description: "Troll",
  country_name: "Antarctica"
}, {
  id: "18",
  name: "Antarctica/Vostok",
  iso_country: "AQ",
  location_code: "VOS",
  description: "Vostok",
  country_name: "Antarctica"
}, {
  id: "19",
  name: "America/Argentina/Buenos_Aires",
  iso_country: "AR",
  location_code: "BUE",
  description: "Buenos Aires",
  country_name: "Argentina"
}, {
  id: "20",
  name: "America/Argentina/Catamarca",
  iso_country: "AR",
  location_code: "CTC",
  description: "Catamarca",
  country_name: "Argentina"
}, {
  id: "21",
  name: "America/Argentina/Cordoba",
  iso_country: "AR",
  location_code: "COR",
  description: "Cordoba",
  country_name: "Argentina"
}, {
  id: "22",
  name: "America/Argentina/Jujuy",
  iso_country: "AR",
  location_code: "JUJ",
  description: "Jujuy",
  country_name: "Argentina"
}, {
  id: "23",
  name: "America/Argentina/La_Rioja",
  iso_country: "AR",
  location_code: "IRJ",
  description: "La Rioja",
  country_name: "Argentina"
}, {
  id: "24",
  name: "America/Argentina/Mendoza",
  iso_country: "AR",
  location_code: "MDZ",
  description: "Mendoza",
  country_name: "Argentina"
}, {
  id: "25",
  name: "America/Argentina/Rio_Gallegos",
  iso_country: "AR",
  location_code: "RGL",
  description: "Rio Gallegos",
  country_name: "Argentina"
}, {
  id: "26",
  name: "America/Argentina/Salta",
  iso_country: "AR",
  location_code: "SLA",
  description: "Salta",
  country_name: "Argentina"
}, {
  id: "27",
  name: "America/Argentina/San_Juan",
  iso_country: "AR",
  location_code: "UAQ",
  description: "San Juan",
  country_name: "Argentina"
}, {
  id: "28",
  name: "America/Argentina/San_Luis",
  iso_country: "AR",
  location_code: "LUQ",
  description: "San Luis",
  country_name: "Argentina"
}, {
  id: "29",
  name: "America/Argentina/Tucuman",
  iso_country: "AR",
  location_code: "TUC",
  description: "Tucuman",
  country_name: "Argentina"
}, {
  id: "30",
  name: "America/Argentina/Ushuaia",
  iso_country: "AR",
  location_code: "USH",
  description: "Ushuaia",
  country_name: "Argentina"
}, {
  id: "31",
  name: "Pacific/Pago_Pago",
  iso_country: "AS",
  location_code: "PPG",
  description: "Pago Pago",
  country_name: "American Samoa"
}, {
  id: "32",
  name: "Europe/Vienna",
  iso_country: "AT",
  location_code: "VIE",
  description: "Vienna",
  country_name: "Austria"
}, {
  id: "33",
  name: "Australia/Macquarie",
  iso_country: "AU",
  location_code: "PQQ",
  description: "Macquarie",
  country_name: "Australia"
}, {
  id: "34",
  name: "Australia/Adelaide",
  iso_country: "AU",
  location_code: "ADL",
  description: "Adelaide",
  country_name: "Australia"
}, {
  id: "35",
  name: "Australia/Brisbane",
  iso_country: "AU",
  location_code: "BNE",
  description: "Brisbane",
  country_name: "Australia"
}, {
  id: "36",
  name: "Australia/Broken_Hill",
  iso_country: "AU",
  location_code: "BHQ",
  description: "Broken Hill",
  country_name: "Australia"
}, {
  id: "37",
  name: "Australia/Currie",
  iso_country: "AU",
  location_code: "CRI",
  description: "Currie",
  country_name: "Australia"
}, {
  id: "38",
  name: "Australia/Darwin",
  iso_country: "AU",
  location_code: "DRW",
  description: "Darwin",
  country_name: "Australia"
}, {
  id: "39",
  name: "Australia/Eucla",
  iso_country: "AU",
  location_code: "EUC",
  description: "Eucla",
  country_name: "Australia"
}, {
  id: "40",
  name: "Australia/Hobart",
  iso_country: "AU",
  location_code: "HBA",
  description: "Hobart",
  country_name: "Australia"
}, {
  id: "41",
  name: "Australia/Lindeman",
  iso_country: "AU",
  location_code: "LDC",
  description: "Lindeman",
  country_name: "Australia"
}, {
  id: "42",
  name: "Australia/Lord_Howe",
  iso_country: "AU",
  location_code: "LDH",
  description: "Lord Howe",
  country_name: "Australia"
}, {
  id: "43",
  name: "Australia/Melbourne",
  iso_country: "AU",
  location_code: "MEL",
  description: "Melbourne",
  country_name: "Australia"
}, {
  id: "44",
  name: "Australia/Perth",
  iso_country: "AU",
  location_code: "PER",
  description: "Perth",
  country_name: "Australia"
}, {
  id: "45",
  name: "Australia/Sydney",
  iso_country: "AU",
  location_code: "SYD",
  description: "Sydney",
  country_name: "Australia"
}, {
  id: "46",
  name: "America/Aruba",
  iso_country: "AW",
  location_code: "AUA",
  description: "Aruba",
  country_name: "Aruba"
}, {
  id: "47",
  name: "Europe/Mariehamn",
  iso_country: "AX",
  location_code: "MHQ",
  description: "Mariehamn",
  country_name: "Åland Islands"
}, {
  id: "48",
  name: "Asia/Baku",
  iso_country: "AZ",
  location_code: "BAK",
  description: "Baku",
  country_name: "Azerbaijan"
}, {
  id: "49",
  name: "Europe/Sarajevo",
  iso_country: "BA",
  location_code: "SJJ",
  description: "Sarajevo",
  country_name: "Bosnia and Herzegovina"
}, {
  id: "50",
  name: "America/Barbados",
  iso_country: "BB",
  location_code: "BB",
  description: "Barbados",
  country_name: "Barbados"
}, {
  id: "51",
  name: "Asia/Dhaka",
  iso_country: "BD",
  location_code: "DAC",
  description: "Dhaka",
  country_name: "Bangladesh"
}, {
  id: "52",
  name: "Europe/Brussels",
  iso_country: "BE",
  location_code: "BRU",
  description: "Brussels",
  country_name: "Belgium"
}, {
  id: "53",
  name: "Africa/Ouagadougou",
  iso_country: "BF",
  location_code: "OUA",
  description: "Ouagadougou",
  country_name: "Burkina Faso"
}, {
  id: "54",
  name: "Europe/Sofia",
  iso_country: "BG",
  location_code: "SOF",
  description: "Sofia",
  country_name: "Bulgaria"
}, {
  id: "55",
  name: "Asia/Bahrain",
  iso_country: "BH",
  location_code: "BAH",
  description: "Bahrain",
  country_name: "Bahrain"
}, {
  id: "56",
  name: "Africa/Bujumbura",
  iso_country: "BI",
  location_code: "BJM",
  description: "Bujumbura",
  country_name: "Burundi"
}, {
  id: "57",
  name: "Africa/Porto-Novo",
  iso_country: "BJ",
  location_code: "PTN",
  description: "Porto-Novo",
  country_name: "Benin"
}, {
  id: "58",
  name: "America/St_Barthelemy",
  iso_country: "BL",
  location_code: "SBH",
  description: "St Barthelemy",
  country_name: "Saint Barthélemy"
}, {
  id: "59",
  name: "Atlantic/Bermuda",
  iso_country: "BM",
  location_code: "BM",
  description: "Bermuda",
  country_name: "Bermuda"
}, {
  id: "60",
  name: "Asia/Brunei",
  iso_country: "BN",
  location_code: "BN",
  description: "Brunei",
  country_name: "Brunei Darussalam"
}, {
  id: "61",
  name: "America/La_Paz",
  iso_country: "BO",
  location_code: "LPB",
  description: "La Paz",
  country_name: "Bolivia, Plurinational State of"
}, {
  id: "62",
  name: "America/Kralendijk",
  iso_country: "BQ",
  location_code: "KRA",
  description: "Kralendijk",
  country_name: "Bonaire, Sint Eustatius and Saba"
}, {
  id: "63",
  name: "America/Araguaina",
  iso_country: "BR",
  location_code: "AUX",
  description: "Araguaina",
  country_name: "Brazil"
}, {
  id: "64",
  name: "America/Bahia",
  iso_country: "BR",
  location_code: "BIA",
  description: "Bahia",
  country_name: "Brazil"
}, {
  id: "65",
  name: "America/Belem",
  iso_country: "BR",
  location_code: "BEL",
  description: "Belem",
  country_name: "Brazil"
}, {
  id: "66",
  name: "America/Boa_Vista",
  iso_country: "BR",
  location_code: "BVB",
  description: "Boa Vista",
  country_name: "Brazil"
}, {
  id: "67",
  name: "America/Campo_Grande",
  iso_country: "BR",
  location_code: "CGR",
  description: "Campo Grande",
  country_name: "Brazil"
}, {
  id: "68",
  name: "America/Cuiaba",
  iso_country: "BR",
  location_code: "CGB",
  description: "Cuiaba",
  country_name: "Brazil"
}, {
  id: "69",
  name: "America/Eirunepe",
  iso_country: "BR",
  location_code: "ERN",
  description: "Eirunepe",
  country_name: "Brazil"
}, {
  id: "70",
  name: "America/Fortaleza",
  iso_country: "BR",
  location_code: "FOR",
  description: "Fortaleza",
  country_name: "Brazil"
}, {
  id: "71",
  name: "America/Maceio",
  iso_country: "BR",
  location_code: "MCZ",
  description: "Maceio",
  country_name: "Brazil"
}, {
  id: "72",
  name: "America/Manaus",
  iso_country: "BR",
  location_code: "MAO",
  description: "Manaus",
  country_name: "Brazil"
}, {
  id: "73",
  name: "America/Noronha",
  iso_country: "BR",
  location_code: "FEN",
  description: "Noronha",
  country_name: "Brazil"
}, {
  id: "74",
  name: "America/Porto_Velho",
  iso_country: "BR",
  location_code: "PVH",
  description: "Porto Velho",
  country_name: "Brazil"
}, {
  id: "75",
  name: "America/Recife",
  iso_country: "BR",
  location_code: "REC",
  description: "Recife",
  country_name: "Brazil"
}, {
  id: "76",
  name: "America/Rio_Branco",
  iso_country: "BR",
  location_code: "RBR",
  description: "Rio Branco",
  country_name: "Brazil"
}, {
  id: "77",
  name: "America/Santarem",
  iso_country: "BR",
  location_code: "STM",
  description: "Santarem",
  country_name: "Brazil"
}, {
  id: "78",
  name: "America/Sao_Paulo",
  iso_country: "BR",
  location_code: "SAO",
  description: "Sao Paulo",
  country_name: "Brazil"
}, {
  id: "79",
  name: "America/Nassau",
  iso_country: "BS",
  location_code: "NAS",
  description: "Nassau",
  country_name: "Bahamas"
}, {
  id: "80",
  name: "Asia/Thimphu",
  iso_country: "BT",
  location_code: "THI",
  description: "Thimphu",
  country_name: "Bhutan"
}, {
  id: "81",
  name: "Africa/Gaborone",
  iso_country: "BW",
  location_code: "GBE",
  description: "Gaborone",
  country_name: "Botswana"
}, {
  id: "82",
  name: "Europe/Minsk",
  iso_country: "BY",
  location_code: "MSQ",
  description: "Minsk",
  country_name: "Belarus"
}, {
  id: "83",
  name: "America/Belize",
  iso_country: "BZ",
  location_code: "BZ",
  description: "Belize",
  country_name: "Belize"
}, {
  id: "84",
  name: "America/Atikokan",
  iso_country: "CA",
  location_code: "YIB",
  description: "Atikokan",
  country_name: "Canada"
}, {
  id: "85",
  name: "America/Blanc-Sablon",
  iso_country: "CA",
  location_code: "YBX",
  description: "Blanc-Sablon",
  country_name: "Canada"
}, {
  id: "86",
  name: "America/Cambridge_Bay",
  iso_country: "CA",
  location_code: "YCB",
  description: "Cambridge Bay",
  country_name: "Canada"
}, {
  id: "87",
  name: "America/Creston",
  iso_country: "CA",
  location_code: "CFQ",
  description: "Creston",
  country_name: "Canada"
}, {
  id: "88",
  name: "America/Dawson",
  iso_country: "CA",
  location_code: "YDA",
  description: "Dawson",
  country_name: "Canada"
}, {
  id: "89",
  name: "America/Dawson_Creek",
  iso_country: "CA",
  location_code: "YDQ",
  description: "Dawson Creek",
  country_name: "Canada"
}, {
  id: "90",
  name: "America/Edmonton",
  iso_country: "CA",
  location_code: "EDM",
  description: "Edmonton",
  country_name: "Canada"
}, {
  id: "91",
  name: "America/Fort_Nelson",
  iso_country: "CA",
  location_code: "FNE",
  description: "Fort Nelson",
  country_name: "Canada"
}, {
  id: "92",
  name: "America/Glace_Bay",
  iso_country: "CA",
  location_code: "GLB",
  description: "Glace Bay",
  country_name: "Canada"
}, {
  id: "93",
  name: "America/Goose_Bay",
  iso_country: "CA",
  location_code: "GOO",
  description: "Goose Bay",
  country_name: "Canada"
}, {
  id: "94",
  name: "America/Halifax",
  iso_country: "CA",
  location_code: "HAL",
  description: "Halifax",
  country_name: "Canada"
}, {
  id: "95",
  name: "America/Inuvik",
  iso_country: "CA",
  location_code: "YEV",
  description: "Inuvik",
  country_name: "Canada"
}, {
  id: "96",
  name: "America/Iqaluit",
  iso_country: "CA",
  location_code: "IQL",
  description: "Iqaluit",
  country_name: "Canada"
}, {
  id: "97",
  name: "America/Moncton",
  iso_country: "CA",
  location_code: "MNT",
  description: "Moncton",
  country_name: "Canada"
}, {
  id: "98",
  name: "America/Nipigon",
  iso_country: "CA",
  location_code: "NPG",
  description: "Nipigon",
  country_name: "Canada"
}, {
  id: "99",
  name: "America/Pangnirtung",
  iso_country: "CA",
  location_code: "PNT",
  description: "Pangnirtung",
  country_name: "Canada"
}, {
  id: "100",
  name: "America/Rainy_River",
  iso_country: "CA",
  location_code: "RRV",
  description: "Rainy River",
  country_name: "Canada"
}, {
  id: "101",
  name: "America/Rankin_Inlet",
  iso_country: "CA",
  location_code: "RIT",
  description: "Rankin Inlet",
  country_name: "Canada"
}, {
  id: "102",
  name: "America/Regina",
  iso_country: "CA",
  location_code: "REG",
  description: "Regina",
  country_name: "Canada"
}, {
  id: "103",
  name: "America/Resolute",
  iso_country: "CA",
  location_code: "REB",
  description: "Resolute",
  country_name: "Canada"
}, {
  id: "104",
  name: "America/St_Johns",
  iso_country: "CA",
  location_code: "YYT",
  description: "St Johns",
  country_name: "Canada"
}, {
  id: "105",
  name: "America/Swift_Current",
  iso_country: "CA",
  location_code: "YYN",
  description: "Swift Current",
  country_name: "Canada"
}, {
  id: "106",
  name: "America/Thunder_Bay",
  iso_country: "CA",
  location_code: "THU",
  description: "Thunder Bay",
  country_name: "Canada"
}, {
  id: "107",
  name: "America/Toronto",
  iso_country: "CA",
  location_code: "TOR",
  description: "Toronto",
  country_name: "Canada"
}, {
  id: "108",
  name: "America/Vancouver",
  iso_country: "CA",
  location_code: "VAN",
  description: "Vancouver",
  country_name: "Canada"
}, {
  id: "109",
  name: "America/Whitehorse",
  iso_country: "CA",
  location_code: "YXY",
  description: "Whitehorse",
  country_name: "Canada"
}, {
  id: "110",
  name: "America/Winnipeg",
  iso_country: "CA",
  location_code: "WNP",
  description: "Winnipeg",
  country_name: "Canada"
}, {
  id: "111",
  name: "America/Yellowknife",
  iso_country: "CA",
  location_code: "YZF",
  description: "Yellowknife",
  country_name: "Canada"
}, {
  id: "112",
  name: "Indian/Cocos",
  iso_country: "CC",
  location_code: "CCK",
  description: "Cocos",
  country_name: "Cocos (Keeling) Islands"
}, {
  id: "113",
  name: "Africa/Kinshasa",
  iso_country: "CD",
  location_code: "FIH",
  description: "Kinshasa",
  country_name: "Congo, the Democratic Republic of the"
}, {
  id: "114",
  name: "Africa/Lubumbashi",
  iso_country: "CD",
  location_code: "FBM",
  description: "Lubumbashi",
  country_name: "Congo, the Democratic Republic of the"
}, {
  id: "115",
  name: "Africa/Bangui",
  iso_country: "CF",
  location_code: "BGF",
  description: "Bangui",
  country_name: "Central African Republic"
}, {
  id: "116",
  name: "Africa/Brazzaville",
  iso_country: "CG",
  location_code: "BZV",
  description: "Brazzaville",
  country_name: "Congo"
}, {
  id: "117",
  name: "Europe/Zurich",
  iso_country: "CH",
  location_code: "ZRH",
  description: "Zurich",
  country_name: "Switzerland"
}, {
  id: "118",
  name: "Africa/Abidjan",
  iso_country: "CI",
  location_code: "ABJ",
  description: "Abidjan",
  country_name: "Côte d'Ivoire"
}, {
  id: "119",
  name: "Pacific/Rarotonga",
  iso_country: "CK",
  location_code: "RAR",
  description: "Rarotonga",
  country_name: "Cook Islands"
}, {
  id: "120",
  name: "America/Punta_Arenas",
  iso_country: "CL",
  location_code: "PUQ",
  description: "Punta Arenas",
  country_name: "Chile"
}, {
  id: "121",
  name: "America/Santiago",
  iso_country: "CL",
  location_code: "SCL",
  description: "Santiago",
  country_name: "Chile"
}, {
  id: "122",
  name: "Pacific/Easter",
  iso_country: "CL",
  location_code: "IPC",
  description: "Easter",
  country_name: "Chile"
}, {
  id: "123",
  name: "Africa/Douala",
  iso_country: "CM",
  location_code: "DLA",
  description: "Douala",
  country_name: "Cameroon"
}, {
  id: "124",
  name: "Asia/Shanghai",
  iso_country: "CN",
  location_code: "SGH",
  description: "Shanghai",
  country_name: "China"
}, {
  id: "125",
  name: "Asia/Urumqi",
  iso_country: "CN",
  location_code: "URM",
  description: "Urumqi",
  country_name: "China"
}, {
  id: "126",
  name: "America/Bogota",
  iso_country: "CO",
  location_code: "BOG",
  description: "Bogota",
  country_name: "Colombia"
}, {
  id: "127",
  name: "America/Costa_Rica",
  iso_country: "CR",
  location_code: "CR",
  description: "Costa Rica",
  country_name: "Costa Rica"
}, {
  id: "128",
  name: "America/Havana",
  iso_country: "CU",
  location_code: "HAV",
  description: "Havana",
  country_name: "Cuba"
}, {
  id: "129",
  name: "Atlantic/Cape_Verde",
  iso_country: "CV",
  location_code: "CV",
  description: "Cape Verde",
  country_name: "Cape Verde"
}, {
  id: "130",
  name: "America/Curacao",
  iso_country: "CW",
  location_code: "CUR",
  description: "Curacao",
  country_name: "Curaçao"
}, {
  id: "131",
  name: "Indian/Christmas",
  iso_country: "CX",
  location_code: "XCH",
  description: "Christmas",
  country_name: "Christmas Island"
}, {
  id: "132",
  name: "Asia/Famagusta",
  iso_country: "CY",
  location_code: "FMG",
  description: "Famagusta",
  country_name: "Cyprus"
}, {
  id: "133",
  name: "Asia/Nicosia",
  iso_country: "CY",
  location_code: "NIC",
  description: "Nicosia",
  country_name: "Cyprus"
}, {
  id: "134",
  name: "Europe/Prague",
  iso_country: "CZ",
  location_code: "PRG",
  description: "Prague",
  country_name: "Czech Republic"
}, {
  id: "135",
  name: "Europe/Berlin",
  iso_country: "DE",
  location_code: "BER",
  description: "Berlin",
  country_name: "Germany"
}, {
  id: "136",
  name: "Europe/Busingen",
  iso_country: "DE",
  location_code: "US2",
  description: "Busingen",
  country_name: "Germany"
}, {
  id: "137",
  name: "Africa/Djibouti",
  iso_country: "DJ",
  location_code: "JIB",
  description: "Djibouti",
  country_name: "Djibouti"
}, {
  id: "138",
  name: "Europe/Copenhagen",
  iso_country: "DK",
  location_code: "CPH",
  description: "Copenhagen",
  country_name: "Denmark"
}, {
  id: "139",
  name: "America/Dominica",
  iso_country: "DM",
  location_code: "DOM",
  description: "Dominica",
  country_name: "Dominica"
}, {
  id: "140",
  name: "America/Santo_Domingo",
  iso_country: "DO",
  location_code: "SDQ",
  description: "Santo Domingo",
  country_name: "Dominican Republic"
}, {
  id: "141",
  name: "Africa/Algiers",
  iso_country: "DZ",
  location_code: "ALG",
  description: "Algiers",
  country_name: "Algeria"
}, {
  id: "142",
  name: "America/Guayaquil",
  iso_country: "EC",
  location_code: "GYE",
  description: "Guayaquil",
  country_name: "Ecuador"
}, {
  id: "143",
  name: "Pacific/Galapagos",
  iso_country: "EC",
  location_code: "GPS",
  description: "Galapagos",
  country_name: "Ecuador"
}, {
  id: "144",
  name: "Europe/Tallinn",
  iso_country: "EE",
  location_code: "TLL",
  description: "Tallinn",
  country_name: "Estonia"
}, {
  id: "145",
  name: "Africa/Cairo",
  iso_country: "EG",
  location_code: "CAI",
  description: "Cairo",
  country_name: "Egypt"
}, {
  id: "146",
  name: "Africa/El_Aaiun",
  iso_country: "EH",
  location_code: "EAI",
  description: "El Aaiun",
  country_name: "Western Sahara"
}, {
  id: "147",
  name: "Africa/Asmara",
  iso_country: "ER",
  location_code: "ASM",
  description: "Asmara",
  country_name: "Eritrea"
}, {
  id: "148",
  name: "Africa/Ceuta",
  iso_country: "ES",
  location_code: "CEU",
  description: "Ceuta",
  country_name: "Spain"
}, {
  id: "149",
  name: "Atlantic/Canary",
  iso_country: "ES",
  location_code: "LPA",
  description: "Canary",
  country_name: "Spain"
}, {
  id: "150",
  name: "Europe/Madrid",
  iso_country: "ES",
  location_code: "MAD",
  description: "Madrid",
  country_name: "Spain"
}, {
  id: "151",
  name: "Africa/Addis_Ababa",
  iso_country: "ET",
  location_code: "ADD",
  description: "Addis Ababa",
  country_name: "Ethiopia"
}, {
  id: "152",
  name: "Europe/Helsinki",
  iso_country: "FI",
  location_code: "HEL",
  description: "Helsinki",
  country_name: "Finland"
}, {
  id: "153",
  name: "Pacific/Fiji",
  iso_country: "FJ",
  location_code: "FJ",
  description: "Fiji",
  country_name: "Fiji"
}, {
  id: "154",
  name: "Atlantic/Stanley",
  iso_country: "FK",
  location_code: "PSY",
  description: "Stanley",
  country_name: "Falkland Islands (Malvinas)"
}, {
  id: "155",
  name: "Pacific/Chuuk",
  iso_country: "FM",
  location_code: "TKK",
  description: "Chuuk",
  country_name: "Micronesia, Federated States of"
}, {
  id: "156",
  name: "Pacific/Kosrae",
  iso_country: "FM",
  location_code: "KSA",
  description: "Kosrae",
  country_name: "Micronesia, Federated States of"
}, {
  id: "157",
  name: "Pacific/Pohnpei",
  iso_country: "FM",
  location_code: "PNI",
  description: "Pohnpei",
  country_name: "Micronesia, Federated States of"
}, {
  id: "158",
  name: "Atlantic/Faroe",
  iso_country: "FO",
  location_code: "FAE",
  description: "Faroe",
  country_name: "Faroe Islands"
}, {
  id: "159",
  name: "Europe/Paris",
  iso_country: "FR",
  location_code: "PAR",
  description: "Paris",
  country_name: "France"
}, {
  id: "160",
  name: "Africa/Libreville",
  iso_country: "GA",
  location_code: "LBV",
  description: "Libreville",
  country_name: "Gabon"
}, {
  id: "161",
  name: "Europe/London",
  iso_country: "GB",
  location_code: "LON",
  description: "London",
  country_name: "United Kingdom"
}, {
  id: "162",
  name: "America/Grenada",
  iso_country: "GD",
  location_code: "GND",
  description: "Grenada",
  country_name: "Grenada"
}, {
  id: "163",
  name: "Asia/Tbilisi",
  iso_country: "GE",
  location_code: "TBS",
  description: "Tbilisi",
  country_name: "Georgia"
}, {
  id: "164",
  name: "America/Cayenne",
  iso_country: "GF",
  location_code: "CAY",
  description: "Cayenne",
  country_name: "French Guiana"
}, {
  id: "165",
  name: "Europe/Guernsey",
  iso_country: "GG",
  location_code: "GCI",
  description: "Guernsey",
  country_name: "Guernsey"
}, {
  id: "166",
  name: "Africa/Accra",
  iso_country: "GH",
  location_code: "ACC",
  description: "Accra",
  country_name: "Ghana"
}, {
  id: "167",
  name: "Europe/Gibraltar",
  iso_country: "GI",
  location_code: "GIB",
  description: "Gibraltar",
  country_name: "Gibraltar"
}, {
  id: "168",
  name: "America/Danmarkshavn",
  iso_country: "GL",
  location_code: "DAN",
  description: "Danmarkshavn",
  country_name: "Greenland"
}, {
  id: "169",
  name: "America/Nuuk",
  iso_country: "GL",
  location_code: "GOH",
  description: "Nuuk",
  country_name: "Greenland"
}, {
  id: "170",
  name: "America/Scoresbysund",
  iso_country: "GL",
  location_code: "OBY",
  description: "Scoresbysund",
  country_name: "Greenland"
}, {
  id: "171",
  name: "America/Thule",
  iso_country: "GL",
  location_code: "PTF",
  description: "Thule",
  country_name: "Greenland"
}, {
  id: "172",
  name: "Africa/Banjul",
  iso_country: "GM",
  location_code: "BJL",
  description: "Banjul",
  country_name: "Gambia"
}, {
  id: "173",
  name: "Africa/Conakry",
  iso_country: "GN",
  location_code: "CKY",
  description: "Conakry",
  country_name: "Guinea"
}, {
  id: "174",
  name: "America/Guadeloupe",
  iso_country: "GP",
  location_code: "GP",
  description: "Guadeloupe",
  country_name: "Guadeloupe"
}, {
  id: "175",
  name: "Africa/Malabo",
  iso_country: "GQ",
  location_code: "SSG",
  description: "Malabo",
  country_name: "Equatorial Guinea"
}, {
  id: "176",
  name: "Europe/Athens",
  iso_country: "GR",
  location_code: "ATH",
  description: "Athens",
  country_name: "Greece"
}, {
  id: "177",
  name: "Atlantic/South_Georgia",
  iso_country: "GS",
  location_code: "SGE",
  description: "South Georgia",
  country_name: "South Georgia and the South Sandwich Islands"
}, {
  id: "178",
  name: "America/Guatemala",
  iso_country: "GT",
  location_code: "GUA",
  description: "Guatemala",
  country_name: "Guatemala"
}, {
  id: "179",
  name: "Pacific/Guam",
  iso_country: "GU",
  location_code: "GUM",
  description: "Guam",
  country_name: "Guam"
}, {
  id: "180",
  name: "Africa/Bissau",
  iso_country: "GW",
  location_code: "OXB",
  description: "Bissau",
  country_name: "Guinea-Bissau"
}, {
  id: "181",
  name: "America/Guyana",
  iso_country: "GY",
  location_code: "GY",
  description: "Guyana",
  country_name: "Guyana"
}, {
  id: "182",
  name: "Asia/Hong_Kong",
  iso_country: "HK",
  location_code: "HKG",
  description: "Hong Kong",
  country_name: "Hong Kong"
}, {
  id: "183",
  name: "America/Tegucigalpa",
  iso_country: "HN",
  location_code: "TGU",
  description: "Tegucigalpa",
  country_name: "Honduras"
}, {
  id: "184",
  name: "Europe/Zagreb",
  iso_country: "HR",
  location_code: "ZAG",
  description: "Zagreb",
  country_name: "Croatia"
}, {
  id: "185",
  name: "America/Port-au-Prince",
  iso_country: "HT",
  location_code: "PAP",
  description: "Port-au-Prince",
  country_name: "Haiti"
}, {
  id: "186",
  name: "Europe/Budapest",
  iso_country: "HU",
  location_code: "BUD",
  description: "Budapest",
  country_name: "Hungary"
}, {
  id: "187",
  name: "Asia/Jakarta",
  iso_country: "ID",
  location_code: "JKT",
  description: "Jakarta",
  country_name: "Indonesia"
}, {
  id: "188",
  name: "Asia/Jayapura",
  iso_country: "ID",
  location_code: "DJJ",
  description: "Jayapura",
  country_name: "Indonesia"
}, {
  id: "189",
  name: "Asia/Makassar",
  iso_country: "ID",
  location_code: "MAK",
  description: "Makassar",
  country_name: "Indonesia"
}, {
  id: "190",
  name: "Asia/Pontianak",
  iso_country: "ID",
  location_code: "PNK",
  description: "Pontianak",
  country_name: "Indonesia"
}, {
  id: "191",
  name: "Europe/Dublin",
  iso_country: "IE",
  location_code: "DUB",
  description: "Dublin",
  country_name: "Ireland"
}, {
  id: "192",
  name: "Asia/Jerusalem",
  iso_country: "IL",
  location_code: "JER",
  description: "Jerusalem",
  country_name: "Israel"
}, {
  id: "193",
  name: "Europe/Isle_of_Man",
  iso_country: "IM",
  location_code: "IM",
  description: "Isle of Man",
  country_name: "Isle of Man"
}, {
  id: "194",
  name: "Asia/Kolkata",
  iso_country: "IN",
  location_code: "CCU",
  description: "Kolkata",
  country_name: "India"
}, {
  id: "195",
  name: "Indian/Chagos",
  iso_country: "IO",
  location_code: "CHA",
  description: "Chagos",
  country_name: "British Indian Ocean Territory"
}, {
  id: "196",
  name: "Asia/Baghdad",
  iso_country: "IQ",
  location_code: "BGW",
  description: "Baghdad",
  country_name: "Iraq"
}, {
  id: "197",
  name: "Asia/Tehran",
  iso_country: "IR",
  location_code: "THR",
  description: "Tehran",
  country_name: "Iran, Islamic Republic of"
}, {
  id: "198",
  name: "Atlantic/Reykjavik",
  iso_country: "IS",
  location_code: "REY",
  description: "Reykjavik",
  country_name: "Iceland"
}, {
  id: "199",
  name: "Europe/Rome",
  iso_country: "IT",
  location_code: "ROM",
  description: "Rome",
  country_name: "Italy"
}, {
  id: "200",
  name: "Europe/Jersey",
  iso_country: "JE",
  location_code: "JE",
  description: "Jersey",
  country_name: "Jersey"
}, {
  id: "201",
  name: "America/Jamaica",
  iso_country: "JM",
  location_code: "JM",
  description: "Jamaica",
  country_name: "Jamaica"
}, {
  id: "202",
  name: "Asia/Amman",
  iso_country: "JO",
  location_code: "AMM",
  description: "Amman",
  country_name: "Jordan"
}, {
  id: "203",
  name: "Asia/Tokyo",
  iso_country: "JP",
  location_code: "TYO",
  description: "Tokyo",
  country_name: "Japan"
}, {
  id: "204",
  name: "Africa/Nairobi",
  iso_country: "KE",
  location_code: "NBO",
  description: "Nairobi",
  country_name: "Kenya"
}, {
  id: "205",
  name: "Asia/Bishkek",
  iso_country: "KG",
  location_code: "FRU",
  description: "Bishkek",
  country_name: "Kyrgyzstan"
}, {
  id: "206",
  name: "Asia/Phnom_Penh",
  iso_country: "KH",
  location_code: "PNH",
  description: "Phnom Penh",
  country_name: "Cambodia"
}, {
  id: "207",
  name: "Pacific/Enderbury",
  iso_country: "KI",
  location_code: "EBI",
  description: "Enderbury",
  country_name: "Kiribati"
}, {
  id: "208",
  name: "Pacific/Kiritimati",
  iso_country: "KI",
  location_code: "CXI",
  description: "Kiritimati",
  country_name: "Kiribati"
}, {
  id: "209",
  name: "Pacific/Tarawa",
  iso_country: "KI",
  location_code: "TRW",
  description: "Tarawa",
  country_name: "Kiribati"
}, {
  id: "210",
  name: "Indian/Comoro",
  iso_country: "KM",
  location_code: "COM",
  description: "Comoro",
  country_name: "Comoros"
}, {
  id: "211",
  name: "America/St_Kitts",
  iso_country: "KN",
  location_code: "KN",
  description: "St Kitts",
  country_name: "Saint Kitts and Nevis"
}, {
  id: "212",
  name: "Asia/Pyongyang",
  iso_country: "KP",
  location_code: "FNJ",
  description: "Pyongyang",
  country_name: "Korea, Democratic People's Republic of"
}, {
  id: "213",
  name: "Asia/Seoul",
  iso_country: "KR",
  location_code: "SEL",
  description: "Seoul",
  country_name: "Korea, Republic of"
}, {
  id: "214",
  name: "Asia/Kuwait",
  iso_country: "KW",
  location_code: "KWI",
  description: "Kuwait",
  country_name: "Kuwait"
}, {
  id: "215",
  name: "America/Cayman",
  iso_country: "KY",
  location_code: "CYB",
  description: "Cayman",
  country_name: "Cayman Islands"
}, {
  id: "216",
  name: "Asia/Almaty",
  iso_country: "KZ",
  location_code: "ALA",
  description: "Almaty",
  country_name: "Kazakhstan"
}, {
  id: "217",
  name: "Asia/Aqtau",
  iso_country: "KZ",
  location_code: "AAU",
  description: "Aqtau",
  country_name: "Kazakhstan"
}, {
  id: "218",
  name: "Asia/Aqtobe",
  iso_country: "KZ",
  location_code: "AKX",
  description: "Aqtobe",
  country_name: "Kazakhstan"
}, {
  id: "219",
  name: "Asia/Atyrau",
  iso_country: "KZ",
  location_code: "GUW",
  description: "Atyrau",
  country_name: "Kazakhstan"
}, {
  id: "220",
  name: "Asia/Oral",
  iso_country: "KZ",
  location_code: "URA",
  description: "Oral",
  country_name: "Kazakhstan"
}, {
  id: "221",
  name: "Asia/Qostanay",
  iso_country: "KZ",
  location_code: "KSN",
  description: "Qostanay",
  country_name: "Kazakhstan"
}, {
  id: "222",
  name: "Asia/Qyzylorda",
  iso_country: "KZ",
  location_code: "KZO",
  description: "Qyzylorda",
  country_name: "Kazakhstan"
}, {
  id: "223",
  name: "Asia/Vientiane",
  iso_country: "LA",
  location_code: "VTE",
  description: "Vientiane",
  country_name: "Lao People's Democratic Republic"
}, {
  id: "224",
  name: "Asia/Beirut",
  iso_country: "LB",
  location_code: "BEY",
  description: "Beirut",
  country_name: "Lebanon"
}, {
  id: "225",
  name: "America/St_Lucia",
  iso_country: "LC",
  location_code: "LC",
  description: "St Lucia",
  country_name: "Saint Lucia"
}, {
  id: "226",
  name: "Europe/Vaduz",
  iso_country: "LI",
  location_code: "VDZ",
  description: "Vaduz",
  country_name: "Liechtenstein"
}, {
  id: "227",
  name: "Asia/Colombo",
  iso_country: "LK",
  location_code: "CMB",
  description: "Colombo",
  country_name: "Sri Lanka"
}, {
  id: "228",
  name: "Africa/Monrovia",
  iso_country: "LR",
  location_code: "MLW",
  description: "Monrovia",
  country_name: "Liberia"
}, {
  id: "229",
  name: "Africa/Maseru",
  iso_country: "LS",
  location_code: "MSU",
  description: "Maseru",
  country_name: "Lesotho"
}, {
  id: "230",
  name: "Europe/Vilnius",
  iso_country: "LT",
  location_code: "VIL",
  description: "Vilnius",
  country_name: "Lithuania"
}, {
  id: "231",
  name: "Europe/Luxembourg",
  iso_country: "LU",
  location_code: "LUX",
  description: "Luxembourg",
  country_name: "Luxembourg"
}, {
  id: "232",
  name: "Europe/Riga",
  iso_country: "LV",
  location_code: "RIX",
  description: "Riga",
  country_name: "Latvia"
}, {
  id: "233",
  name: "Africa/Tripoli",
  iso_country: "LY",
  location_code: "TIP",
  description: "Tripoli",
  country_name: "Libya"
}, {
  id: "234",
  name: "Africa/Casablanca",
  iso_country: "MA",
  location_code: "CAS",
  description: "Casablanca",
  country_name: "Morocco"
}, {
  id: "235",
  name: "Europe/Monaco",
  iso_country: "MC",
  location_code: "MON",
  description: "Monaco",
  country_name: "Monaco"
}, {
  id: "236",
  name: "Europe/Chisinau",
  iso_country: "MD",
  location_code: "KIV",
  description: "Chisinau",
  country_name: "Moldova, Republic of"
}, {
  id: "237",
  name: "Europe/Podgorica",
  iso_country: "ME",
  location_code: "TGD",
  description: "Podgorica",
  country_name: "Montenegro"
}, {
  id: "238",
  name: "America/Marigot",
  iso_country: "MF",
  location_code: "MAR",
  description: "Marigot",
  country_name: "Saint Martin (French part)"
}, {
  id: "239",
  name: "Indian/Antananarivo",
  iso_country: "MG",
  location_code: "TNR",
  description: "Antananarivo",
  country_name: "Madagascar"
}, {
  id: "240",
  name: "Pacific/Kwajalein",
  iso_country: "MH",
  location_code: "KWA",
  description: "Kwajalein",
  country_name: "Marshall Islands"
}, {
  id: "241",
  name: "Pacific/Majuro",
  iso_country: "MH",
  location_code: "MAJ",
  description: "Majuro",
  country_name: "Marshall Islands"
}, {
  id: "242",
  name: "Europe/Skopje",
  iso_country: "MK",
  location_code: "SKP",
  description: "Skopje",
  country_name: "Macedonia, the Former Yugoslav Republic of"
}, {
  id: "243",
  name: "Africa/Bamako",
  iso_country: "ML",
  location_code: "BKO",
  description: "Bamako",
  country_name: "Mali"
}, {
  id: "244",
  name: "Asia/Yangon",
  iso_country: "MM",
  location_code: "RGN",
  description: "Yangon",
  country_name: "Myanmar"
}, {
  id: "245",
  name: "Asia/Choibalsan",
  iso_country: "MN",
  location_code: "COQ",
  description: "Choibalsan",
  country_name: "Mongolia"
}, {
  id: "246",
  name: "Asia/Hovd",
  iso_country: "MN",
  location_code: "HVD",
  description: "Hovd",
  country_name: "Mongolia"
}, {
  id: "247",
  name: "Asia/Ulaanbaatar",
  iso_country: "MN",
  location_code: "ULN",
  description: "Ulaanbaatar",
  country_name: "Mongolia"
}, {
  id: "248",
  name: "Asia/Macau",
  iso_country: "MO",
  location_code: "MFM",
  description: "Macau",
  country_name: "Macao"
}, {
  id: "249",
  name: "Pacific/Saipan",
  iso_country: "MP",
  location_code: "SPN",
  description: "Saipan",
  country_name: "Northern Mariana Islands"
}, {
  id: "250",
  name: "America/Martinique",
  iso_country: "MQ",
  location_code: "MQ",
  description: "Martinique",
  country_name: "Martinique"
}, {
  id: "251",
  name: "Africa/Nouakchott",
  iso_country: "MR",
  location_code: "NKC",
  description: "Nouakchott",
  country_name: "Mauritania"
}, {
  id: "252",
  name: "America/Montserrat",
  iso_country: "MS",
  location_code: "MNI",
  description: "Montserrat",
  country_name: "Montserrat"
}, {
  id: "253",
  name: "Europe/Malta",
  iso_country: "MT",
  location_code: "DIS",
  description: "Malta",
  country_name: "Malta"
}, {
  id: "254",
  name: "Indian/Mauritius",
  iso_country: "MU",
  location_code: "MU",
  description: "Mauritius",
  country_name: "Mauritius"
}, {
  id: "255",
  name: "Indian/Maldives",
  iso_country: "MV",
  location_code: "MV",
  description: "Maldives",
  country_name: "Maldives"
}, {
  id: "256",
  name: "Africa/Blantyre",
  iso_country: "MW",
  location_code: "BLZ",
  description: "Blantyre",
  country_name: "Malawi"
}, {
  id: "257",
  name: "America/Bahia_Banderas",
  iso_country: "MX",
  location_code: "BDB",
  description: "Bahia Banderas",
  country_name: "Mexico"
}, {
  id: "258",
  name: "America/Cancun",
  iso_country: "MX",
  location_code: "CUN",
  description: "Cancun",
  country_name: "Mexico"
}, {
  id: "259",
  name: "America/Chihuahua",
  iso_country: "MX",
  location_code: "CUU",
  description: "Chihuahua",
  country_name: "Mexico"
}, {
  id: "260",
  name: "America/Hermosillo",
  iso_country: "MX",
  location_code: "HMO",
  description: "Hermosillo",
  country_name: "Mexico"
}, {
  id: "261",
  name: "America/Matamoros",
  iso_country: "MX",
  location_code: "MMA",
  description: "Matamoros",
  country_name: "Mexico"
}, {
  id: "262",
  name: "America/Mazatlan",
  iso_country: "MX",
  location_code: "MZT",
  description: "Mazatlan",
  country_name: "Mexico"
}, {
  id: "263",
  name: "America/Merida",
  iso_country: "MX",
  location_code: "MID",
  description: "Merida",
  country_name: "Mexico"
}, {
  id: "264",
  name: "America/Mexico_City",
  iso_country: "MX",
  location_code: "MEX",
  description: "Mexico City",
  country_name: "Mexico"
}, {
  id: "265",
  name: "America/Monterrey",
  iso_country: "MX",
  location_code: "MTY",
  description: "Monterrey",
  country_name: "Mexico"
}, {
  id: "266",
  name: "America/Ojinaga",
  iso_country: "MX",
  location_code: "OJI",
  description: "Ojinaga",
  country_name: "Mexico"
}, {
  id: "267",
  name: "America/Tijuana",
  iso_country: "MX",
  location_code: "TIJ",
  description: "Tijuana",
  country_name: "Mexico"
}, {
  id: "268",
  name: "Asia/Kuala_Lumpur",
  iso_country: "MY",
  location_code: "KUL",
  description: "Kuala Lumpur",
  country_name: "Malaysia"
}, {
  id: "269",
  name: "Asia/Kuching",
  iso_country: "MY",
  location_code: "KCH",
  description: "Kuching",
  country_name: "Malaysia"
}, {
  id: "270",
  name: "Africa/Maputo",
  iso_country: "MZ",
  location_code: "MPM",
  description: "Maputo",
  country_name: "Mozambique"
}, {
  id: "271",
  name: "Africa/Windhoek",
  iso_country: "NA",
  location_code: "WDH",
  description: "Windhoek",
  country_name: "Namibia"
}, {
  id: "272",
  name: "Pacific/Noumea",
  iso_country: "NC",
  location_code: "NOU",
  description: "Noumea",
  country_name: "New Caledonia"
}, {
  id: "273",
  name: "Africa/Niamey",
  iso_country: "NE",
  location_code: "NIM",
  description: "Niamey",
  country_name: "Niger"
}, {
  id: "274",
  name: "Pacific/Norfolk",
  iso_country: "NF",
  location_code: "NLK",
  description: "Norfolk",
  country_name: "Norfolk Island"
}, {
  id: "275",
  name: "Africa/Lagos",
  iso_country: "NG",
  location_code: "LAG",
  description: "Lagos",
  country_name: "Nigeria"
}, {
  id: "276",
  name: "America/Managua",
  iso_country: "NI",
  location_code: "MGA",
  description: "Managua",
  country_name: "Nicaragua"
}, {
  id: "277",
  name: "Europe/Amsterdam",
  iso_country: "NL",
  location_code: "AMS",
  description: "Amsterdam",
  country_name: "Netherlands"
}, {
  id: "278",
  name: "Europe/Oslo",
  iso_country: "NO",
  location_code: "OSL",
  description: "Oslo",
  country_name: "Norway"
}, {
  id: "279",
  name: "Asia/Kathmandu",
  iso_country: "NP",
  location_code: "KTM",
  description: "Kathmandu",
  country_name: "Nepal"
}, {
  id: "280",
  name: "Pacific/Nauru",
  iso_country: "NR",
  location_code: "INU",
  description: "Nauru",
  country_name: "Nauru"
}, {
  id: "281",
  name: "Pacific/Niue",
  iso_country: "NU",
  location_code: "IUE",
  description: "Niue",
  country_name: "Niue"
}, {
  id: "282",
  name: "Pacific/Auckland",
  iso_country: "NZ",
  location_code: "AKL",
  description: "Auckland",
  country_name: "New Zealand"
}, {
  id: "283",
  name: "Pacific/Chatham",
  iso_country: "NZ",
  location_code: "CHT",
  description: "Chatham",
  country_name: "New Zealand"
}, {
  id: "284",
  name: "Asia/Muscat",
  iso_country: "OM",
  location_code: "MCT",
  description: "Muscat",
  country_name: "Oman"
}, {
  id: "285",
  name: "America/Panama",
  iso_country: "PA",
  location_code: "PA",
  description: "Panama",
  country_name: "Panama"
}, {
  id: "286",
  name: "America/Lima",
  iso_country: "PE",
  location_code: "LIM",
  description: "Lima",
  country_name: "Peru"
}, {
  id: "287",
  name: "Pacific/Gambier",
  iso_country: "PF",
  location_code: "GAM",
  description: "Gambier",
  country_name: "French Polynesia"
}, {
  id: "288",
  name: "Pacific/Marquesas",
  iso_country: "PF",
  location_code: "MQS",
  description: "Marquesas",
  country_name: "French Polynesia"
}, {
  id: "289",
  name: "Pacific/Tahiti",
  iso_country: "PF",
  location_code: "FAA",
  description: "Tahiti",
  country_name: "French Polynesia"
}, {
  id: "290",
  name: "Pacific/Bougainville",
  iso_country: "PG",
  location_code: "BGN",
  description: "Bougainville",
  country_name: "Papua New Guinea"
}, {
  id: "291",
  name: "Pacific/Port_Moresby",
  iso_country: "PG",
  location_code: "POM",
  description: "Port Moresby",
  country_name: "Papua New Guinea"
}, {
  id: "292",
  name: "Asia/Manila",
  iso_country: "PH",
  location_code: "MNL",
  description: "Manila",
  country_name: "Philippines"
}, {
  id: "293",
  name: "Asia/Karachi",
  iso_country: "PK",
  location_code: "KHI",
  description: "Karachi",
  country_name: "Pakistan"
}, {
  id: "294",
  name: "Europe/Warsaw",
  iso_country: "PL",
  location_code: "WAW",
  description: "Warsaw",
  country_name: "Poland"
}, {
  id: "295",
  name: "America/Miquelon",
  iso_country: "PM",
  location_code: "MQC",
  description: "Miquelon",
  country_name: "Saint Pierre and Miquelon"
}, {
  id: "296",
  name: "Pacific/Pitcairn",
  iso_country: "PN",
  location_code: "PCN",
  description: "Pitcairn",
  country_name: "Pitcairn"
}, {
  id: "297",
  name: "America/Puerto_Rico",
  iso_country: "PR",
  location_code: "PR",
  description: "Puerto Rico",
  country_name: "Puerto Rico"
}, {
  id: "298",
  name: "Asia/Gaza",
  iso_country: "PS",
  location_code: "GZA",
  description: "Gaza",
  country_name: "Palestine, State of"
}, {
  id: "299",
  name: "Asia/Hebron",
  iso_country: "PS",
  location_code: "HEB",
  description: "Hebron",
  country_name: "Palestine, State of"
}, {
  id: "300",
  name: "Atlantic/Azores",
  iso_country: "PT",
  location_code: "AZR",
  description: "Azores",
  country_name: "Portugal"
}, {
  id: "301",
  name: "Atlantic/Madeira",
  iso_country: "PT",
  location_code: "M6E",
  description: "Madeira",
  country_name: "Portugal"
}, {
  id: "302",
  name: "Europe/Lisbon",
  iso_country: "PT",
  location_code: "LIS",
  description: "Lisbon",
  country_name: "Portugal"
}, {
  id: "303",
  name: "Pacific/Palau",
  iso_country: "PW",
  location_code: "PW",
  description: "Palau",
  country_name: "Palau"
}, {
  id: "304",
  name: "America/Asuncion",
  iso_country: "PY",
  location_code: "ASU",
  description: "Asuncion",
  country_name: "Paraguay"
}, {
  id: "305",
  name: "Asia/Qatar",
  iso_country: "QA",
  location_code: "QA",
  description: "Qatar",
  country_name: "Qatar"
}, {
  id: "306",
  name: "Indian/Reunion",
  iso_country: "RE",
  location_code: "RE",
  description: "Reunion",
  country_name: "Réunion"
}, {
  id: "307",
  name: "Europe/Bucharest",
  iso_country: "RO",
  location_code: "BUH",
  description: "Bucharest",
  country_name: "Romania"
}, {
  id: "308",
  name: "Europe/Belgrade",
  iso_country: "RS",
  location_code: "BEG",
  description: "Belgrade",
  country_name: "Serbia"
}, {
  id: "309",
  name: "Asia/Anadyr",
  iso_country: "RU",
  location_code: "DYR",
  description: "Anadyr",
  country_name: "Russian Federation"
}, {
  id: "310",
  name: "Asia/Barnaul",
  iso_country: "RU",
  location_code: "BAX",
  description: "Barnaul",
  country_name: "Russian Federation"
}, {
  id: "311",
  name: "Asia/Chita",
  iso_country: "RU",
  location_code: "CTA",
  description: "Chita",
  country_name: "Russian Federation"
}, {
  id: "312",
  name: "Asia/Irkutsk",
  iso_country: "RU",
  location_code: "IKT",
  description: "Irkutsk",
  country_name: "Russian Federation"
}, {
  id: "313",
  name: "Asia/Kamchatka",
  iso_country: "RU",
  location_code: "KAM",
  description: "Kamchatka",
  country_name: "Russian Federation"
}, {
  id: "314",
  name: "Asia/Khandyga",
  iso_country: "RU",
  location_code: "KHA",
  description: "Khandyga",
  country_name: "Russian Federation"
}, {
  id: "315",
  name: "Asia/Krasnoyarsk",
  iso_country: "RU",
  location_code: "KRN",
  description: "Krasnoyarsk",
  country_name: "Russian Federation"
}, {
  id: "316",
  name: "Asia/Magadan",
  iso_country: "RU",
  location_code: "GDX",
  description: "Magadan",
  country_name: "Russian Federation"
}, {
  id: "317",
  name: "Asia/Novokuznetsk",
  iso_country: "RU",
  location_code: "NOZ",
  description: "Novokuznetsk",
  country_name: "Russian Federation"
}, {
  id: "318",
  name: "Asia/Novosibirsk",
  iso_country: "RU",
  location_code: "OVB",
  description: "Novosibirsk",
  country_name: "Russian Federation"
}, {
  id: "319",
  name: "Asia/Omsk",
  iso_country: "RU",
  location_code: "OMS",
  description: "Omsk",
  country_name: "Russian Federation"
}, {
  id: "320",
  name: "Asia/Sakhalin",
  iso_country: "RU",
  location_code: "SAK",
  description: "Sakhalin",
  country_name: "Russian Federation"
}, {
  id: "321",
  name: "Asia/Srednekolymsk",
  iso_country: "RU",
  location_code: "SRD",
  description: "Srednekolymsk",
  country_name: "Russian Federation"
}, {
  id: "322",
  name: "Asia/Tomsk",
  iso_country: "RU",
  location_code: "TOF",
  description: "Tomsk",
  country_name: "Russian Federation"
}, {
  id: "323",
  name: "Asia/Ust-Nera",
  iso_country: "RU",
  location_code: "USN",
  description: "Ust-Nera",
  country_name: "Russian Federation"
}, {
  id: "324",
  name: "Asia/Vladivostok",
  iso_country: "RU",
  location_code: "VVO",
  description: "Vladivostok",
  country_name: "Russian Federation"
}, {
  id: "325",
  name: "Asia/Yakutsk",
  iso_country: "RU",
  location_code: "YKS",
  description: "Yakutsk",
  country_name: "Russian Federation"
}, {
  id: "326",
  name: "Asia/Yekaterinburg",
  iso_country: "RU",
  location_code: "YEK",
  description: "Yekaterinburg",
  country_name: "Russian Federation"
}, {
  id: "327",
  name: "Europe/Astrakhan",
  iso_country: "RU",
  location_code: "ASF",
  description: "Astrakhan",
  country_name: "Russian Federation"
}, {
  id: "328",
  name: "Europe/Kaliningrad",
  iso_country: "RU",
  location_code: "KGD",
  description: "Kaliningrad",
  country_name: "Russian Federation"
}, {
  id: "329",
  name: "Europe/Kirov",
  iso_country: "RU",
  location_code: "KVX",
  description: "Kirov",
  country_name: "Russian Federation"
}, {
  id: "330",
  name: "Europe/Moscow",
  iso_country: "RU",
  location_code: "MOW",
  description: "Moscow",
  country_name: "Russian Federation"
}, {
  id: "331",
  name: "Europe/Samara",
  iso_country: "RU",
  location_code: "KUF",
  description: "Samara",
  country_name: "Russian Federation"
}, {
  id: "332",
  name: "Europe/Saratov",
  iso_country: "RU",
  location_code: "RTW",
  description: "Saratov",
  country_name: "Russian Federation"
}, {
  id: "333",
  name: "Europe/Ulyanovsk",
  iso_country: "RU",
  location_code: "ULY",
  description: "Ulyanovsk",
  country_name: "Russian Federation"
}, {
  id: "334",
  name: "Europe/Volgograd",
  iso_country: "RU",
  location_code: "VOG",
  description: "Volgograd",
  country_name: "Russian Federation"
}, {
  id: "335",
  name: "Africa/Kigali",
  iso_country: "RW",
  location_code: "KGL",
  description: "Kigali",
  country_name: "Rwanda"
}, {
  id: "336",
  name: "Asia/Riyadh",
  iso_country: "SA",
  location_code: "RUH",
  description: "Riyadh",
  country_name: "Saudi Arabia"
}, {
  id: "337",
  name: "Pacific/Guadalcanal",
  iso_country: "SB",
  location_code: "GSI",
  description: "Guadalcanal",
  country_name: "Solomon Islands"
}, {
  id: "338",
  name: "Indian/Mahe",
  iso_country: "SC",
  location_code: "MAW",
  description: "Mahe",
  country_name: "Seychelles"
}, {
  id: "339",
  name: "Africa/Khartoum",
  iso_country: "SD",
  location_code: "KRT",
  description: "Khartoum",
  country_name: "Sudan"
}, {
  id: "340",
  name: "Europe/Stockholm",
  iso_country: "SE",
  location_code: "STO",
  description: "Stockholm",
  country_name: "Sweden"
}, {
  id: "341",
  name: "Asia/Singapore",
  iso_country: "SG",
  location_code: "SIN",
  description: "Singapore",
  country_name: "Singapore"
}, {
  id: "342",
  name: "Atlantic/St_Helena",
  iso_country: "SH",
  location_code: "SH",
  description: "St Helena",
  country_name: "Saint Helena, Ascension and Tristan da Cunha"
}, {
  id: "343",
  name: "Europe/Ljubljana",
  iso_country: "SI",
  location_code: "LJU",
  description: "Ljubljana",
  country_name: "Slovenia"
}, {
  id: "344",
  name: "Arctic/Longyearbyen",
  iso_country: "SJ",
  location_code: "LYR",
  description: "Longyearbyen",
  country_name: "Svalbard and Jan Mayen"
}, {
  id: "345",
  name: "Europe/Bratislava",
  iso_country: "SK",
  location_code: "BTS",
  description: "Bratislava",
  country_name: "Slovakia"
}, {
  id: "346",
  name: "Africa/Freetown",
  iso_country: "SL",
  location_code: "FNA",
  description: "Freetown",
  country_name: "Sierra Leone"
}, {
  id: "347",
  name: "Europe/San_Marino",
  iso_country: "SM",
  location_code: "SAI",
  description: "San Marino",
  country_name: "San Marino"
}, {
  id: "348",
  name: "Africa/Dakar",
  iso_country: "SN",
  location_code: "DKR",
  description: "Dakar",
  country_name: "Senegal"
}, {
  id: "349",
  name: "Africa/Mogadishu",
  iso_country: "SO",
  location_code: "MGQ",
  description: "Mogadishu",
  country_name: "Somalia"
}, {
  id: "350",
  name: "America/Paramaribo",
  iso_country: "SR",
  location_code: "PBM",
  description: "Paramaribo",
  country_name: "Suriname"
}, {
  id: "351",
  name: "Africa/Juba",
  iso_country: "SS",
  location_code: "JUB",
  description: "Juba",
  country_name: "South Sudan"
}, {
  id: "352",
  name: "Africa/Sao_Tome",
  iso_country: "ST",
  location_code: "TMS",
  description: "Sao Tome",
  country_name: "Sao Tome and Principe"
}, {
  id: "353",
  name: "America/El_Salvador",
  iso_country: "SV",
  location_code: "ELS",
  description: "El Salvador",
  country_name: "El Salvador"
}, {
  id: "354",
  name: "America/Lower_Princes",
  iso_country: "SX",
  location_code: "LWP",
  description: "Lower Princes",
  country_name: "Sint Maarten (Dutch part)"
}, {
  id: "355",
  name: "Asia/Damascus",
  iso_country: "SY",
  location_code: "DAM",
  description: "Damascus",
  country_name: "Syrian Arab Republic"
}, {
  id: "356",
  name: "Africa/Mbabane",
  iso_country: "SZ",
  location_code: "QMN",
  description: "Mbabane",
  country_name: "Swaziland"
}, {
  id: "357",
  name: "America/Grand_Turk",
  iso_country: "TC",
  location_code: "GDT",
  description: "Grand Turk",
  country_name: "Turks and Caicos Islands"
}, {
  id: "358",
  name: "Africa/Ndjamena",
  iso_country: "TD",
  location_code: "NDJ",
  description: "Ndjamena",
  country_name: "Chad"
}, {
  id: "359",
  name: "Indian/Kerguelen",
  iso_country: "TF",
  location_code: "KER",
  description: "Kerguelen",
  country_name: "French Southern Territories"
}, {
  id: "360",
  name: "Africa/Lome",
  iso_country: "TG",
  location_code: "LFW",
  description: "Lome",
  country_name: "Togo"
}, {
  id: "361",
  name: "Asia/Bangkok",
  iso_country: "TH",
  location_code: "BKK",
  description: "Bangkok",
  country_name: "Thailand"
}, {
  id: "362",
  name: "Asia/Dushanbe",
  iso_country: "TJ",
  location_code: "DYU",
  description: "Dushanbe",
  country_name: "Tajikistan"
}, {
  id: "363",
  name: "Pacific/Fakaofo",
  iso_country: "TK",
  location_code: "FKO",
  description: "Fakaofo",
  country_name: "Tokelau"
}, {
  id: "364",
  name: "Asia/Dili",
  iso_country: "TL",
  location_code: "DIL",
  description: "Dili",
  country_name: "Timor-Leste"
}, {
  id: "365",
  name: "Asia/Ashgabat",
  iso_country: "TM",
  location_code: "AGT",
  description: "Ashgabat",
  country_name: "Turkmenistan"
}, {
  id: "366",
  name: "Africa/Tunis",
  iso_country: "TN",
  location_code: "TUN",
  description: "Tunis",
  country_name: "Tunisia"
}, {
  id: "367",
  name: "Pacific/Tongatapu",
  iso_country: "TO",
  location_code: "TO",
  description: "Tongatapu",
  country_name: "Tonga"
}, {
  id: "368",
  name: "Europe/Istanbul",
  iso_country: "TR",
  location_code: "IST",
  description: "Istanbul",
  country_name: "Turkey"
}, {
  id: "369",
  name: "America/Port_of_Spain",
  iso_country: "TT",
  location_code: "POS",
  description: "Port of Spain",
  country_name: "Trinidad and Tobago"
}, {
  id: "370",
  name: "Pacific/Funafuti",
  iso_country: "TV",
  location_code: "FUN",
  description: "Funafuti",
  country_name: "Tuvalu"
}, {
  id: "371",
  name: "Asia/Taipei",
  iso_country: "TW",
  location_code: "TPE",
  description: "Taipei",
  country_name: "Taiwan, Province of China"
}, {
  id: "372",
  name: "Africa/Dar_es_Salaam",
  iso_country: "TZ",
  location_code: "DAR",
  description: "Dar es Salaam",
  country_name: "Tanzania, United Republic of"
}, {
  id: "373",
  name: "Europe/Kiev",
  iso_country: "UA",
  location_code: "IEV",
  description: "Kiev",
  country_name: "Ukraine"
}, {
  id: "374",
  name: "Europe/Simferopol",
  iso_country: "UA",
  location_code: "SIP",
  description: "Simferopol",
  country_name: "Ukraine"
}, {
  id: "375",
  name: "Europe/Uzhgorod",
  iso_country: "UA",
  location_code: "UZH",
  description: "Uzhgorod",
  country_name: "Ukraine"
}, {
  id: "376",
  name: "Europe/Zaporozhye",
  iso_country: "UA",
  location_code: "OZH",
  description: "Zaporozhye",
  country_name: "Ukraine"
}, {
  id: "377",
  name: "Africa/Kampala",
  iso_country: "UG",
  location_code: "KLA",
  description: "Kampala",
  country_name: "Uganda"
}, {
  id: "378",
  name: "Pacific/Midway",
  iso_country: "UM",
  location_code: "MDY",
  description: "Midway",
  country_name: "United States Minor Outlying Islands"
}, {
  id: "379",
  name: "Pacific/Wake",
  iso_country: "UM",
  location_code: "AWK",
  description: "Wake",
  country_name: "United States Minor Outlying Islands"
}, {
  id: "380",
  name: "America/Adak",
  iso_country: "US",
  location_code: "AXK",
  description: "Adak",
  country_name: "United States"
}, {
  id: "381",
  name: "America/Anchorage",
  iso_country: "US",
  location_code: "ANC",
  description: "Anchorage",
  country_name: "United States"
}, {
  id: "382",
  name: "America/Boise",
  iso_country: "US",
  location_code: "BOI",
  description: "Boise",
  country_name: "United States"
}, {
  id: "383",
  name: "America/Chicago",
  iso_country: "US",
  location_code: "CHI",
  description: "Chicago",
  country_name: "United States"
}, {
  id: "384",
  name: "America/Denver",
  iso_country: "US",
  location_code: "DEN",
  description: "Denver",
  country_name: "United States"
}, {
  id: "385",
  name: "America/Detroit",
  iso_country: "US",
  location_code: "DET",
  description: "Detroit",
  country_name: "United States"
}, {
  id: "386",
  name: "America/Indiana/Indianapolis",
  iso_country: "US",
  location_code: "IND",
  description: "Indianapolis, Indiana",
  country_name: "United States"
}, {
  id: "387",
  name: "America/Indiana/Knox",
  iso_country: "US",
  location_code: "KNX",
  description: "Knox, Indiana",
  country_name: "United States"
}, {
  id: "388",
  name: "America/Indiana/Marengo",
  iso_country: "US",
  location_code: "AEG",
  description: "Marengo, Indiana",
  country_name: "United States"
}, {
  id: "389",
  name: "America/Indiana/Petersburg",
  iso_country: "US",
  location_code: "PB8",
  description: "Petersburg, Indiana",
  country_name: "United States"
}, {
  id: "390",
  name: "America/Indiana/Tell_City",
  iso_country: "US",
  location_code: "TEL",
  description: "Tell City, Indiana",
  country_name: "United States"
}, {
  id: "391",
  name: "America/Indiana/Vevay",
  iso_country: "US",
  location_code: "VYI",
  description: "Vevay, Indiana",
  country_name: "United States"
}, {
  id: "392",
  name: "America/Indiana/Vincennes",
  iso_country: "US",
  location_code: "OEA",
  description: "Vincennes, Indiana",
  country_name: "United States"
}, {
  id: "393",
  name: "America/Indiana/Winamac",
  iso_country: "US",
  location_code: "WLZ",
  description: "Winamac, Indiana",
  country_name: "United States"
}, {
  id: "394",
  name: "America/Juneau",
  iso_country: "US",
  location_code: "JNU",
  description: "Juneau",
  country_name: "United States"
}, {
  id: "395",
  name: "America/Kentucky/Louisville",
  iso_country: "US",
  location_code: "LUI",
  description: "Louisville, Kentucky",
  country_name: "United States"
}, {
  id: "396",
  name: "America/Kentucky/Monticello",
  iso_country: "US",
  location_code: "MOC",
  description: "Monticello, Kentucky",
  country_name: "United States"
}, {
  id: "397",
  name: "America/Los_Angeles",
  iso_country: "US",
  location_code: "LAX",
  description: "Los Angeles",
  country_name: "United States"
}, {
  id: "398",
  name: "America/Menominee",
  iso_country: "US",
  location_code: "MNM",
  description: "Menominee",
  country_name: "United States"
}, {
  id: "399",
  name: "America/Metlakatla",
  iso_country: "US",
  location_code: "MTM",
  description: "Metlakatla",
  country_name: "United States"
}, {
  id: "400",
  name: "America/New_York",
  iso_country: "US",
  location_code: "NYC",
  description: "New York",
  country_name: "United States"
}, {
  id: "401",
  name: "America/Nome",
  iso_country: "US",
  location_code: "OME",
  description: "Nome",
  country_name: "United States"
}, {
  id: "402",
  name: "America/North_Dakota/Beulah",
  iso_country: "US",
  location_code: "XUL",
  description: "Beulah, North Dakota",
  country_name: "United States"
}, {
  id: "403",
  name: "America/North_Dakota/Center",
  iso_country: "US",
  location_code: "ZT8",
  description: "Center, North Dakota",
  country_name: "United States"
}, {
  id: "404",
  name: "America/North_Dakota/New_Salem",
  iso_country: "US",
  location_code: "NQY",
  description: "New Salem, North Dakota",
  country_name: "United States"
}, {
  id: "405",
  name: "America/Phoenix",
  iso_country: "US",
  location_code: "PHX",
  description: "Phoenix",
  country_name: "United States"
}, {
  id: "406",
  name: "America/Sitka",
  iso_country: "US",
  location_code: "SIT",
  description: "Sitka",
  country_name: "United States"
}, {
  id: "407",
  name: "America/Yakutat",
  iso_country: "US",
  location_code: "YAK",
  description: "Yakutat",
  country_name: "United States"
}, {
  id: "408",
  name: "Pacific/Honolulu",
  iso_country: "US",
  location_code: "HNL",
  description: "Honolulu",
  country_name: "United States"
}, {
  id: "409",
  name: "America/Montevideo",
  iso_country: "UY",
  location_code: "MVD",
  description: "Montevideo",
  country_name: "Uruguay"
}, {
  id: "410",
  name: "Asia/Samarkand",
  iso_country: "UZ",
  location_code: "SKD",
  description: "Samarkand",
  country_name: "Uzbekistan"
}, {
  id: "411",
  name: "Asia/Tashkent",
  iso_country: "UZ",
  location_code: "TAS",
  description: "Tashkent",
  country_name: "Uzbekistan"
}, {
  id: "412",
  name: "Europe/Vatican",
  iso_country: "VA",
  location_code: "VAT",
  description: "Vatican",
  country_name: "Holy See (Vatican City State)"
}, {
  id: "413",
  name: "America/St_Vincent",
  iso_country: "VC",
  location_code: "VC",
  description: "St Vincent",
  country_name: "Saint Vincent and the Grenadines"
}, {
  id: "414",
  name: "America/Caracas",
  iso_country: "VE",
  location_code: "CCS",
  description: "Caracas",
  country_name: "Venezuela, Bolivarian Republic of"
}, {
  id: "415",
  name: "America/Tortola",
  iso_country: "VG",
  location_code: "TOV",
  description: "Tortola",
  country_name: "Virgin Islands, British"
}, {
  id: "416",
  name: "America/St_Thomas",
  iso_country: "VI",
  location_code: "STT",
  description: "St Thomas",
  country_name: "Virgin Islands, U.S."
}, {
  id: "417",
  name: "Asia/Ho_Chi_Minh",
  iso_country: "VN",
  location_code: "SGN",
  description: "Ho Chi Minh",
  country_name: "Viet Nam"
}, {
  id: "418",
  name: "Pacific/Efate",
  iso_country: "VU",
  location_code: "EFT",
  description: "Efate",
  country_name: "Vanuatu"
}, {
  id: "419",
  name: "Pacific/Wallis",
  iso_country: "WF",
  location_code: "WLS",
  description: "Wallis",
  country_name: "Wallis and Futuna"
}, {
  id: "420",
  name: "Pacific/Apia",
  iso_country: "WS",
  location_code: "APW",
  description: "Apia",
  country_name: "Samoa"
}, {
  id: "421",
  name: "Asia/Aden",
  iso_country: "YE",
  location_code: "ADE",
  description: "Aden",
  country_name: "Yemen"
}, {
  id: "422",
  name: "Indian/Mayotte",
  iso_country: "YT",
  location_code: "MAY",
  description: "Mayotte",
  country_name: "Mayotte"
}, {
  id: "423",
  name: "Africa/Johannesburg",
  iso_country: "ZA",
  location_code: "JNB",
  description: "Johannesburg",
  country_name: "South Africa"
}, {
  id: "424",
  name: "Africa/Lusaka",
  iso_country: "ZM",
  location_code: "LUN",
  description: "Lusaka",
  country_name: "Zambia"
}, {
  id: "425",
  name: "Africa/Harare",
  iso_country: "ZW",
  location_code: "HRE",
  description: "Harare",
  country_name: "Zimbabwe"
}];

const {
  VUE_APP_NAME
} = process.env;
var script$3 = {
  name: "TimezoneLocation",
  components: {
    SearchableSelect: __vue_component__$Q,
    ViewModeItem: __vue_component__$x
  },
  mixins: [itemTypesMixin, jsonMixin],

  data() {
    return {
      id: this.globalUniqueId(),
      value: VUE_APP_NAME === "empire" ? "LON" : null
    };
  },

  computed: {
    orderedTimezoneLocations() {
      return _orderBy(timezoneLocations, ["iso_country", "location_code"], ["asc", "asc"]);
    },

    viewModeValue() {
      var _this$orderedTimezone, _this$orderedTimezone2;

      return ((_this$orderedTimezone = this.orderedTimezoneLocations) === null || _this$orderedTimezone === void 0 ? void 0 : (_this$orderedTimezone2 = _findInstanceProperty(_this$orderedTimezone).call(_this$orderedTimezone, l => l.location_code === this.value)) === null || _this$orderedTimezone2 === void 0 ? void 0 : _this$orderedTimezone2.name) || this.value;
    }

  },
  watch: {
    jsonProp: {
      deep: true,

      handler(newVal) {
        if (typeof newVal.body !== "string" || newVal.body === "") return;
        this.value = newVal.body;
      },

      immediate: true
    },
    value: {
      handler(newVal) {
        const formattedVal = this.formatValueReadyToEmitIfInArray(newVal);
        this.$emit("json-changed", formattedVal);
      },

      immediate: true
    }
  },
  methods: {
    optionLabel(option) {
      if (!option) return;
      const countryNameAndDescriptionMatch = option.country_name === option.description;
      return countryNameAndDescriptionMatch ? option.description : `(${option.country_name}) ${option.description}`;
    }

  }
};

/* script */
const __vue_script__$3 = script$3;
/* template */

var __vue_render__$3 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v("\n    Select the closest location that shares the same time zone all year round\n  ")]), _vm._v(" "), _vm.viewMode ? _c('ViewModeItem', {
    attrs: {
      "name": _vm.name,
      "value": _vm.viewModeValue
    }
  }) : _c('SearchableSelect', {
    attrs: {
      "id": _vm.id,
      "label": "description",
      "options": _vm.orderedTimezoneLocations,
      "option-output": function (o) {
        return _vm.optionLabel(o);
      },
      "value-key": "location_code",
      "placeholder": "Select timezone location"
    },
    model: {
      value: _vm.value,
      callback: function ($$v) {
        _vm.value = $$v;
      },
      expression: "value"
    }
  })], 1);
};

var __vue_staticRenderFns__$3 = [];
/* style */

const __vue_inject_styles__$3 = undefined;
/* scoped */

const __vue_scope_id__$3 = undefined;
/* module identifier */

const __vue_module_identifier__$3 = undefined;
/* functional template */

const __vue_is_functional_template__$3 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3,
  staticRenderFns: __vue_staticRenderFns__$3
}, __vue_inject_styles__$3, __vue_script__$3, __vue_scope_id__$3, __vue_is_functional_template__$3, __vue_module_identifier__$3, false, undefined, undefined, undefined);

var script$2 = {
  name: "ItemType",
  components: {
    TypeArray: __vue_component__$g,
    TypeCountry: __vue_component__$f,
    TypeDropdown: __vue_component__$e,
    TypeHours: __vue_component__$9,
    TypeLink: __vue_component__$8,
    TypeMap: __vue_component__$7,
    TypeNumber: __vue_component__$5,
    TypeString: __vue_component__$6,
    TypeTextarea: __vue_component__$4,
    TypeTimezone: __vue_component__$3
  },
  mixins: [jsonMixin],
  props: {
    default_: String,
    fieldProps: Object,
    flattenItem: Boolean,
    isInArray: Boolean,
    item: Object,
    itemParent: Object,
    loopKey: Number
  },

  data() {
    return {
      isEmptyObject
    };
  },

  computed: {
    itemKey() {
      // required for JSON mixin
      return classKey(this.item);
    },

    // when this updates, the Item child component (e.g. String) will be
    // recreated afresh, removing any old lingering data (for example, if the
    // parent changed from a Person to a Department, we don't want any old data
    // in the old String to exist, but to create a whole new String component
    // afresh, using :key={vueKey} provides this for us. See:
    // https://vuejs.org/v2/api/#key
    vueKey() {
      // combining the parentKey and key from the item creates a unique
      // combination that will change if we change anything upstream (e.g.
      // switching our Options dropdown
      return `${this.jsonProp.parentKey}-${_Object$keys(this.item)[0]}`;
    }

  },
  methods: {
    jsonChanged(jsonBody) {
      this.$emit("json-changed", jsonBody, this.loopKey);
    },

    setJsonToPass() {
      var _this$jsonPropKeys;

      if (this.isInArray && this.jsonProp.body) {
        this.$set(this.jsonToPass, "body", this.jsonProp.body);
      } else if ((_this$jsonPropKeys = this.jsonPropKeys) !== null && _this$jsonPropKeys !== void 0 && _includesInstanceProperty(_this$jsonPropKeys).call(_this$jsonPropKeys, this.itemKey)) {
        const jsonPropBody = this.getJsonByKey(this.itemKey); // the slice method here is needed so that a new Array is created.
        // without this the child component which receives the `jsonToPass`
        // won't know anything has changed, and as such won't fire off the
        // watcher for its `jsonProp` handler, so will never update it's
        // values.

        const bodyToPass = Array.isArray(jsonPropBody) ? _sliceInstanceProperty(jsonPropBody).call(jsonPropBody) : jsonPropBody;
        this.$set(this.jsonToPass, "body", bodyToPass);
      } else if (!this.typeToShow("arr", this.item) && this.itemKey === this.jsonProp.parentKey) {
        this.$set(this.jsonToPass, "body", this.jsonProp.body);
      } else if (isEmptyObject(this.jsonProp.body) || this.jsonProp.body === null) {
        this.$set(this.jsonToPass, "body", null);
      }

      this.$set(this.jsonToPass, "parentKey", this.itemKey);
    },

    typeToShow(type, object) {
      var _values$options, _context;

      const values = classValues(object);
      if (!values) return;

      if ((_values$options = values.options) !== null && _values$options !== void 0 && _values$options.length) {
        return type === "dropdown";
      } else if (_startsWithInstanceProperty(_context = this.itemKey).call(_context, "@")) {
        return this.itemKey === type;
      } else if (this.isInArray) {
        // if we have a custom component specified, use that, else use the
        // first class field
        if (values.component) {
          return values.component === type;
        } else {
          const classFields = values.fields;

          const firstClassField = classFields && _Object$keys(classFields)[0];

          return firstClassField === type;
        }
      } else if (values.superclass === "arr" && values.component !== "textarea") {
        return values.superclass === type;
      } else if (values.component) {
        return values.component === type;
      } else if (values.superclass) {
        return values.superclass === type;
      }
    }

  }
};

/* script */
const __vue_script__$2 = script$2;
/* template */

var __vue_render__$2 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.typeToShow('textarea', _vm.item) ? _c('TypeTextarea', {
    key: _vm.vueKey,
    attrs: {
      "default_": _vm.default_,
      "item": _vm.item,
      "item-parent": _vm.itemParent,
      "view-mode": _vm.viewMode,
      "field-props": _vm.fieldProps,
      "json-prop": _vm.jsonToPass
    },
    on: {
      "json-changed": _vm.jsonChanged
    }
  }) : _vm.typeToShow('arr', _vm.item) ? _c('TypeArray', {
    key: _vm.vueKey,
    attrs: {
      "default_": _vm.default_,
      "item": _vm.item,
      "item-parent": _vm.itemParent,
      "view-mode": _vm.viewMode,
      "field-props": _vm.fieldProps,
      "json-prop": _vm.jsonToPass
    },
    on: {
      "json-changed": _vm.jsonChanged
    }
  }) : _vm.typeToShow('num', _vm.item) ? _c('TypeNumber', {
    key: _vm.vueKey,
    attrs: {
      "default_": _vm.default_,
      "item": _vm.item,
      "item-parent": _vm.itemParent,
      "view-mode": _vm.viewMode,
      "field-props": _vm.fieldProps,
      "is-in-array": _vm.isInArray,
      "json-prop": _vm.jsonToPass
    },
    on: {
      "json-changed": _vm.jsonChanged
    }
  }) : _vm.typeToShow('str', _vm.item) ? _c('TypeString', {
    key: _vm.vueKey,
    class: {
      'module-editor-group--slim': _vm.isInArray
    },
    attrs: {
      "default_": _vm.default_,
      "item": _vm.item,
      "item-parent": _vm.itemParent,
      "view-mode": _vm.viewMode,
      "field-props": _vm.fieldProps,
      "is-in-array": _vm.isInArray,
      "json-prop": _vm.jsonToPass
    },
    on: {
      "json-changed": _vm.jsonChanged
    }
  }) : _vm.typeToShow('dropdown', _vm.item) ? _c('TypeDropdown', {
    key: _vm.vueKey,
    class: {
      'module-editor-group--slim': _vm.isInArray
    },
    attrs: {
      "default_": _vm.default_,
      "item": _vm.item,
      "item-parent": _vm.itemParent,
      "view-mode": _vm.viewMode,
      "field-props": _vm.fieldProps,
      "is-in-array": _vm.isInArray,
      "json-prop": _vm.jsonToPass,
      "use-label-for-errors": false
    },
    on: {
      "json-changed": _vm.jsonChanged
    }
  }) : _vm.typeToShow('@L', _vm.item) ? _c('TypeLink', {
    key: _vm.vueKey,
    attrs: {
      "default_": _vm.default_,
      "item": _vm.item,
      "item-parent": _vm.itemParent,
      "view-mode": _vm.viewMode,
      "field-props": _vm.fieldProps,
      "is-in-array": _vm.isInArray,
      "json-prop": _vm.jsonToPass
    },
    on: {
      "json-changed": _vm.jsonChanged
    }
  }) : _vm.typeToShow('country', _vm.item) ? _c('TypeCountry', {
    key: _vm.vueKey,
    attrs: {
      "default_": _vm.default_,
      "item": _vm.item,
      "item-parent": _vm.itemParent,
      "view-mode": _vm.viewMode,
      "field-props": _vm.fieldProps,
      "is-in-array": _vm.isInArray,
      "json-prop": _vm.jsonToPass
    },
    on: {
      "json-changed": _vm.jsonChanged
    }
  }) : _vm.typeToShow('hours', _vm.item) ? _c('TypeHours', {
    key: _vm.vueKey,
    attrs: {
      "default_": _vm.default_,
      "item": _vm.item,
      "item-parent": _vm.itemParent,
      "view-mode": _vm.viewMode,
      "field-props": _vm.fieldProps,
      "is-in-array": _vm.isInArray,
      "json-prop": _vm.jsonToPass
    },
    on: {
      "json-changed": _vm.jsonChanged
    }
  }) : _vm.typeToShow('timezone', _vm.item) ? _c('TypeTimezone', {
    key: _vm.vueKey,
    attrs: {
      "default_": _vm.default_,
      "item": _vm.item,
      "item-parent": _vm.itemParent,
      "view-mode": _vm.viewMode,
      "field-props": _vm.fieldProps,
      "is-in-array": _vm.isInArray,
      "json-prop": _vm.jsonToPass
    },
    on: {
      "json-changed": _vm.jsonChanged
    }
  }) : _c('TypeMap', {
    key: _vm.vueKey,
    attrs: {
      "default_": _vm.default_,
      "item": _vm.item,
      "item-parent": _vm.itemParent,
      "view-mode": _vm.viewMode,
      "field-props": _vm.fieldProps,
      "flatten-item": _vm.flattenItem,
      "is-in-array": _vm.isInArray,
      "json-prop": _vm.jsonToPass
    },
    on: {
      "json-changed": _vm.jsonChanged
    }
  });
};

var __vue_staticRenderFns__$2 = [];
/* style */

const __vue_inject_styles__$2 = undefined;
/* scoped */

const __vue_scope_id__$2 = undefined;
/* module identifier */

const __vue_module_identifier__$2 = undefined;
/* functional template */

const __vue_is_functional_template__$2 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2,
  staticRenderFns: __vue_staticRenderFns__$2
}, __vue_inject_styles__$2, __vue_script__$2, __vue_scope_id__$2, __vue_is_functional_template__$2, __vue_module_identifier__$2, false, undefined, undefined, undefined);

var script$1 = {
  name: "Options",
  components: {
    ConfigClass: __vue_component__$j,
    FormError: __vue_component__$X,
    SearchableSelect: __vue_component__$Q
  },
  mixins: [jsonMixin],
  props: {
    fieldProps: Object,
    item: Object,
    name: String,
    optionTypeKey: String,
    options: Array,
    parentIsRoot: Boolean
  },

  data() {
    return {
      id: this.globalUniqueId(),
      itemKey: null
    };
  },

  computed: { ...mapGetters("base", ["getModuleClassByKey", "isSuperclass"]),

    formattedOptions() {
      var _context;

      return _mapInstanceProperty(_context = this.options).call(_context, o => {
        return { ...classValues(o),
          __key: classKey(o)
        };
      });
    },

    label() {
      return classValues(this.optionType).label;
    },

    option() {
      var _this$options;

      return (_this$options = this.options) === null || _this$options === void 0 ? void 0 : _findInstanceProperty(_this$options).call(_this$options, option => {
        var _context2;

        return _includesInstanceProperty(_context2 = _Object$keys(option)).call(_context2, this.itemKey);
      });
    },

    optionKeys() {
      var _this$options2;

      return (_this$options2 = this.options) === null || _this$options2 === void 0 ? void 0 : _mapInstanceProperty(_this$options2).call(_this$options2, o => _Object$keys(o)[0]);
    },

    optionType() {
      return this.getModuleClassByKey(this.optionTypeKey);
    },

    optionTypeName() {
      const values = classValues(this.optionType);
      return values.object_display_name || values.name;
    },

    placeholder() {
      return classValues(this.optionType).placeholder;
    }

  },
  watch: {
    itemKey(newVal, oldVal) {
      // if the itemKey has been wiped...
      if (newVal === null && !this.parentIsRoot) {
        // if this is a superclass, then we want to preserve this item,
        // otherwise we get complications with our Array, which loses track of
        // which item to update when the JSON flows back down
        if (this.isSuperclass(oldVal)) {
          this.$emit("json-changed", {}, oldVal);
        } else {
          this.$emit("json-changed", null, oldVal);
        } // else if we have an old value, we need to wipe it's child values now
        // that we've changed to a new Option value. The check here is
        // important as we don't want to emit a clearance event when
        // initialising from populated JSON from an existing NUM record

      } else if (oldVal !== null) {
        this.$emit("json-changed", {}, oldVal);
      }
    }

  },
  methods: {
    // getClassKeyToSet gets the correct key to set from the JSON prop body, as
    // the JSON prop body will not include superclasses, so if we need to
    // select a superclass, we have to go and find the value for this first.
    // this function is made to recurr, so it can go ~infinitely up the tree of
    // superclasses to find the right value to set.
    getClassKeyToSet(ck) {
      var _context3;

      if (_includesInstanceProperty(_context3 = this.optionKeys).call(_context3, ck)) {
        return ck;
      } else {
        const moduleClass = this.getModuleClassByKey(ck);

        if (moduleClass) {
          var _context4;

          const moduleClassValues = classValues(moduleClass);
          const jsonPropSuperclassKey = moduleClassValues.superclass; // if the populated JSON's superclass matches our options, then
          // set that (this is because superclasses aren't explicitly listed
          // in the JSON, so have to be inferred from the superclass as a
          // separate check)

          if (_includesInstanceProperty(_context4 = this.optionKeys).call(_context4, jsonPropSuperclassKey)) {
            return jsonPropSuperclassKey;
          } else if (jsonPropSuperclassKey) {
            // if it didn't match, but we have a superclass, call this method
            // again with the superclass to check if the superclass matches an
            // one of our `optionKeys`, and this will call itself recurringly
            // whilst there are superclasses to check, all the way back up the
            // superclass tree
            return this.getClassKeyToSet(jsonPropSuperclassKey);
          }
        }
      }
    },

    jsonChanged(jsonBody) {
      let updatedJson;

      if (this.isSuperclass(this.itemKey)) {
        if (jsonBody === null) {
          // if this Options is a superclass, and the child class has been
          // cleared, we don't want to send up `null`, as this will remove the
          // Options item from the root JSON, but instead we just want to clear
          // the data inside this superclass, so we send up a blank object
          updatedJson = {};
        } else {
          updatedJson = jsonBody;
        }
      } else {
        updatedJson = jsonBody;
      }

      this.$emit("json-changed", updatedJson);
    },

    setItemKeyFromJsonProp(jsonPropBody) {
      // this enables editing existing records, by setting the Options key from
      // JSON passed down
      if (!!jsonPropBody && !isEmptyObject(jsonPropBody)) {
        const jsonPropBodyKey = classKey(jsonPropBody);
        const matchingClassKeyToSet = this.getClassKeyToSet(jsonPropBodyKey);
        if (matchingClassKeyToSet) this.itemKey = matchingClassKeyToSet;
      }
    },

    setJsonToPass() {
      this.setItemKeyFromJsonProp(this.jsonProp.body);
      this.$set(this.jsonToPass, "body", this.jsonProp.body);
      this.$set(this.jsonToPass, "parentKey", this.itemKey);
    }

  }
};

/* script */
const __vue_script__$1 = script$1;
/* template */

var __vue_render__$1 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('ValidationProvider', {
    staticClass: "mb-4 last:mb-0",
    attrs: {
      "rules": {
        required: !!_vm.fieldProps.required
      },
      "name": _vm.optionTypeKey,
      "vid": _vm.globalUniqueId(_vm.optionTypeKey),
      "tag": "div"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (ref) {
        var errors = ref.errors;
        return [_vm.label && !_vm.viewMode ? _c('label', [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), !_vm.viewMode ? _c('SearchableSelect', {
          attrs: {
            "id": _vm.id,
            "options": _vm.formattedOptions,
            "option-output": function (o) {
              return o && o.object_display_name;
            },
            "placeholder": _vm.placeholder || "Select " + _vm.optionTypeName,
            "value-key": "__key"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (ref) {
              var option = ref.option;
              return [_c('div', {
                staticClass: "option"
              }, [option.icon && option.icon.length > 1 ? _c('img', {
                staticClass: "option__icon",
                attrs: {
                  "alt": "Option icon",
                  "src": option.icon[0] + ":" + option.icon[1]
                }
              }) : _vm._e(), _vm._v("\n        " + _vm._s(option.object_display_name || option.name) + "\n      ")])];
            }
          }], null, true),
          model: {
            value: _vm.itemKey,
            callback: function ($$v) {
              _vm.itemKey = $$v;
            },
            expression: "itemKey"
          }
        }) : _vm._e(), _vm._v(" "), _vm.option ? _c('ConfigClass', {
          attrs: {
            "item": _vm.option,
            "item-parent": _vm.item,
            "view-mode": _vm.viewMode,
            "json-prop": _vm.jsonToPass
          },
          on: {
            "json-changed": _vm.jsonChanged
          }
        }) : _vm._e(), _vm._v(" "), _c('FormError', {
          attrs: {
            "errors": errors
          }
        })];
      }
    }])
  });
};

var __vue_staticRenderFns__$1 = [];
/* style */

const __vue_inject_styles__$1 = undefined;
/* scoped */

const __vue_scope_id__$1 = "data-v-137f4a42";
/* module identifier */

const __vue_module_identifier__$1 = undefined;
/* functional template */

const __vue_is_functional_template__$1 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, false, undefined, undefined, undefined);

const PUSH_FLASH_MESSAGE = "PUSH_FLASH_MESSAGE";
const SET_MODULE_CONFIG = "SET_MODULE_CONFIG";
const SET_MODULE_ID = "SET_MODULE_ID";
var script = {
  name: "RecordEditor",
  components: {
    Card: __vue_component__$Y,
    ConfigClass: __vue_component__$j,
    SkeletonLine: __vue_component__$v
  },
  props: {
    convertJsonToModl: Boolean,
    disableCache: Boolean,
    emptyRecordMessage: String,
    getModuleUrl: {
      required: true,
      type: Function
    },
    jsonToModl: {
      required: true,
      type: Function
    },
    modlToJson: {
      required: true,
      type: Function
    },
    modlProp: String,
    moduleId: Number,
    open: Boolean,
    rcfWithEcf: Object,
    viewMode: Boolean
  },

  data() {
    return {
      json: {
        body: null,
        parentKey: null
      },
      modl: null,
      modlLoading: false,
      rootItem: null
    };
  },

  computed: { ...mapGetters("base", ["getModuleClassByKey", "moduleConfig"]),

    jsonBodyWithoutMetaData() {
      var _context;

      return this.json.body && _filterInstanceProperty(_context = _Object$keys(this.json.body)).call(_context, key => !_startsWithInstanceProperty(key).call(key, "@")).reduce((obj, key) => {
        obj[key] = this.json.body[key];
        return obj;
      }, {});
    },

    jsonBodyWithoutMetaDataIsEmpty() {
      return isEmptyObject(this.jsonBodyWithoutMetaData);
    }

  },
  watch: {
    convertJsonToModl(newVal) {
      this.jsonChanged(null, newVal);
    },

    json: {
      deep: true,

      handler(newVal) {
        this.$emit("json-changed", newVal);
      }

    },

    modl(newVal) {
      this.$emit("modl-changed", newVal);
    },

    modlLoading(newVal) {
      this.$emit("modl-loading-changed", newVal);
    },

    modlProp(newVal) {
      const modlChangedInParent = newVal !== this.modl;

      if (modlChangedInParent) {
        this.handleInitialModl();
      }
    },

    moduleConfig() {
      this.rootItem = this.getModuleClassByKey("root");
      this.handleInitialModl();
    },

    moduleId: {
      immediate: true,

      handler(newVal) {
        newVal && this.SET_MODULE_ID(newVal);
      }

    },
    rcfWithEcf: {
      immediate: true,

      handler(newVal) {
        newVal && this.SET_MODULE_CONFIG({
          moduleConfig: newVal,
          moduleId: this.moduleId
        });
      }

    }
  },
  methods: { ...mapMutations("base", [PUSH_FLASH_MESSAGE, SET_MODULE_CONFIG, SET_MODULE_ID]),

    deepRemoveEmptyObjectsAndArrays(json) {
      let filteredJson = null;

      if (typeof json === "string" || typeof json === "number") {
        if (json !== "") filteredJson = json;
      } else if (Array.isArray(json)) {
        filteredJson = [];
        json.forEach(item => {
          const filteredJsonItem = this.deepRemoveEmptyObjectsAndArrays(item);

          if (filteredJsonItem) {
            filteredJson = [...filteredJson, filteredJsonItem];
          }
        }); // if filteredJson doesn't include any valid entries, don't include it
        // in the MODL

        if (filteredJson.length === 0) filteredJson = null;
      } else if (json) {
        const keys = _Object$keys(json);

        for (const index in keys) {
          const key = keys[index];
          const jsonItem = json[key];
          const filteredJsonItem = this.deepRemoveEmptyObjectsAndArrays(jsonItem); // if there item is null, don't spread it

          if (filteredJsonItem) {
            filteredJson = { ...filteredJson,
              [key]: filteredJsonItem
            };
          }
        }
      }

      return filteredJson;
    },

    formatInitialJson(initialJson) {
      let formattedJson;

      if (typeof initialJson === "string" || typeof initialJson === "number") {
        formattedJson = initialJson;
      } else if (Array.isArray(initialJson)) {
        formattedJson = [];
        initialJson.forEach((item, index) => {
          if (typeof item === "string" || typeof item === "number") {
            formattedJson.push(item);
          } else {
            const key = classKey(item);
            const moduleClass = this.isModuleClass(key); // this if statement removes values returned by the MODL to JSON
            // converter that aren't classes in our config, e.g.
            // `default_description`

            if (moduleClass) {
              formattedJson = [...formattedJson, this.formatInitialJson(_Object$values(initialJson)[index])];
            }
          }
        });
      } else {
        formattedJson = {};

        const nameKeys = _Object$keys(initialJson);

        for (const index in nameKeys) {
          const key = nameKeys[index];
          const moduleClass = this.isModuleClass(key); // if the class key starts with "@", then it's a custom class that
          // should just be passed through as is (and not stripped of anything
          // that's not in the config, because it's not module specific so
          // doesn't live in the config

          if (_startsWithInstanceProperty(key).call(key, "@")) {
            formattedJson = { ...formattedJson,
              [key]: _Object$values(initialJson)[index]
            };
          } // this else if statement removes values returned by the MODL to JSON
          // converter that aren't classes in our config, e.g.
          // `default_description`
          else if (moduleClass) {
              const moduleClassKey = classKey(moduleClass);
              formattedJson = { ...formattedJson,
                [moduleClassKey]: this.formatInitialJson(_Object$values(initialJson)[index])
              };
            }
        }
      }

      return formattedJson;
    },

    async handleInitialModl() {
      if (this.modlProp) {
        const rcfUrl = this.getModuleUrl(this.moduleId, "rcf", true);
        const cacheChar = this.disableCache ? "!" : "";
        const data = `*l="${rcfUrl}${cacheChar}";${this.modlProp}`;
        const response = await this.modlToJson(data, this.open);

        if (responseSuccessful(response)) {
          const formattedResponse = this.formatInitialJson(response.data);
          this.json.body = formattedResponse;
        } else {
          var _response$data;

          this.PUSH_FLASH_MESSAGE({
            message: (response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.message) || "An error occurred, please try again",
            type: "error"
          });
        }
      } else {
        this.modl = null;
        this.json.body = {};
      }
    },

    isModuleClass(key) {
      var _this$moduleConfig, _this$moduleConfig$cl;

      return (_this$moduleConfig = this.moduleConfig) === null || _this$moduleConfig === void 0 ? void 0 : (_this$moduleConfig$cl = _this$moduleConfig.classes) === null || _this$moduleConfig$cl === void 0 ? void 0 : _findInstanceProperty(_this$moduleConfig$cl).call(_this$moduleConfig$cl, c => classValues(c).name === key);
    },

    async jsonChanged(jsonBody, convertJsonToModl = this.convertJsonToModl) {
      let response;
      if (jsonBody) this.json.body = jsonBody;

      if (this.json.body && convertJsonToModl) {
        this.modlLoading = true;
        response = await this.debounceJsonToModl();
      }

      return response;
    },

    debounceJsonToModl: _debounce(async function () {
      let response;

      if (isEmptyObject(this.json.body)) {
        this.modl = null;
      } else {
        const filteredJsonBody = this.deepRemoveEmptyObjectsAndArrays(this.json.body);

        if (filteredJsonBody) {
          response = await this.jsonToModl(filteredJsonBody, this.open);
          const modlResponse = response.data.modl;
          this.modl = setModlVersion(modlResponse);
        } else {
          this.modl = null;
        }
      }

      this.modlLoading = false;
      return response;
    }, 1000, {
      leading: true
    })
  }
};

/* script */
const __vue_script__ = script;
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.moduleConfig && _vm.rootItem && _vm.json.body ? _c('div', [_vm.viewMode && _vm.jsonBodyWithoutMetaDataIsEmpty ? _c('Card', {
    attrs: {
      "variant": "dark"
    }
  }, [_c('em', [_vm._v(_vm._s(_vm.emptyRecordMessage || "Record is empty"))])]) : _c('ConfigClass', {
    attrs: {
      "item": _vm.rootItem,
      "json-prop": _vm.json,
      "view-mode": _vm.viewMode
    },
    on: {
      "json-changed": _vm.jsonChanged
    }
  })], 1) : _c('Card', [_vm.moduleId ? _c('SkeletonLine') : _c('em', {
    staticClass: "opacity-50"
  }, [_vm._v("Select a module to get started")])], 1);
};

var __vue_staticRenderFns__ = [];
/* style */

const __vue_inject_styles__ = undefined;
/* scoped */

const __vue_scope_id__ = undefined;
/* module identifier */

const __vue_module_identifier__ = undefined;
/* functional template */

const __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

function configureValidation() {
  setInteractionMode("eager");
  extend("array", {
    computesRequired: true,
    message: "{_field_} must contain at least one valid entry",
    validate: value => value === null || value === void 0 ? void 0 : value.some(v => !(v === "" || isEmptyObject(v)))
  });
  extend("confirmed", { ...confirmed,
    message: "Passwords don't match"
  });
  extend("domain", {
    message: "Please enter a valid domain name",
    validate: domain => /^(([^.\s\f\t\r\b\\]+\.)*([^!"#$%&'()*+,./:;<=>?@[\\\]^_`{|}~\s\f\t\r\b\\]+\.)([^!"#$%&'()*+,./:;<=>?@[\\\]^_`{|}~\s\f\t\r\b\\]+))\.?$/.test(domain)
  });
  extend("email", { ...email,
    message: "Please enter a valid email address",
    validate: inputEmail => /^(?!\s)[^@\f\t\r\b\s\\]+@(([^.\s\f\t\r\b\\]+\.)*([^!"#$%&'()*+,./:;<=>?@[\\\]^_`{|}~\s\f\t\r\b\\]+\.)([^!"#$%&'()*+,./:;<=>?@[\\\]^_`{|}~\s\f\t\r\b\\]+))\.?$/.test(inputEmail)
  });
  extend("json", {
    message: "Please enter valid JSON",
    validate: json => isJsonString(json)
  });
  extend("numVersionJson", {
    message: "NUM records must include the NUM version, using the `@n` key",
    validate: json => {
      try {
        return !!JSON.parse(json)["@n"];
      } catch (e) {// console.log("error, parsing JSON failed", e);
      }
    }
  });
  extend("numVersionModl", {
    message: "NUM records must begin with the NUM version, using the `@n` key",
    validate: modl => modl.match(/^(@n=)[0-9]+/)
  });
  extend("verificationCode", {
    message: "Verification code must be 6 digits long",
    validate: code => code.length === 6
  });
  extend("notInFuture", {
    message: "{_field_} must not be in the future",
    validate: date => moment(date).isSameOrBefore(new Date(), "day")
  });
  extend("notInPast", {
    message: "{_field_} must not be in the past",
    validate: date => moment(date).isSameOrAfter(new Date(), "day")
  });
  const passwordRegex = RegExp("((?=\\S+$)(?=.*[a-z])(?=.*\\d)(?=.*[A-Z])(?=.*[£%^&*\\(\\)\\[\\]\\{\\}~`,.:;\"'@#$%!]).{10,80})");
  extend("password", {
    message: "Passwords must be between 10 to 80 characters, contain at least 1 number, uppercase character, lowercase character, special character and no whitespace",
    validate: password => passwordRegex.test(password)
  });
  extend("phoneNumber", {
    message: "This field must be a valid phone number",
    params: [{
      isTarget: true,
      name: "countryCode"
    }],
    validate: (phoneMain, {
      countryCode
    }) => {
      var _parsePhoneNumberFrom;

      return countryCode && phoneMain ? (_parsePhoneNumberFrom = parsePhoneNumberFromString(`${countryCode}${phoneMain}`)) === null || _parsePhoneNumberFrom === void 0 ? void 0 : _parsePhoneNumberFrom.isValid() : false;
    }
  });
  extend("required", { ...required,
    message: "{_field_} is required"
  });
  extend("recordPath", {
    message: "Whitespace, periods, backslashes, multiple chained and forward slashes are disallowed in the record path",
    validate: path => /^(\/[^;,/\\?:@&=+$.\s]+)*\/?$/.test(path)
  });
  const taxIdRegex = RegExp("^(" + "(AT)?U[0-9]{8}|" + // Austria
  "(BE)?0[0-9]{9}|" + // Belgium
  "(BG)?[0-9]{9,10}|" + // Bulgaria
  "(CY)?[0-9]{8}L|" + // Cyprus
  "(CZ)?[0-9]{8,10}|" + // Czech Republic
  "(DE)?[0-9]{9}|" + // Germany
  "(DK)?[0-9]{8}|" + // Denmark
  "(EE)?[0-9]{9}|" + // Estonia
  "(EL|GR)?[0-9]{9}|" + // Greece
  "(ES)?[0-9A-Z][0-9]{7}[0-9A-Z]|" + // Spain
  "(FI)?[0-9]{8}|" + // Finland
  "(FR)?[0-9A-Z]{2}[0-9]{9}|" + // France
  "(GB)((?:[0-9]{12}|[0-9]{9}|(?:GD|HA)[0-9]{3})$)/i|" + // United Kingdom
  "(HU)?[0-9]{8}|" + // Hungary
  "(IE)([0-9A-Z\\*\\+]{7}[A-Z]{1,2}$)/i|" + // Ireland
  "(IT)?[0-9]{11}|" + // Italy
  "(LT)?([0-9]{9}|[0-9]{12})|" + // Lithuania
  "(LU)?[0-9]{8}|" + // Luxembourg
  "(LV)?[0-9]{11}|" + // Latvia
  "(MT)?[0-9]{8}|" + // Malta
  "(NL)?[0-9]{9}B[0-9]{2}|" + // Netherlands
  "(PL)?[0-9]{10}|" + // Poland
  "(PT)?[0-9]{9}|" + // Portugal
  "(RO)?[0-9]{2,10}|" + // Romania
  "(SE)?[0-9]{12}|" + // Sweden
  "(SI)?[0-9]{8}|" + // Slovenia
  "(SK)?[0-9]{10}" + // Slovakia
  ")$");
  extend("taxId", {
    message: "Please enter a valid EU or UK tax ID, without spaces",
    validate: taxId => taxIdRegex.test(taxId)
  });
  const usernameRegex = RegExp("[\\w_-]{6,50}");
  extend("username", {
    message: "Usernames must be between 6 to 50 characters, and can only include letters, numbers, hyphens and underscores",
    validate: username => usernameRegex.test(username)
  });
}

var configureValidation$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': configureValidation
});

const formatDate = date => {
  return date ? moment(date).format("Do MMMM YYYY") : null;
};
const formatDateTime = date => {
  return date ? moment(date).format("Do MMMM YYYY, h:mma") : null;
};
const dateIsInPast = date => {
  return moment.utc(date).isSameOrBefore(new Date());
};

var dateTime = /*#__PURE__*/Object.freeze({
  __proto__: null,
  formatDate: formatDate,
  formatDateTime: formatDateTime,
  dateIsInPast: dateIsInPast
});

const elIsInViewport = (el, onIsInViewport) => {
  const rect = el.getBoundingClientRect();
  const isInViewport = rect.top <= (window.innerHeight || document.documentElement.clientHeight) && rect.left <= (window.innerWidth || document.documentElement.clientWidth);
  if (isInViewport) onIsInViewport();
  return isInViewport; // stop the scroll from continuing to check
};

var elIsInViewport$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': elIsInViewport
});

const CLEAR_PROMISE = "CLEAR_PROMISE";
const PUSH_FLASH_MESSAGE_FROM_RESPONSE = "PUSH_FLASH_MESSAGE_FROM_RESPONSE";
const SET_PROMISE = "SET_PROMISE";
var getAction = (async ({
  beforeAction,
  context,
  flashMessageId,
  instance,
  onSuccess,
  path,
  silent,
  successMessage
}) => {
  const {
    commit,
    rootState
  } = context;
  const existingPromise = rootState._promises[path];
  if (existingPromise) return existingPromise;
  beforeAction === null || beforeAction === void 0 ? void 0 : beforeAction(); // this is the amount of time we keep the promise for after returning, to
  // stop endpoints being re-queried if it was queried milliseconds before.
  // this stops the case of a resource being requested, returning very fast,
  // before it is re-requested and then querying again.

  const timeBeforeAllowingReRequest = 1000;

  const clearPromise = () => {
    setTimeout(() => commit(CLEAR_PROMISE, path, {
      root: true
    }), timeBeforeAllowingReRequest);
  };

  const handleAnyResponse = response => {
    clearPromise();

    if (!silent) {
      commit(`base/${PUSH_FLASH_MESSAGE_FROM_RESPONSE}`, {
        id: flashMessageId,
        response,
        success: successMessage
      }, {
        root: true
      });
    }
  };

  const promise = instance.get(path).then(response => {
    onSuccess(response);
    handleAnyResponse(response);
    return response;
  }).catch(function (error) {
    handleAnyResponse(error.response);
    console.error(error);
    return error.response;
  });
  commit(SET_PROMISE, {
    key: path,
    promise
  }, {
    root: true
  });
  return promise;
});

var getAction$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': getAction
});

const clickOutside = {
  bind: (el, binding, vnode) => {
    el.clickOutsideEvent = event => {
      // here I check that click was outside the el and his children
      if (!(el == event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };

    document.body.addEventListener("click", el.clickOutsideEvent);
  },
  unbind: el => {
    document.body.removeEventListener("click", el.clickOutsideEvent);
  }
};

const scroll = {
  inserted: function (el, binding) {
    const f = function (evt) {
      if (binding.value(evt, el)) {
        window.removeEventListener("scroll", f);
      }
    };

    window.addEventListener("scroll", f);
  }
};

/* eslint-disable import/prefer-default-export */

var components = /*#__PURE__*/Object.freeze({
  __proto__: null,
  utilsConfigureValidation: configureValidation$1,
  utilsDateTime: dateTime,
  utilsElIsInViewport: elIsInViewport$1,
  utilsGetAction: getAction$1,
  utilsNum: num,
  utilsRecordEditorConfig: config,
  utilsResponse: response,
  utilsTypeOf: typeOf,
  Button: __vue_component__$_,
  Card: __vue_component__$Y,
  Checkbox: __vue_component__$W,
  CompanyApiErrors: __vue_component__$U,
  Container: __vue_component__$T,
  Country: __vue_component__$P,
  DomainClaimForm: __vue_component__$L,
  FlashMessage: __vue_component__$I,
  Form: __vue_component__$O,
  FormError: __vue_component__$X,
  GlobalFooter: __vue_component__$H,
  GlobalNav: __vue_component__$F,
  GlobalNavSpacer: __vue_component__$E,
  Hamburger: __vue_component__$G,
  HeaderWrapper: __vue_component__$D,
  Hero: __vue_component__$C,
  Input: __vue_component__$M,
  JsonModl: __vue_component__$y,
  JsonModlViewer: __vue_component__$u,
  JsonPreview: __vue_component__$w,
  Modal: __vue_component__$t,
  Pagination: __vue_component__$s,
  RadioBlockItem: __vue_component__$q,
  RadioBlocks: __vue_component__$p,
  RecordPath: __vue_component__$o,
  RecordModl: __vue_component__$n,
  RemoveButton: __vue_component__$R,
  SearchableSelect: __vue_component__$Q,
  Select: __vue_component__$m,
  SeparatedList: __vue_component__$Z,
  SideNav: __vue_component__$l,
  SkeletonLine: __vue_component__$v,
  Spacer: __vue_component__$r,
  Table: __vue_component__$k,
  Tabs: __vue_component__$z,
  Textarea: __vue_component__$B,
  ToggleArrow: __vue_component__$V,
  GlobalRecordEditorConfigClass: __vue_component__$j,
  GlobalRecordEditorItemType: __vue_component__$2,
  GlobalRecordEditorOptions: __vue_component__$1,
  GlobalRecordEditorViewModeItem: __vue_component__$x,
  RecordEditor: __vue_component__,
  directivesClickOutside: clickOutside,
  directivesScroll: scroll
});

const install = function installTestVueSfcRollup(Vue) {
  _Object$entries(components).forEach(([componentName, component]) => {
    Vue.component(componentName, component);
  });
}; // Create module definition for Vue.use()

export default install;
export { __vue_component__$_ as Button, __vue_component__$Y as Card, __vue_component__$W as Checkbox, __vue_component__$U as CompanyApiErrors, __vue_component__$T as Container, __vue_component__$P as Country, __vue_component__$L as DomainClaimForm, __vue_component__$I as FlashMessage, __vue_component__$O as Form, __vue_component__$X as FormError, __vue_component__$H as GlobalFooter, __vue_component__$F as GlobalNav, __vue_component__$E as GlobalNavSpacer, __vue_component__$j as GlobalRecordEditorConfigClass, __vue_component__$2 as GlobalRecordEditorItemType, __vue_component__$1 as GlobalRecordEditorOptions, __vue_component__$x as GlobalRecordEditorViewModeItem, __vue_component__$G as Hamburger, __vue_component__$D as HeaderWrapper, __vue_component__$C as Hero, __vue_component__$M as Input, __vue_component__$y as JsonModl, __vue_component__$u as JsonModlViewer, __vue_component__$w as JsonPreview, __vue_component__$t as Modal, __vue_component__$s as Pagination, __vue_component__$q as RadioBlockItem, __vue_component__$p as RadioBlocks, __vue_component__ as RecordEditor, __vue_component__$n as RecordModl, __vue_component__$o as RecordPath, __vue_component__$R as RemoveButton, __vue_component__$Q as SearchableSelect, __vue_component__$m as Select, __vue_component__$Z as SeparatedList, __vue_component__$l as SideNav, __vue_component__$v as SkeletonLine, __vue_component__$r as Spacer, __vue_component__$k as Table, __vue_component__$z as Tabs, __vue_component__$B as Textarea, __vue_component__$V as ToggleArrow, clickOutside as directivesClickOutside, scroll as directivesScroll, configureValidation$1 as utilsConfigureValidation, dateTime as utilsDateTime, elIsInViewport$1 as utilsElIsInViewport, getAction$1 as utilsGetAction, num as utilsNum, config as utilsRecordEditorConfig, response as utilsResponse, typeOf as utilsTypeOf };
